webpackJsonp([1],{

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4IFh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7sQc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GY5a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HAkv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HGqI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lc9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NwXJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OyIo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qbfk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SMvC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SqcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tg1b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VQyD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqS7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bH6m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c4RS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lJKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/i18n/pt-BR/Views.js

/* harmony default export */ var Views = ({
  breadcrumbs: {
    'user-list': 'Administração - Usuário',
    'user-form': 'Administração - Usuário',
    'client-list': 'Administração - Cliente',
    'client-form': 'Administração - Cliente',
    'cycle-list': 'Administração - Ciclo',
    'cycle-form': 'Administração - Ciclo',
    profile: 'Perfil',
    dashboard: 'Dashboard',
    audit: 'Administração - Auditoria',
    mail: 'Administração - Envio de e-mail',
    'project-list': 'Administração - Projetos',
    'project-form': 'Administração - Projetos',
    'dinamic-query': 'Administração - Consultas Dinâmicas',
    'not-authorized': 'Acesso Negado',
    'called-list': 'Lista de Chamados',
    'called-form': 'Formulário de Chamados',
    'follow-called': 'Acompanhamento de Chamado',
    'event-list': 'Lista de Eventos',
    'event-form': 'Formulário de Eventos',
    'cycle-consolidated': 'Relatório Consolidado de Ciclos',
    'table-manager-list': 'Administração - Gerenciador de Tabelas',
    'table-manager-form': 'Administração - Gerenciador de Tabelas',
    'settings-list': 'Configurações',
    'billing-report-list': 'Administração - Relatório de Faturamento',
    'billing-report-form': 'Administração - Relatório de Faturamento',
    'zoho-report-credential-list': 'Zoho Analytics - Credenciais Zoho Analytics',
    'zoho-report-credential-form': 'Zoho Analytics - Credenciais Zoho Analytics',
    'zoho-report-group-list': 'Zoho Analytics - Grupos de Relatórios',
    'zoho-report-group-form': 'Zoho Analytics - Grupos de Relatórios',
    'zoho-report-view': 'Zoho Analytics - Visualizar Relatório',
    'user-project-list': 'Usuários vinculados a projetos',
    'user-project-form': 'Vincular usuários a projetos',
    'load-conf-list': 'Administração - Configuração de Carga',
    'load-conf-form': 'Administração - Configuração de Carga'
  },
  titles: {
    dashboard: 'Página inicial',
    mailSend: 'Enviar e-mail',
    taskList: 'Lista de Tarefas',
    auditList: 'Lista de Logs',
    register: 'Formulário de Cadastro',
    resetPassword: 'Redefinir Senha',
    update: 'Formulário de Atualização',
    list: 'Listagem',
    attention: 'Atenção',
    userList: 'Lista de Usuários',
    clientList: 'Lista de Clientes'
  },
  actions: {
    send: 'Enviar',
    save: 'Salvar',
    clear: 'Limpar',
    clearAll: 'Limpar Tudo',
    restart: 'Reiniciar',
    filter: 'Filtrar',
    search: 'Pesquisar',
    list: 'Listar',
    edit: 'Editar',
    cancel: 'Cancelar',
    update: 'Atualizar',
    remove: 'Remover',
    getOut: 'Sair',
    add: 'Adicionar',
    in: 'Entrar',
    loadImage: 'Carregar Imagem'
  },
  fields: {
    date: 'Data',
    action: 'Ação',
    actions: 'Ações',
    audit: {
      dateStart: 'Data Inicial',
      dateEnd: 'Data Final',
      resource: 'Recurso',
      allResources: 'Todos Recursos',
      type: {
        created: 'Cadastrado',
        updated: 'Atualizado',
        deleted: 'Removido'
      }
    },
    login: {
      resetPassword: 'Esqueci minha senha',
      confirmPassword: 'Confirmar senha'
    },
    mail: {
      to: 'Para',
      subject: 'Assunto',
      message: 'Mensagem'
    },
    queryDinamic: {
      filters: 'Filtros',
      results: 'Resultados',
      model: 'Model',
      attribute: 'Atributo',
      operator: 'Operador',
      resource: 'Recurso',
      value: 'Valor',
      operators: {
        equals: 'Igual',
        diferent: 'Diferente',
        conteins: 'Contém',
        startWith: 'Inicia com',
        finishWith: 'Finaliza com',
        biggerThan: 'Maior',
        equalsOrBiggerThan: 'Maior ou Igual',
        lessThan: 'Menor',
        equalsOrLessThan: 'Menor ou Igual'
      }
    },
    project: {
      name: 'Nome',
      totalTask: 'Total de Tarefas',
      cost: 'Custo'
    },
    task: {
      done: 'Não Feito / Feito'
    },
    user: {
      perfils: 'Perfis',
      nameOrEmail: 'Nome ou Email'
    },
    cycle: {
      start_date: 'Data de Início',
      end_date: 'Data do Fim',
      client: 'Cliente',
      note: 'Observação',
      name: 'Nome'
    },
    called: {
      description: 'Descrição',
      date: 'Data'
    },
    event: {
      date: 'Data do Evento'
    }
  },
  layout: {
    menu: {
      dashboard: 'Dashboard',
      'project-list': 'Projetos',
      admin: 'Administração',
      examples: 'Exemplos',
      'user-list': 'Usuários',
      'client-list': 'Clientes',
      'cycle-list': 'Ciclos',
      mail: 'Enviar e-mail',
      audit: 'Auditoria',
      dinamicQuery: 'Consultas Dinamicas',
      'called-list': 'Chamados',
      'event-list': 'Eventos',
      reports: 'Relatórios',
      'cycle-consolidated': 'Consolidado de Ciclos',
      'table-manager-list': 'Gerenciador de Tabelas',
      'settings-list': 'Configurações',
      'billing-report-list': 'Relatório de Faturamento',
      'zoho-reports': 'Zoho Analytics',
      'zoho-report-credential-list': 'Credenciais Zoho Analytics',
      'zoho-report-group-list': 'Grupos de Relatórios',
      'zoho-report-view': 'Visualizar Relatório',
      'user-project-list': 'Vincular Usuários - Projetos',
      'load-conf-list': 'Configuração de Carga'
    }
  },
  tooltips: {
    audit: {
      viewDetail: 'Visualizar Detalhamento'
    },
    user: {
      perfil: 'Perfil',
      transfer: 'Transferir'
    },
    task: {
      listTask: 'Listar Tarefas'
    }
  }
});
// CONCATENATED MODULE: ./src/i18n/pt-BR/Models.js
/* harmony default export */ var Models = ({
  user: 'Usuário',
  task: 'Tarefa',
  project: 'Projeto'
});
// CONCATENATED MODULE: ./src/i18n/pt-BR/Messages.js
/* harmony default export */ var Messages = ({
  internalError: 'Ocorreu um erro interno, contate o administrador do sistema',
  notFound: 'Nenhum registro encontrado',
  notAuthorized: 'Você não tem acesso a esta funcionalidade.',
  searchError: 'Não foi possível realizar a busca.',
  saveSuccess: 'Registro salvo com sucesso.',
  operationSuccess: 'Operação realizada com sucesso.',
  operationError: 'Erro ao realizar a operação',
  saveError: 'Erro ao tentar salvar o registro.',
  removeSuccess: 'Remoção realizada com sucesso.',
  removeError: 'Erro ao tentar remover o registro.',
  resourceNotFoundError: 'Recurso não encontrado',
  notNullError: 'Todos os campos obrigatórios devem ser preenchidos.',
  duplicatedResourceError: 'Já existe um recurso com essas informações.',
  validate: {
    fieldRequired: 'O campo {field} é obrigratório.'
  },
  layout: {
    error404: 'Página não encontrada'
  },
  login: {
    logoutInactive: 'Você foi deslogado do sistema por inatividade. Favor entrar no sistema novamente.',
    invalidCredentials: 'Credenciais Inválidas',
    unknownError: 'N\xE3o foi poss\xEDvel realizar o login. Tente novamente.\n      Caso n\xE3o consiga favor encontrar em contato com o administrador do sistema.',
    userNotFound: 'Não foi possível encontrar seus dados',
    userInactive: 'Usuário informado foi desabilitado, contate o administrador do sistema'
  },
  dashboard: {
    welcome: 'Seja bem Vindo {userName}',
    description: 'Utilize o menu para navegação.'
  },
  password: {
    resetError: 'Não foi possível reiniciar sua senha.'
  },
  mail: {
    mailErrors: 'Ocorreu um erro nos seguintes emails abaixo:\n',
    sendMailSuccess: 'Email enviado com sucesso!',
    passwordSendingError: 'Não foi possível enviar o email.',
    passwordSendingSuccess: 'O processo de recupera\xE7\xE3o de senha foi iniciado. Caso o email n\xE3o chegue em\n      10 minutos tente novamente.'
  },
  user: {
    removeYourSelfError: 'Você não pode remover seu próprio usuário',
    userExists: 'Usuário já adicionado!',
    profile: {
      updateError: 'Não foi possível atualizar seu profile'
    }
  },
  queryDinamic: {
    noFilter: 'Nenhum filtro adicionado'
  },
  foreignKeyError: 'Não foi possível remover o registro pois ele possui outros relacionamentos.',
  withoutUserPermission: 'Você não tem permissão para realizar a operação.',
  recoveryPassword: {
    sendMailSuccess: 'O link para redefinição de senha foi enviado para seu email.'
  },
  table_manager: {
    tableNotFound: 'A tabela informada não está cadastrada em nossa base.'
  },
  called: {
    editWithoutStatusChange: 'O status do chamado deve ser alterado antes de salvar.'
  }
});
// CONCATENATED MODULE: ./src/i18n/pt-BR/Global.js
/* harmony default export */ var Global = ({
  loading: 'Carregando...',
  processing: 'Processando...',
  yes: 'Sim',
  no: 'Não',
  cancel: 'Cancelar',
  ok: 'Ok',
  all: 'Todos'
});
// CONCATENATED MODULE: ./src/i18n/pt-BR/Attributes.js
/* harmony default export */ var Attributes = ({
  description: 'Descrição',
  email: 'Email',
  password: 'Senha',
  confirm_password: 'Confirmar Senha',
  name: 'Nome',
  image: 'Imagem',
  roles: 'Perfis',
  date: 'Data',
  initialDate: 'Data Inicial',
  finalDate: 'Data Final',
  created_at: 'Criado em',
  updated_at: 'Atualizado em',
  status: 'Status',
  userProject: 'Usuário',
  projects: 'Projetos',
  server: {
    host: 'Host',
    ip: 'IP',
    database: 'Banco de Dados',
    port: 'Porta'
  },
  user: {
    id: 'Código',
    name: 'Nome',
    email: 'Email',
    remember_token: 'Token',
    created_at: 'Criado em',
    updated_at: 'Atualizado em',
    image: 'Imagem',
    client: 'Cliente Vinculado',
    perfil: 'Perfil',
    status: 'Status'
  },
  client: {
    name: 'Cliente',
    cnpj: 'CNPJ',
    status: 'Status'
  },
  cycle: {
    start_date: 'Data de Início',
    end_date: 'Data do Fim',
    note: 'Observação',
    status: 'Status',
    qtd_hours: 'Quantidade de Horas'
  },
  task: {
    id: 'Código',
    description: 'Descrição',
    done: 'Feito?',
    priority: 'Prioridade',
    scheduled_to: 'Agendado Para',
    project: 'Projeto',
    project_id: 'Projeto',
    created_at: 'Criado em',
    updated_at: 'Atualizado em'
  },
  call: {
    id: 'Código',
    type_call: 'Tipo',
    destination_call: 'Destino',
    origin_call: 'Origem',
    date_call: 'Data/Hora',
    duration_call: 'Duração'
  },
  project: {
    responsible_name: 'Nome do Responsável',
    responsible_email: 'Email do Responsável',
    responsible_tel: 'Telefone do Responsável',
    status: 'Status'
  },
  called: {
    title: 'Título',
    project: 'Projeto',
    priority: 'Prioridade',
    cycle: 'Ciclo',
    number: 'Nº',
    user_created: 'Criado por',
    cycle_status: 'Status do Ciclo',
    createBy: 'Criado Por'
  },
  event: {
    event_type: 'Tipo',
    date: 'Data do Evento'
  },
  table_manager: {
    table_name: 'Nome da Tabela',
    created_by: 'Criado Por',
    users: 'Usuários Associados'
  },
  billing_report: {
    client: 'Cliente',
    hours_performed: 'Horas Executadas',
    billed_hours: 'Horas Faturadas',
    authorized_by: 'Autorizado Por',
    cycle: 'Ciclo',
    cycle_status: 'Status do Ciclo'
  },
  zoho: {
    client_id: 'Client ID',
    client_secret: 'Client Secret',
    refresh_token: 'Refresh Token',
    email: 'Email',
    db_name: 'Workspace',
    table_name: 'Nome da Tabela'
  },
  load_conf: {
    project: 'Projeto',
    description: 'Descrição',
    periodicity: 'Periodicidade',
    qtd_periodicity: 'Por Período',
    active: 'Ativo',
    types: 'Tipos'
  },
  // é carregado do servidor caso esteja definido no mesmo
  auditModel: {}
});
// CONCATENATED MODULE: ./src/i18n/pt-BR/Dialog.js
/* harmony default export */ var Dialog = ({
  confirmTitle: 'Confirmação',
  confirmDescription: 'Confirma a ação?',
  removeDescription: 'Deseja remover permanentemente {name}?',
  audit: {
    created: 'Informações do Cadastro',
    updatedBefore: 'Antes da Atualização',
    updatedAfter: 'Depois da Atualização',
    deleted: 'Informações antes de remover'
  },
  login: {
    resetPassword: {
      description: 'Digite abaixo o email cadastrado no sistema.'
    }
  }
});
// CONCATENATED MODULE: ./src/i18n/index.js









// Encapsula todas as mensagens de internacionalização
var i18n_translate = {
  'pt-BR': {
    views: Views,
    messages: Messages,
    models: Models,
    global: Global,
    attributes: Attributes,
    dialog: Dialog
  }
};

vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: 'pt-BR', // set locale
  messages: i18n_translate // set locale messages
});

// Fix para poder utilizar internacionalização nos componentes que são criados dinamicamente,
// como por exemplo os Dialogs
vue_esm["default"].prototype.$t = function (key) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return i18n.t(key, args);
};

/* harmony default export */ var src_i18n = (i18n);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.es.js
var vuex_persistedstate_es = __webpack_require__("424j");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/MutationTypes.js
var UPDATE_USER = 'UPDATE_USER';
var UPDATE_TOKEN = 'UPDATE_TOKEN';

// Aqui são declarados todos os tipos de mutations no store
// CONCATENATED MODULE: ./src/store/Mutations.js


var _types$UPDATE_USER$ty;



// Declaração de todos os mutations
/* harmony default export */ var Mutations = (_types$UPDATE_USER$ty = {}, defineProperty_default()(_types$UPDATE_USER$ty, UPDATE_USER, function (state, payload) {
  state.currentUser = payload;
}), defineProperty_default()(_types$UPDATE_USER$ty, UPDATE_TOKEN, function (state, payload) {
  state.token = payload;
}), _types$UPDATE_USER$ty);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/store/Actions.js



/* harmony default export */ var Actions = ({
  /**
   * Realiza o login do sistema e guarda as informações
   * do usuário e token
   *
   * @param {*} commit, função derivada do contexto da store
   * @param {*} credentials email e senha do usuário
   */
  login: function login(_ref, credentials) {
    var commit = _ref.commit;

    return axios_default.a.post('authenticate', credentials).then(function (response) {
      commit(UPDATE_USER, response.data.user);
      commit(UPDATE_TOKEN, response.data.token);

      return response.user;
    });
  },

  /**
   * Realiza o logout do sistema, para isso basta apagar todas as informações
   * do state que são relativas a autenticação
   * @param {*} commit, função derivada do contexto da store
   */
  logout: function logout(_ref2) {
    var commit = _ref2.commit;

    commit(UPDATE_USER, null);
    commit(UPDATE_TOKEN, null);
  },

  /**
   * Atualiza o profile do usuário
   *
   * @param {*} commit, função derivada do contexto da store
   * @param {*} user, dados do usuário
   */
  updateProfile: function updateProfile(_ref3, user) {
    var commit = _ref3.commit;

    return axios_default.a.put('profile', user).then(function (_ref4) {
      var data = _ref4.data;

      commit(UPDATE_USER, data);

      return data;
    });
  },

  /**
   * Envia email com informações para recuperar senha
   *
   * @param {*} commit, função derivada do contexto da store
   * @param {*} email, email do usuário que quer recuperar a senha
   */
  recoverPassword: function recoverPassword(_ref5, email) {
    var commit = _ref5.commit;

    return axios_default.a.post('password/email', email).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  },

  /**
   * Redefine a senha do usuário
   *
   * @param {*} commit, função derivada do contexto da store
   * @param {*} reset, dados para redefinir a senha
   */
  sendReset: function sendReset(_ref7, reset) {
    var commit = _ref7.commit;

    return axios_default.a.post('/password/reset', reset).then(function (_ref8) {
      var data = _ref8.data;
      return data;
    });
  }
});
// CONCATENATED MODULE: ./src/store/Getters.js
/* harmony default export */ var Getters = ({});
// CONCATENATED MODULE: ./src/store/Store.js








vue_esm["default"].use(vuex_esm["a" /* default */]);

// Declaração da Store do sistema
// Nesta store deve ser colocada todas as informações que são compartilhadas entre
// todos os componentes
var store = new vuex_esm["a" /* default */].Store({
  state: {
    currentUser: null,
    token: null
  },
  plugins: [
  // Plugin utilizado para persistir o state da store no localstorage
  Object(vuex_persistedstate_es["a" /* default */])()],
  mutations: Mutations,
  actions: Actions,
  getters: Getters
});

/* harmony default export */ var Store = (store);
// CONCATENATED MODULE: ./src/store/index.js

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/components/mixins/DialogMixin.js

/**
 * Mixin contendo todo o comportamento do para uso de Dialogs
 *
 * Uso:
 *  Adicionar aos arrays de Mixins ex: mixins: [ DialogMixin ]
 *
 *  Adicionar ao template a estrutura
 *
 *  <v-dialog v-model="controlDialogVisible" :fullscreen="fullscreen"
 *    :max-width="width" :persistent="!closeWithMask">
 *
 *    o template do dialog deve ser colocado aqui
 *
 *  </v-dialog>
 *
 * Para abrir o Dialog é necessário utilizar o serviço $dialog, ex:
 *
 * this.$dialog.component(UserDialog, {
        width: 800,
        props1: 'conteudo da props 1'
        props2: 'conteudo da props 2' }).then((response) => {
          call back executado quando o modal é fechado
          response.data
          response.action
        });
 *
 * Para o fechar o Dialog e passar informações para quem chamou basta emitir um evento close, ex:
 *
 *  this.$emit('close', params);
 *    ou
 *  this.sendParamsOnClose(params);
 *
 * Por padrão os eventos (esc, clicar na mascara do Dialog) do Dialog
 * chamam sendParamsOnClose quando o mesmo é fechado.
 */
/* harmony default export */ var DialogMixin = ({
  model: {
    prop: 'visible',
    event: 'visibleChange'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 520
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    closeWithMask: {
      type: Boolean,
      default: true
    },
    closeWithEsc: {
      type: Boolean,
      default: true
    },
    throughService: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      controlDialogVisible: this.visible
    };
  },

  watch: {
    /**
     * Metodo que atualiza o controle do modal de acordo com as mudanças no v-model do pai
     * @param {*} newValue
     */
    visible: function visible(newValue) {
      this.controlDialogVisible = newValue;
    },


    /**
     * Metodo que controla a visibilidade do dialog.
     * @param {*} newValue
     */
    controlDialogVisible: function controlDialogVisible(newValue) {
      if (newValue === false) {
        this.closeDialog();
      }
      // emite esse evento para o v-model do parent quando o dialog é utilizado inline
      this.$emit('visibleChange', newValue);
    }
  },
  methods: {
    /**
     * Metodo responsavel por exibir dialog
     */
    showDialog: function showDialog() {
      this.controlDialogVisible = true;
    },

    /**
     * Metodo responsavel por fechar dialog.
     * @param {*} action
     * @param {*} data
     */
    closeDialog: function closeDialog(action, data) {
      this.controlDialogVisible = false;
      this.sendParamsOnClose({ action: action, data: data });

      if (this.throughService) {
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      }
    },

    /**
     * Metodo responsavel por emitir o evento de close do dialog.
     * @param {*} params
     */
    sendParamsOnClose: function sendParamsOnClose(params) {
      this.$emit('close', params);
    },

    /**
     * Metodo responsavel por capturar o evento do teclado.
     * @param {*} evt
     */
    handleModalKeyCode: function handleModalKeyCode(evt) {
      // Escape
      if (this.controlDialogVisible && this.closeWithEsc && evt.keyCode === 27) {
        this.closeDialog('esc');
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleModalKeyCode);
  },
  beforeDestory: function beforeDestory() {
    document.removeEventListener('keydown', this.handleModalKeyCode);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/RecoverPasswordDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var RecoverPasswordDialog = ({
  name: 'recover-password-dialog',
  data: function data() {
    return {
      validationErrors: {},
      reset: {}
    };
  },

  mixins: [DialogMixin],
  methods: {
    send: function send() {
      var _this = this;

      this.$store.dispatch('recoverPassword', this.reset).then(function () {
        _this.$toast.success(_this.$t('messages.recoveryPassword.sendMailSuccess'));
        _this.hide();
      }).catch(function (error) {
        _this.valdationErrors = error.response.data;
      });
    },
    close: function close() {
      this.valdationErrors = {};
      this.closeDialog();
    }
  },
  mounted: function mounted() {
    this.valdationErrors = {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8536f13c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/RecoverPasswordDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":_vm.width,"persistent":!_vm.closeWithMask},model:{value:(_vm.controlDialogVisible),callback:function ($$v) {_vm.controlDialogVisible=$$v},expression:"controlDialogVisible"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n        "+_vm._s(_vm.$t('views.titles.resetPassword'))+"\n      ")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Digite abaixo o email cadastrado no sistema.\n        "),_c('v-text-field',{attrs:{"label":_vm.$t('attributes.email'),"counter":100,"error-messages":_vm.validationErrors.email},model:{value:(_vm.reset.email),callback:function ($$v) {_vm.$set(_vm.reset, "email", $$v)},expression:"reset.email"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('views.actions.getOut')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","dark":""},on:{"click":_vm.send}},[_vm._v(_vm._s(_vm.$t('views.actions.send')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var auth_RecoverPasswordDialog = (esExports);
// CONCATENATED MODULE: ./src/features/auth/RecoverPasswordDialog.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  RecoverPasswordDialog,
  auth_RecoverPasswordDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var features_auth_RecoverPasswordDialog = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/features/auth/AuthService.js




var AuthService_AuthService = function () {
  function AuthService() {
    classCallCheck_default()(this, AuthService);
  }

  createClass_default()(AuthService, null, [{
    key: 'login',


    /**
     * Serviço especifico para realizar o login do sistema
     * @param {*} credentials objeto login e senha.
     */
    value: function login(credentials) {
      return Store.dispatch('login', credentials);
    }
  }]);

  return AuthService;
}();

/* harmony default export */ var auth_AuthService = (AuthService_AuthService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Login = ({
  name: 'login',
  components: {
    RecoverPasswordDialog: features_auth_RecoverPasswordDialog
  },
  data: function data() {
    return {
      roles: [],
      valdationErrors: [],
      showModal: false,
      credentials: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      auth_AuthService.login(this.credentials).then(function () {
        _this.$router.replace({
          name: 'dashboard'
        });
      }).catch(function (error) {
        _this.valdationErrors = error.response.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da47c42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":"","grid-list-sm":"","pa-0":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"fill-height":""}},[_c('v-layout',{staticClass:"login-background-color",attrs:{"column":""}},[_c('v-flex',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","ma-3":""}},[_c('v-flex',{staticClass:"box-login",attrs:{"xs12":"","sm7":"","md3":""}},[_c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('v-card',{staticClass:"elevation-3"},[_c('v-card-text',{staticClass:"pl-3 pr-3 pb-1 pt-0"},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"pt-3":""}},[_c('img',{staticClass:"img-logo",attrs:{"src":"/static/logo_ciclos.png","alt":"logo"}})]),_vm._v(" "),_c('v-flex',{staticClass:"title-access primary--text headline",attrs:{"pt-3":"","align-center":""}},[_vm._v("\n                            ACESSE SUA CONTA\n                          ")]),_vm._v(" "),_c('v-flex',{attrs:{"pt-4":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('attributes.email'),"name":"email","counter":100,"error-messages":_vm.valdationErrors.email},model:{value:(_vm.credentials.email),callback:function ($$v) {_vm.$set(_vm.credentials, "email", $$v)},expression:"credentials.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('attributes.password'),"name":"password","type":"password","error-messages":_vm.valdationErrors.password,"counter":20},model:{value:(_vm.credentials.password),callback:function ($$v) {_vm.$set(_vm.credentials, "password", $$v)},expression:"credentials.password"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"color":"primary","block":"","type":"submit","name":"loginButton"}},[_vm._v(_vm._s(_vm.$t('views.actions.in')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","block":"","color":"primary"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v(_vm._s(_vm.$t('views.fields.login.resetPassword')))])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('recover-password-dialog',{attrs:{"lazy":"true"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}})],1)],1)],1)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var auth_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/features/auth/Login.vue
function injectStyle (ssrContext) {
  __webpack_require__("Lc9T")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = injectStyle
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  auth_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var features_auth_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/ResetPassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ResetPassword = ({
  name: 'login',
  data: function data() {
    return {
      roles: [],
      validationErrors: {},
      reset: {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.params.token
      }
    };
  },

  methods: {
    send: function send() {
      var _this = this;

      this.$store.dispatch('sendReset', this.reset).then(function () {
        _this.$toast.success(_this.$t('messages.operationSuccess'));
        _this.$router.push({
          name: 'login'
        });
      }).catch(function (error) {
        _this.validationErrors = error.response.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7711ee68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/ResetPassword.vue
var ResetPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-5",attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('views.titles.resetPassword')))])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-card-media',{attrs:{"contain":true,"src":"/static/logo_ciclos.png","height":"200px"}}),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"sm6":"","offset-sm3":""}},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.send($event)}}},[_c('v-text-field',{attrs:{"label":_vm.$t('attributes.email'),"counter":100,"error-messages":_vm.validationErrors.email},model:{value:(_vm.reset.email),callback:function ($$v) {_vm.$set(_vm.reset, "email", $$v)},expression:"reset.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('attributes.password'),"type":"password","counter":20,"error-messages":_vm.validationErrors.password},model:{value:(_vm.reset.password),callback:function ($$v) {_vm.$set(_vm.reset, "password", $$v)},expression:"reset.password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('attributes.confirm_password'),"type":"password","error-messages":_vm.validationErrors.password_confirmation,"counter":20},model:{value:(_vm.reset.password_confirmation),callback:function ($$v) {_vm.$set(_vm.reset, "password_confirmation", $$v)},expression:"reset.password_confirmation"}}),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","block":"","color":"primary"}},[_vm._v(_vm._s(_vm.$t('views.actions.send')))])],1)],1)],1)],1)],1)],1)],1)}
var ResetPassword_staticRenderFns = []
var ResetPassword_esExports = { render: ResetPassword_render, staticRenderFns: ResetPassword_staticRenderFns }
/* harmony default export */ var auth_ResetPassword = (ResetPassword_esExports);
// CONCATENATED MODULE: ./src/features/auth/ResetPassword.vue
var ResetPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResetPassword___vue_template_functional__ = false
/* styles */
var ResetPassword___vue_styles__ = null
/* scopeId */
var ResetPassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ResetPassword___vue_module_identifier__ = null
var ResetPassword_Component = ResetPassword_normalizeComponent(
  ResetPassword,
  auth_ResetPassword,
  ResetPassword___vue_template_functional__,
  ResetPassword___vue_styles__,
  ResetPassword___vue_scopeId__,
  ResetPassword___vue_module_identifier__
)

/* harmony default export */ var features_auth_ResetPassword = (ResetPassword_Component.exports);

// CONCATENATED MODULE: ./src/Config.js


// arquivo que tem as configurações globais
// to starterpack e das bibliotecas

axios_default.a.defaults.baseURL = "/api/v1";

var Config_Global = {
  format: {
    displayDate: 'DD/MM/YYYY',
    displayDateTime: 'DD/MM/YYYY HH:mm',
    parseDate: 'YYYY-MM-DD',
    parseDateTime: 'YYYY-MM-DD HH:mm Z'
  },
  info: {
    version: '1.9.0',
    name: 'Ciclos'
  }
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/features/BaseService.js





/**
 * Classe base para a criação de serviços
 * Aqui é implementado os métodos básicos para integração com uma API REST.
 * Está é uma classe abstrata, é necessário herdar de BaseService para utiliza-la
 */

var BaseService_BaseService = function () {
  function BaseService(domain) {
    classCallCheck_default()(this, BaseService);

    this.domain = '';
    this.data = '';

    this.mapDataFromResponse = function (response) {
      return response.data;
    };

    this.domain = domain;
  }

  /**
   * Metodo responsavel por realizar um get por id.
   * @param {*} id
   */


  createClass_default()(BaseService, [{
    key: 'get',
    value: function get(id) {
      return axios_default.a.get(this.domain + '/' + id).then(this.mapDataFromResponse);
    }

    /**
     * Metodo responsavel por realizar um get com filtros.
     * @param {*} filters
     */

  }, {
    key: 'query',
    value: function query() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return axios_default.a.get(this.domain, {
        params: filters
      }).then(this.mapDataFromResponse);
    }
  }, {
    key: 'paginateQuery',


    /**
     * Metodo responsavel por realizar um get com filtros e paginado.
     * @param {*} filters
     * @param {*} perPage
     * @param {*} page
     */
    value: function paginateQuery() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var defaultFilters = assign_default()({ perPage: perPage, page: page }, filters);

      return this.query(defaultFilters);
    }

    /**
     * Metodo responsavel por realizar um post ou put.
     * Caso o objeto possua id ele realiza put.
     * @param {*} data
     */

  }, {
    key: 'save',
    value: function save(data) {
      var reqConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var promise = null;
      var id = data instanceof FormData ? data.get('id') : data.id;
      if (id === undefined || id === null) {
        promise = axios_default.a.post(this.domain, data, reqConfig);
      } else {
        promise = axios_default.a.put(this.domain + '/' + id, data, reqConfig);
      }

      return promise.then(this.mapDataFromResponse);
    }

    /**
     * Metodo responsavel por realizar um metodo de delete.
     * @param {*} id
     */

  }, {
    key: 'destroy',
    value: function destroy(id) {
      return axios_default.a.delete(this.domain + '/' + id).then(this.mapDataFromResponse);
    }

    /**
     * Metodo responsavel por realizar requests dinamicos.
     * @param {*} method
     * @param {*} path
     * @param {*} data
     * @param {*} options
     */

  }, {
    key: 'request',
    value: function request(method, path) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return BaseService.request(method, this.domain + '/' + path, data, options);
    }
  }], [{
    key: 'manyRequests',
    value: function manyRequests(promises) {
      return axios_default.a.all(promises).then(this.mapDataFromResponse);
    }
  }, {
    key: 'request',
    value: function request(method, path) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var defaultOptions = assign_default()({ url: path, overridePath: false }, options, { method: method, data: data });

      if (defaultOptions.overridePath) defaultOptions.url = path;
      delete defaultOptions.overridePath;

      return axios_default.a.request(defaultOptions).then(this.mapDataFromResponse);
    }
  }]);

  return BaseService;
}();

/* harmony default export */ var features_BaseService = (BaseService_BaseService);
// CONCATENATED MODULE: ./src/features/user/UserService.js








var UserService_UserService = function (_BaseService) {
  inherits_default()(UserService, _BaseService);

  function UserService() {
    classCallCheck_default()(this, UserService);

    return possibleConstructorReturn_default()(this, (UserService.__proto__ || get_prototype_of_default()(UserService)).call(this, 'users'));
  }

  /**
   * Verifica se o usuário tem o(s) perfil(s) solicitado
   *
   * @param {*} user usuário que vai ser verificado
   * @param {*} roles perfils a serem verificados, pode ser um array contendo vários ou
   * uma string contendo um único perfil
   * @param {*} all determina se é para checar se o usuário tem todos ou algum,
   * true para todos, false paga algum
   */


  createClass_default()(UserService, null, [{
    key: 'hasProfile',
    value: function hasProfile(user, roles) {
      var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // eslint-disable-next-line
      roles = Array.isArray(roles) ? roles : [roles];

      var userRoles = Object(lodash["map"])(user.roles, 'slug');

      if (all) {
        return Object(lodash["intersection"])(userRoles, roles).length === roles.length;
      }

      return Object(lodash["intersection"])(userRoles, roles).length;
    }
  }, {
    key: 'toggleStatus',
    value: function toggleStatus(_ref) {
      var id = _ref.id;

      return features_BaseService.request('POST', 'users/toggle-status', { id: id });
    }
  }]);

  return UserService;
}(features_BaseService);

/* harmony default export */ var user_UserService = (UserService_UserService);
// CONCATENATED MODULE: ./src/components/layout/MenuItems.js
/* harmony default export */ var MenuItems = ([{
  icon: 'multiline_chart',
  name: 'dashboard',
  items: []
}, {
  icon: 'receipt',
  name: 'called-list',
  items: []
}, {
  icon: 'event',
  name: 'event-list',
  items: []
}, {
  icon: 'sync_alt',
  name: 'user-project-list',
  items: []
}, {
  icon: 'assignment',
  name: 'reports',
  items: [{
    icon: 'date_range',
    name: 'cycle-consolidated'
  }]
}, {
  icon: 'line_axis',
  name: 'zoho-reports',
  path: '#',
  requireRoles: ['master'],
  items: [{
    icon: 'analytics',
    name: 'zoho-report-view',
    requireRoles: ['master']
  }, {
    icon: 'post_add',
    name: 'zoho-report-group-list',
    requireRoles: ['master']
  }, {
    icon: 'lock',
    name: 'zoho-report-credential-list',
    requireRoles: ['master']
  }]
}, {
  icon: 'settings_applications',
  name: 'admin',
  path: '#',
  requireRoles: ['master', 'admin', 'admin_cliente'],
  items: [{
    icon: 'request_page',
    name: 'billing-report-list',
    requireRoles: ['master', 'admin']
  }, {
    icon: 'work',
    name: 'project-list',
    requireRoles: ['master', 'admin']
  }, {
    icon: 'date_range',
    name: 'cycle-list',
    requireRoles: ['master', 'admin']
  }, {
    icon: 'assignment_ind',
    name: 'client-list',
    requireRoles: ['master', 'admin']
  }, {
    icon: 'save',
    name: 'table-manager-list',
    requireRoles: ['master', 'admin']
  }, {
    icon: 'update',
    name: 'load-conf-list',
    requireRoles: ['master', 'admin', 'admin_cliente']
  }, {
    icon: 'people',
    name: 'user-list',
    requireRoles: ['master', 'admin', 'admin_cliente']
  }, {
    icon: 'settings',
    name: 'settings-list',
    requireRoles: ['master', 'admin']
  }]
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/MenuSideBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MenuSideBar = ({
  name: 'menu-side-bar',
  created: function created() {
    this.preparedItems = this.prepareMenuItems(MenuItems);
  },

  computed: {
    /**
     * Metodo responsavel por montar avatar do usuario.
     */
    avatar: function avatar() {
      return this.$store.state.currentUser.image ? this.$store.state.currentUser.image : '/static/no_avatar.gif';
    }
  },
  methods: {
    /**
     *  Prepara o item de menus pegando informações das rotas dentro de /app
     */
    prepareMenuItems: function prepareMenuItems(itemsOrder) {
      var _this = this;

      var data = [];

      // pega as rotas que estão dentro do main
      var mainRoute = src_router.options.routes.find(function (routerItem) {
        return routerItem.path === '/app';
      });

      var mainChildrenRoutes = mainRoute.children;

      itemsOrder.forEach(function (itemMenu) {
        var preparedItem = _this.mergeItemWithRouter(mainChildrenRoutes, assign_default()({}, itemMenu));
        preparedItem.items = [];

        itemMenu.items.forEach(function (subItemMenu) {
          preparedItem.items.push(_this.mergeItemWithRouter(mainChildrenRoutes, assign_default()({}, subItemMenu)));
        });

        data.push(preparedItem);
      });

      return data;
    },

    /**
     * Metodo que faz o merge das informações contida no roteamento com as informações
     * contidas na declaração dos itens de menu
     */
    mergeItemWithRouter: function mergeItemWithRouter(mainChildrenRoutes, item) {
      var menuPrefix = 'views.layout.menu.';
      var routerMatched = void 0;

      item.title = '' + menuPrefix + item.name;
      item.exact = true;

      if (item.requireRoles) {
        item.hasPermission = user_UserService.hasProfile(this.$store.state.currentUser, item.requireRoles);
      } else {
        item.hasPermission = true;
      }

      mainChildrenRoutes.find(function (routerItem) {
        var found = item.name === routerItem.name;

        if (found) {
          routerMatched = assign_default()({}, routerItem, { path: '/app/' + routerItem.path });
          return true;
        }

        return false;
      });

      if (routerMatched) {
        var hasPermission = true;

        if (routerMatched.meta.requireRoles) {
          hasPermission = user_UserService.hasProfile(this.$store.state.currentUser, routerMatched.meta.requireRoles);
        }

        // eslint-disable-next-line
        item = assign_default()({}, item, {
          path: routerMatched.path,
          hasPermission: hasPermission
        });
      }
      return item;
    }
  },
  data: function data() {
    return {
      preparedItems: []
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f9a9355","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MenuSideBar.vue
var MenuSideBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"main-menu",attrs:{"dense":""}},[_c('v-layout',{class:[_vm.$theme.menu.headerClass, 'elevation-2', 'menu-header'],attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"menu-logo text-xs-center",attrs:{"xs12":""}},[_c('img',{staticClass:"img-logo",attrs:{"src":"/static/logo_ciclos_branca.png","alt":"logo"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('router-link',{staticClass:"avatarWrapper",attrs:{"to":{ name: 'dashboard' }}},[_c('div',{staticClass:"avatar elevation-2",style:({'background-image': 'url(' + _vm.avatar + ')'})})])],1),_vm._v(" "),_c('v-flex',{staticClass:"textAvatar",attrs:{"xs8":""}},[_c('div',[_c('b',[_vm._v(" "+_vm._s(_vm.$store.state.currentUser.name)+" ")])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$store.state.currentUser.email))])])],1),_vm._v(" "),_vm._l((_vm.preparedItems),function(item){return (item.hasPermission)?[(item.items.length)?_c('v-list-group',{key:item.title,attrs:{"value":item.active,"active-class":_vm.$theme.menu.darkMode ? 'white--text' : 'grey--text text--darken-2',"prepend-icon":item.icon}},[_c('v-list-tile',{attrs:{"slot":"activator","to":item.path == '#' ? '' : item.path,"exact":item.exact,"active-class":_vm.$theme.menu.activeItemClass},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(item.title)))])],1)],1),_vm._v(" "),_vm._l((item.items),function(subItem){return (subItem.hasPermission)?_c('v-list-tile',{key:subItem.title,staticClass:"menu-sub-item",attrs:{"exact":false,"to":subItem.path,"active-class":_vm.$theme.menu.activeItemClass}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(subItem.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(subItem.title)))])],1)],1):_vm._e()})],2):_c('v-list-tile',{key:item.title,attrs:{"to":item.path == '#' ? '' : item.path,"exact":item.exact,"active-class":_vm.$theme.menu.activeItemClass}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(item.title)))])],1)],1)]:_vm._e()})],2)}
var MenuSideBar_staticRenderFns = []
var MenuSideBar_esExports = { render: MenuSideBar_render, staticRenderFns: MenuSideBar_staticRenderFns }
/* harmony default export */ var layout_MenuSideBar = (MenuSideBar_esExports);
// CONCATENATED MODULE: ./src/components/layout/MenuSideBar.vue
function MenuSideBar_injectStyle (ssrContext) {
  __webpack_require__("vCkZ")
}
var MenuSideBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MenuSideBar___vue_template_functional__ = false
/* styles */
var MenuSideBar___vue_styles__ = MenuSideBar_injectStyle
/* scopeId */
var MenuSideBar___vue_scopeId__ = "data-v-4f9a9355"
/* moduleIdentifier (server only) */
var MenuSideBar___vue_module_identifier__ = null
var MenuSideBar_Component = MenuSideBar_normalizeComponent(
  MenuSideBar,
  layout_MenuSideBar,
  MenuSideBar___vue_template_functional__,
  MenuSideBar___vue_styles__,
  MenuSideBar___vue_scopeId__,
  MenuSideBar___vue_module_identifier__
)

/* harmony default export */ var components_layout_MenuSideBar = (MenuSideBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/HeaderNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var HeaderNav = ({
  name: 'header-nav',
  components: {
    MenuSideBar: components_layout_MenuSideBar
  },
  data: function data() {
    return {
      title: this.$router.currentRoute.name,
      clipped: false,
      drawer: this.$vuetify.breakpoint.smAndUp
    };
  },

  watch: {
    /**
     * Metodo responsavel por atribuir o titulo atraves da route.
     */
    $route: function $route(to) {
      this.title = to.name;
    }
  },
  computed: {
    /**
     * Método responsavel por traduzir o title.
     */
    translateTitle: function translateTitle() {
      return this.$t('views.breadcrumbs.' + this.title);
    }
  },
  methods: {
    /**
     * Metodo responsavel por efetuar o logout da aplicacao.
     * Dispara um evento para limpar o cache.
     */
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$toast.success('Deslogado com sucesso');
      this.$router.replace('/');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8debcf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/HeaderNav.vue
var HeaderNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"menu-drawer",class:_vm.$theme.menu.bodyClass,attrs:{"fixed":true,"dark":_vm.$theme.menu.darkMode,"clipped":_vm.clipped,"enable-resize-watcher":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('menu-side-bar')],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1",attrs:{"fixed":"","app":"","clipped-left":_vm.clipped}},[(!_vm.drawer)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{attrs:{"id":"toolbarTitle"},domProps:{"textContent":_vm._s(_vm.translateTitle)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","to":{name: 'profile'},"icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("account_box")])],1),_vm._v(" "),_c('span',[_vm._v("Perfil")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.logout()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("power_settings_new")])],1),_vm._v(" "),_c('span',[_vm._v("Sair")])],1)],1)],1)}
var HeaderNav_staticRenderFns = []
var HeaderNav_esExports = { render: HeaderNav_render, staticRenderFns: HeaderNav_staticRenderFns }
/* harmony default export */ var layout_HeaderNav = (HeaderNav_esExports);
// CONCATENATED MODULE: ./src/components/layout/HeaderNav.vue
function HeaderNav_injectStyle (ssrContext) {
  __webpack_require__("HGqI")
}
var HeaderNav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HeaderNav___vue_template_functional__ = false
/* styles */
var HeaderNav___vue_styles__ = HeaderNav_injectStyle
/* scopeId */
var HeaderNav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HeaderNav___vue_module_identifier__ = null
var HeaderNav_Component = HeaderNav_normalizeComponent(
  HeaderNav,
  layout_HeaderNav,
  HeaderNav___vue_template_functional__,
  HeaderNav___vue_styles__,
  HeaderNav___vue_scopeId__,
  HeaderNav___vue_module_identifier__
)

/* harmony default export */ var components_layout_HeaderNav = (HeaderNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Este component centraliza os componentes de layout do sistema
/* harmony default export */ var Main = ({
  components: {
    HeaderNav: components_layout_HeaderNav
  },
  name: 'Main',
  data: function data() {
    return {
      fixed: false,
      info: Config_Global.info
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14466305","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('header-nav'),_vm._v(" "),_c('v-content',{staticClass:"content-white"},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"fixed":_vm.fixed,"app":""}},[_c('span',{staticClass:"footer"},[_vm._v(" "+_vm._s(_vm.info.name)+" - "+_vm._s(_vm.info.version)+" ")])])],1)}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var layout_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/components/layout/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("Tg1b")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = "data-v-14466305"
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  layout_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var components_layout_Main = (Main_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/auth/NotAuthorized.vue
//
//
//
//
//
//

/* harmony default export */ var NotAuthorized = ({
  name: 'not-authorized',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0cd5710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/NotAuthorized.vue
var NotAuthorized_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.$t('views.titles.attention')}},[_c('p',[_vm._v(_vm._s(_vm.$t('messages.notAuthorized')))])])}
var NotAuthorized_staticRenderFns = []
var NotAuthorized_esExports = { render: NotAuthorized_render, staticRenderFns: NotAuthorized_staticRenderFns }
/* harmony default export */ var auth_NotAuthorized = (NotAuthorized_esExports);
// CONCATENATED MODULE: ./src/features/auth/NotAuthorized.vue
var NotAuthorized_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotAuthorized___vue_template_functional__ = false
/* styles */
var NotAuthorized___vue_styles__ = null
/* scopeId */
var NotAuthorized___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotAuthorized___vue_module_identifier__ = null
var NotAuthorized_Component = NotAuthorized_normalizeComponent(
  NotAuthorized,
  auth_NotAuthorized,
  NotAuthorized___vue_template_functional__,
  NotAuthorized___vue_styles__,
  NotAuthorized___vue_scopeId__,
  NotAuthorized___vue_module_identifier__
)

/* harmony default export */ var features_auth_NotAuthorized = (NotAuthorized_Component.exports);

// CONCATENATED MODULE: ./src/router/guards/AuthenticationGuard.js



/**
 * TODO Este evento é responsável por verificar o controle de autenticação
 * na transição de páginas
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
var AuthenticationGuard_beforeEach = function beforeEach(to, from, next) {
  // Verifica se a rota requer autenticação ou algum perfil especifico
  // se requerer o usuário deverá estar logado para continuar a rota
  if ((to.meta.requiresAuth || to.meta.requireRoles) && !Store.state.currentUser) {
    next('/');
    // Se o usuário estiver logado e tentar ir para a página de login ele vai ser direcionado
    // paga página inicial
  } else if (to.name === 'login' && Store.state.currentUser) {
    // TODO Mudar para constante de HomePage
    next({ name: 'dashboard' });
  } else {
    next();
  }
};

/* harmony default export */ var AuthenticationGuard = (AuthenticationGuard_beforeEach);
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/plugins/dialog/DialogDefinitions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DialogDefinitions = ({
  name: 'dialog-definitions',
  mixins: [DialogMixin],
  props: {
    title: String,
    content: String,
    cancelText: {
      type: String
    },
    okText: {
      type: String
    },
    showHead: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showInput: {
      type: Boolean,
      default: false
    },
    inputLabel: {
      type: String,
      default: ''
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showOkButton: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      inputValue: null
    };
  },

  computed: {
    /**
     * Metodo responsavel por retornar o texto.
     */
    localeOKText: function localeOKText() {
      return typeof this.okText === 'undefined' ? this.$t('global.ok') : this.okText;
    },

    /**
     * Metodo responsavel por retornar o texto.
     */
    localeCancelText: function localeCancelText() {
      return typeof this.cancelText === 'undefined' ? this.$t('global.cancel') : this.cancelText;
    }
  },
  methods: {
    /**
     * Metodo responsavel por controlar o confirm do dialog
     */
    confirm: function confirm() {
      if (this.showInput) {
        this.closeDialog('ok', { inputValue: this.inputValue });
      } else {
        this.closeDialog('ok');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0269c829","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/dialog/DialogDefinitions.vue
var DialogDefinitions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":_vm.width,"persistent":!_vm.closeWithMask,"fullscreen":_vm.fullscreen},model:{value:(_vm.controlDialogVisible),callback:function ($$v) {_vm.controlDialogVisible=$$v},expression:"controlDialogVisible"}},[_c('v-card',[(_vm.showHead && (_vm.$slots.header || this.title))?_c('v-card-title',{staticClass:"headline"},[_vm._t("header",[_c('p',[_vm._v(_vm._s(_vm.title))])])],2):_vm._e(),_vm._v(" "),_c('v-card-text',[_vm._t("default",[(_vm.content)?_c('p',[_vm._v(_vm._s(_vm.content))]):_vm._e(),_vm._v(" "),(_vm.showInput)?_c('v-text-field',{attrs:{"label":_vm.inputLabel},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.closeDialog('ok')}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}):_vm._e()])],2),_vm._v(" "),_c('v-card-actions',[_vm._t("footer",[_c('v-spacer'),_vm._v(" "),(_vm.showCancelButton)?_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.closeDialog('cancel')}}},[_vm._v(_vm._s(_vm.localeCancelText))]):_vm._e(),_vm._v(" "),(_vm.showOkButton)?_c('v-btn',{attrs:{"flat":"","color":"primary"},nativeOn:{"click":function($event){_vm.confirm('ok')}}},[_vm._v(_vm._s(_vm.localeOKText))]):_vm._e()])],2)],1)],1)],1)}
var DialogDefinitions_staticRenderFns = []
var DialogDefinitions_esExports = { render: DialogDefinitions_render, staticRenderFns: DialogDefinitions_staticRenderFns }
/* harmony default export */ var dialog_DialogDefinitions = (DialogDefinitions_esExports);
// CONCATENATED MODULE: ./src/plugins/dialog/DialogDefinitions.vue
var DialogDefinitions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DialogDefinitions___vue_template_functional__ = false
/* styles */
var DialogDefinitions___vue_styles__ = null
/* scopeId */
var DialogDefinitions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DialogDefinitions___vue_module_identifier__ = null
var DialogDefinitions_Component = DialogDefinitions_normalizeComponent(
  DialogDefinitions,
  dialog_DialogDefinitions,
  DialogDefinitions___vue_template_functional__,
  DialogDefinitions___vue_styles__,
  DialogDefinitions___vue_scopeId__,
  DialogDefinitions___vue_module_identifier__
)

/* harmony default export */ var plugins_dialog_DialogDefinitions = (DialogDefinitions_Component.exports);

// CONCATENATED MODULE: ./src/plugins/dialog/DialogService.js








// Injetta na instancia base os mesmos atributos utilizados na instancia Root do Vue
// Isto é necessário para que o Dialog tenha acesso as mesmas informações (store, i18n ...)
var VueBase = vue_esm["default"].extend(extends_default()({}, VueInstanceInject));

var DialogDefinitionsConstructor = VueBase.extend(plugins_dialog_DialogDefinitions);

// Controla a instancia corrente do Dialog
var instance = void 0;
// Controla a Fila do Dialog
var queue = [];

/**
 * Inicializa a instancia de um Dialog com base no Component informado
 * @param {*} component Componente a ser utilizado no Dialog
 * @param {*} options Propriedades a ser setadas no Dialog
 */
var DialogService_initInstance = function initInstance(component, options) {
  // Esta propriedade throughService é necessária pois existes tratamentos
  // especificos para quando o Dialog é aberto através do serviço
  var propsData = extends_default()({
    throughService: true
  }, options);

  // Cria a instancia do component informado ou utiliza o
  // pré definido (Alert, Confirm, Prompt)
  if (component) {
    var CustomComponentConstructor = VueBase.extend(component);

    instance = new CustomComponentConstructor({ propsData: propsData });
  } else {
    instance = new DialogDefinitionsConstructor({ propsData: propsData });
  }
};

/**
 * Exibe o próximo Dialog que está na fila
 *
 * @param {*} component
 */
var DialogService_showNextDialog = function showNextDialog(component) {
  // Verifica se existe algum Dialog na fila para ser exibido
  if (queue.length) {
    var currentDialog = queue.shift();
    var options = currentDialog.options;

    // Inicializa uma nova instancia do Dialog com base nas definições informadas

    DialogService_initInstance(component, options);

    // Escuta o evento close emitido pelo Dialog para resolver a
    // promise retornando as informações necessárias
    instance.$on('close', function (_ref) {
      var action = _ref.action,
          data = _ref.data;

      currentDialog.resolve({ action: action, data: data });
    });

    var el = document.createElement('div');
    instance.$mount(el);
    document.body.appendChild(instance.$el);

    vue_esm["default"].nextTick(function () {
      instance.controlDialogVisible = true;
    });
  }
};

/* eslint-disable no-param-reassign */

var DialogService_prepareOptions = function prepareOptions(content, title, options) {
  if ((typeof content === 'undefined' ? 'undefined' : typeof_default()(content)) === 'object') {
    options = content;
    content = options.content || '';
    title = options.title || '';
  }

  return assign_default()({ title: title, content: content }, options);
};

/**
 * Funcion utilizada como classe Base para encapsula a tratativa
 * comum de todos os Dialogs, como por exemplo a Promise que irá
 * ser responsável pelo comportamento de callback
 * @param {*} options
 * @param {*} component
 */
var DialogService_DialogService = function DialogService(options, component) {
  if (vue_esm["default"].prototype.$isServer) return undefined;

  // eslint-disable-next-line
  return new promise_default.a(function (resolve, reject) {

    // Adiciona o Dialog na fila para controlar a ordem de visibilidade
    queue.push({
      options: assign_default()({}, options),
      resolve: resolve,
      reject: reject
    });

    DialogService_showNextDialog(component);
  });
};

// Método que é responsável por fechar todos os Dialogs presentes e reseta a fila
DialogService_DialogService.close = function () {
  if (instance) instance.closeDialog();
  queue = [];
};

DialogService_DialogService.component = function (component, options) {
  return new DialogService_DialogService(options, component);
};
DialogService_DialogService.custom = function (options) {
  return new DialogService_DialogService(options);
};

/**
 * Semelhante ao window.alert
 */
DialogService_DialogService.alert = function (content, title, options) {
  var mergeOptions = assign_default()({
    closeWithMask: false,
    showCancelButton: false
  }, DialogService_prepareOptions(content, title, options));

  return new DialogService_DialogService(mergeOptions);
};

/**
 * Semelhante ao window.confirm
 */
DialogService_DialogService.confirm = function (content, title, options) {
  var mergeOptions = DialogService_prepareOptions(content, title, options);

  return new DialogService_DialogService(mergeOptions);
};

/**
 * Semelhante ao window.prompt
 */
DialogService_DialogService.prompt = function (content, title, options) {
  var mergeOptions = assign_default()({
    showInput: true
  }, DialogService_prepareOptions(content, title, options));

  return new DialogService_DialogService(mergeOptions);
};

/* harmony default export */ var dialog_DialogService = (DialogService_DialogService);
// CONCATENATED MODULE: ./src/router/guards/AuthorizationGuard.js



var AuthorizationGuard__this = this;







/**
 * TODO Este evento é responsável por verificar o controle de autorização
 * na transição de páginas
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
var AuthorizationGuard_beforeEach = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
    var response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            response = null;

            if (!(to.name !== 'login' && to.name !== 'resetPassword')) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return user_UserService.request('GET', 'authenticate/check');

          case 4:
            response = _context.sent;

          case 5:
            if (response && response.data.status !== 'valid') {
              Store.dispatch('logout');
              dialog_DialogService.close();
              vue_esm["default"].$toast.error(src_i18n.t('messages.login.logoutInactive'));
              next({ name: 'login' });
            } else if (Store.state.currentUser && to.meta.requireRoles && !user_UserService.hasProfile(Store.state.currentUser, to.meta.requireRoles)) {
              next({ name: 'not-authorized' });
            } else {
              next();
            }

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, AuthorizationGuard__this);
  }));

  return function beforeEach(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var AuthorizationGuard = (AuthorizationGuard_beforeEach);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/components/widgets/PrPaginacaoService.js




var PrPaginacaoService_PrPaginacaoService = function () {
  function PrPaginacaoService(searchMethod, perPage, _options) {
    classCallCheck_default()(this, PrPaginacaoService);

    this.searchMethod = undefined;
    this.numberOfPages = 1;
    this.total = 0;
    this.perPage = 10;
    this.currentPage = 0;
    this.options = {
      maxPages: 10,
      labels: {
        first: '««',
        previous: '«',
        next: '»',
        last: '»»'
      }
    };

    if (perPage !== undefined) {
      this.perPage = perPage;
    }

    assign_default()(this.options, _options);

    this.searchMethod = searchMethod;
    // calcula quantas páginas vão ser exibidas na parte intermediaria da paginação
    this.options.maxPagesInner = Math.floor(this.options.maxPages / 2);
  }

  /**
   * Calcula o número de páginas que vai ser exibida baseado no total de
   * itens com a perPage
   *
   * @param {int} total - total de itens
   */


  createClass_default()(PrPaginacaoService, [{
    key: 'calcNumberOfPages',
    value: function calcNumberOfPages(total) {
      this.total = total;

      if (total <= 0) {
        this.numberOfPages = 1;
      } else {
        this.numberOfPages = Math.floor(total / this.perPage) + (total % this.perPage > 0 ? 1 : 0);
      }
    }

    /**
     * Verifica as páginas que devem ser exibidas
     */

  }, {
    key: 'pages',
    value: function pages() {
      var ret = [];

      for (var i = 1; i <= this.numberOfPages; i += 1) {
        if (this.currentPage === i) {
          ret.push(i);
        } else if (this.currentPage <= this.options.maxPagesInner + 1) {
          if (i <= this.options.maxPages) {
            ret.push(i);
          }
        } else if (i >= this.currentPage - this.options.maxPagesInner && i <= this.currentPage + this.options.maxPagesInner) {
          ret.push(i);
        }
      }
      return ret;
    }

    /**
     * Carrega os dados da página anterior
     */

  }, {
    key: 'previousPage',
    value: function previousPage() {
      if (this.currentPage > 1) {
        this.searchMethod(this.currentPage - 1);
      }
    }

    /**
     * Carrega os dados da próxima página
     */

  }, {
    key: 'nextPage',
    value: function nextPage() {
      if (this.currentPage < this.numberOfPages) {
        this.searchMethod(this.currentPage + 1);
      }
    }

    /**
     * Carrega os dados da página informada
     *
     * @param {int} page - pagina que deve ser carregada
     */

  }, {
    key: 'goToPage',
    value: function goToPage(page) {
      if (page >= 1 && page <= this.numberOfPages) {
        this.searchMethod(page);
      }
    }
  }]);

  return PrPaginacaoService;
}();

/* harmony default export */ var widgets_PrPaginacaoService = (PrPaginacaoService_PrPaginacaoService);
// CONCATENATED MODULE: ./src/components/mixins/CrudMixin.js






// Definição dos Callbacks
var CALLBACKS = {
  beforeSearch: 'beforeSearch',
  applyFilters: 'applyFilters',
  afterSearch: 'afterSearch',
  beforeSave: 'beforeSave',
  beforeLoadResource: 'beforeLoadResource',
  afterLoadResource: 'afterLoadResource',
  afterSave: 'afterSave'
};

// Tipos a ser utilizado no CrudMixin
var CRUD_TYPE = {
  search: 'SEARCH',
  form: 'FORM'
};

/**
 * Mixin contendo todo o comportamento do genérico de um CRUD
 *
 * Uso:
 *  Adicionar aos arrays de Mixins ex: mixins: [ CrudMixin ]
 *
 *  Implementar o método initCrud e informar as propriedades obrigatórias, ex:
 *
 *  initCrud() {
 *    this.serviceType = ProjectService;
 *    this.routerName = 'project';
 *    this.componentType = 'FORM';
 *  }
 */
/* harmony default export */ var CrudMixin = ({
  data: function data() {
    return {
      serviceType: null,
      routerName: null,
      resource: {},
      resources: [],
      paginator: null,
      totalResources: 0,
      service: null,
      componentType: CRUD_TYPE.search,
      searchLoading: false,
      saveLoading: false,
      stopSaveData: false,
      validationErrors: {},
      options: {
        perPage: 7,
        skipPagination: false,
        redirectAfterSave: true
      },
      orderSync: {},
      noDataAvailable: this.$t('messages.notFound'),
      onSearchInit: true,
      reqSaveConfig: {}
    };
  },

  computed: {
    /**
     * Metodo responsavel por montar o titulo do box da pagina.
     */
    titleBox: function titleBox() {
      if (this.componentType === CRUD_TYPE.form && this.resource.id) {
        return src_i18n.t('views.titles.update');
      } else if (this.componentType === CRUD_TYPE.form && !this.resource.id) {
        return src_i18n.t('views.titles.register');
      }
      return src_i18n.t('views.titles.list');
    }
  },
  created: function created() {
    this.checkPreRequisites();
    this.paginator = new widgets_PrPaginacaoService(this.search, this.options.perPage);
    this.orderSync.rowsPerPage = this.paginator.perPage;
    // eslint-disable-next-line
    this.service = new this.serviceType();

    if (this.componentType === CRUD_TYPE.form) {
      this.prepareResource();
    }
  },

  watch: {
    /**
     * Metodo responsavel por realizar a paginacao da grid
     */
    orderSync: {
      handler: function handler() {
        this.search(this.paginator.currentPage);
      },

      deep: true
    }
  },
  methods: {
    /**
     * Metodo responsavel por checar os pre requisitos de quem implementa o CrudMixin.
     */
    checkPreRequisites: function checkPreRequisites() {
      if (typeof this.initCrud === 'function') {
        this.callTriggerEvent('initCrud');

        if (!this.serviceType) this.$log.error('É preciso injetar o ServiceType no método initCrud()');
        if (!this.routerName) this.$log.error('É preciso injetar o routerName no método initCrud()');
      } else {
        this.$log.error('Implemente o método initCrud como um evento e injete os pré-requisitos');
      }
    },

    /**
     * Método de pesquisa podendo ser paginado ou nao
     * @param {*} page
     */
    search: function search() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.onSearchInit) {
        this.searchLoading = true;
        this.options.skipPagination ? this.normalSearch() : this.paginateSearch(page);
      }
      this.onSearchInit = true;
    },


    /**
     * Metodo de pesquisa sem paginacao
     */
    normalSearch: function normalSearch() {
      this.callTriggerEvent(CALLBACKS.beforeSearch);

      return this.service.query(this.mergeFiltersAndSort()).then(this.baseSearchSuccessBehaviour).finally(this.baseSearchFinallyBehaviour);
    },


    /**
     * Metodo de pesquisa paginada
     * @param {*} page
     */
    paginateSearch: function paginateSearch(page) {
      var _this = this;

      this.paginator.currentPage = page || 1;
      var defaultFilters = { perPage: this.paginator.perPage, page: this.paginator.currentPage };

      this.callTriggerEvent(CALLBACKS.beforeSearch);

      return this.service.query(this.mergeFiltersAndSort(defaultFilters)).then(function (data) {
        _this.paginator.calcNumberOfPages(data.total);

        return data.items;
      }).then(this.baseSearchSuccessBehaviour).finally(this.baseSearchFinallyBehaviour);
    },


    /**
     * Metodo chamado apos a pesquisa ser realizada com sucesso.
     * @param {*} items
     */
    baseSearchSuccessBehaviour: function baseSearchSuccessBehaviour(items) {
      this.callTriggerEvent(CALLBACKS.afterSearch);
      this.resources = items;
    },


    /**
     * Metodo chamado apos a pesquisa ser finalizada
     */
    baseSearchFinallyBehaviour: function baseSearchFinallyBehaviour() {
      this.searchLoading = false;
    },


    /**
     * Metodo responsavel por retornar o id passado pelo param do route.
     */
    getId: function getId() {
      return this.$route.params.id;
    },


    /**
     * Metodo responsavel por preparar o Resource.
     */
    prepareResource: function prepareResource() {
      var _this2 = this;

      var id = this.getId();

      this.callTriggerEvent(CALLBACKS.beforeLoadResource);

      if (id !== 'new') {
        this.service.get(id).then(function (data) {
          _this2.resource = data;
          _this2.callTriggerEvent(CALLBACKS.afterLoadResource);
        });
      } else {
        this.resource = {};
      }
    },


    /**
     * Metodo responsavel por salvar o resource.
     */
    save: function save() {
      var _this3 = this;

      this.saveLoading = true;
      this.callTriggerEvent(CALLBACKS.beforeSave);

      if (!this.stopSaveData) {
        this.service.save(this.resource, this.reqSaveConfig).then(function (data) {
          _this3.resource = data;

          _this3.$toast.success(src_i18n.t('messages.saveSuccess'));

          _this3.callTriggerEvent(CALLBACKS.afterSave);

          if (_this3.options.redirectAfterSave) {
            _this3.goToList();
          }
        }).catch(function (error) {
          if (error.response && typeof_default()(error.response.data) === 'object') {
            _this3.validationErrors = error.response.data;
          } else {
            _this3.validationErrors = {};
          }
        }).finally(this.baseSaveFinallyBehaviour);
      } else {
        this.baseSaveFinallyBehaviour();
      }
    },


    /**
     * Metodo chamado apos a finalização do save.
     */
    baseSaveFinallyBehaviour: function baseSaveFinallyBehaviour() {
      this.saveLoading = false;
    },


    /**
     * Metodo chamado para excluir o resource
     * @param {*} id
     * @param {*} label
     */
    destroy: function destroy(id, label) {
      var _this4 = this;

      this.$dialog.confirm({ title: 'Atenção', content: 'Deseja apagar ' + label + '?' }).then(function (response) {
        if (response.action === 'ok') {
          _this4.service.destroy(id).then(function () {
            _this4.search();
            _this4.$toast.success(src_i18n.t('messages.removeSuccess'));
          });
        }
      });
    },


    /**
     * Metodo responsavel por redirecionar para o form.
     * @param {*} id
     */
    goToForm: function goToForm(id) {
      if (id) {
        this.goTo(this.routerName + '-form', { id: id });
      } else {
        this.goTo(this.routerName + '-form', { id: '/new' });
      }
    },


    /**
     * Metodo responsavel para redirecionar para a list.
     */
    goToList: function goToList() {
      if (this.resource.id) {
        this.goTo(this.routerName + '-list', { id: this.resource.id });
      } else {
        this.goTo(this.routerName + '-list');
      }
    },


    /**
     * Metodo responsavel por redirecionar.
     * @param {*} routerName
     * @param {*} params
     * @param {*} options
     */
    goTo: function goTo(routerName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var routerDefinition = assign_default()(options, { name: routerName, params: params });

      this.$router.push(routerDefinition);
    },


    /**
     * Metodo responsavel por aplicar a ordenacao e os filtros.
     * @param {*} defaultFilters
     */
    mergeFiltersAndSort: function mergeFiltersAndSort() {
      var defaultFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var filters = assign_default()({}, defaultFilters);

      if (this.orderSync.sortBy) {
        assign_default()(filters, {
          orderBy: this.orderSync.sortBy,
          orderType: this.orderSync.descending ? 'DESC' : 'ASC'
        });
      }

      // chama o applyFilters
      if (typeof this[CALLBACKS.applyFilters] === 'function') {
        filters = this[CALLBACKS.applyFilters](filters);
      }

      return this.fixFilter(filters);
    },


    /**
     * Metodo responsavel por executar funcoes disparadas em eventos.
     * @param {*} eventName
     * @param {*} args
     */
    callTriggerEvent: function callTriggerEvent(eventName) {
      if (typeof this[eventName] === 'function') {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        this[eventName](args);
      }
    },


    /**
     * Metodo responsavel por retirar propriedades undefined de objetos.
     * @param {*} filters
     */
    fixFilter: function fixFilter() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var fixFilters = assign_default()({}, filters);

      keys_default()(fixFilters).forEach(function (key) {
        if (fixFilters[key] === undefined) {
          delete fixFilters[key];
        }
      });

      return fixFilters;
    }
  }
});
// CONCATENATED MODULE: ./src/features/audit/AuditService.js







var AuditService_AuditService = function (_BaseService) {
  inherits_default()(AuditService, _BaseService);

  function AuditService() {
    classCallCheck_default()(this, AuditService);

    return possibleConstructorReturn_default()(this, (AuditService.__proto__ || get_prototype_of_default()(AuditService)).call(this, AuditService.domain));
  }

  /**
   * Lista de tipos de autitoria
   */


  createClass_default()(AuditService, null, [{
    key: 'listTypes',
    value: function listTypes() {
      var auditPath = 'views.fields.audit.';
      return [{ id: '', label: auditPath + 'allResources' }, { id: 'created', label: auditPath + 'type.created' }, { id: 'updated', label: auditPath + 'type.updated' }, { id: 'deleted', label: auditPath + 'type.deleted' }];
    }

    /**
     * Pega a lista de models que são auditados
     */

  }, {
    key: 'getAuditedModels',
    value: function getAuditedModels() {
      return features_BaseService.request('GET', AuditService.domain + '\\models');
    }
  }]);

  return AuditService;
}(features_BaseService);

AuditService_AuditService.domain = 'audit';
/* harmony default export */ var audit_AuditService = (AuditService_AuditService);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/filters/PrDateTimeFilter.js



// Filtro para converter um objeto Date em uma string
// no formato Brasileiro de Data com horário
/* harmony default export */ var PrDateTimeFilter = (function (date, displayDateTimeParam) {
  var displayDateTime = Config_Global.format.displayDateTime;

  if (!displayDateTime) {
    displayDateTime = displayDateTimeParam;
  }

  if (date) {
    return moment_default()(String(date), Config_Global.format.parseDateTime).format(displayDateTime);
  }

  return null;
});
// CONCATENATED MODULE: ./src/components/widgets/PrMoneyUtilFormat.js
function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

function fixed(precision) {
  return between(0, precision, 20);
}

function toStr(value) {
  return value ? value.toString() : '';
}

function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, '') || '0';
}

function numbersToCurrency(numbers, precision) {
  var exp = Math.pow(10, precision);
  var float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1' + separator);
}

function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

function format(inputParam, optParam) {
  var input = void 0;

  var opt = {
    prefix: '',
    suffix: '',
    thousands: ',',
    decimal: '.',
    precision: 2
  };

  if (optParam) {
    opt = optParam;
  }

  if (typeof inputParam === 'number') {
    input = inputParam.toFixed(fixed(opt.precision));
  } else {
    input = inputParam;
  }

  var negative = input.indexOf('-') >= 0 ? '-' : '';

  var numbers = onlyNumbers(input);
  var currency = numbersToCurrency(numbers, opt.precision);
  var parts = toStr(currency).split('.');
  var integer = parts[0];
  var decimal = parts[1];
  integer = addThousandSeparator(integer, opt.thousands);
  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix;
}

function unformat(input, precision) {
  var negative = input.indexOf('-') >= 0 ? -1 : 1;
  var numbers = onlyNumbers(input);
  var currency = numbersToCurrency(numbers, precision);
  return parseFloat(currency) * negative;
}

function setCursor(el, position) {
  var setSelectionRange = function setSelectionRange() {
    el.setSelectionRange(position, position);
  };
  if (el === document.activeElement) {
    setSelectionRange();
    setTimeout(setSelectionRange, 1); // Android Fix
  }
}

function PrMoneyUtilFormat_event(name) {
  var evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}


// CONCATENATED MODULE: ./src/filters/CurrencyFilter.js



// Filtro para converter um objeto float
// no formato da moeda Real
/* harmony default export */ var CurrencyFilter = (function (value) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var defaults = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2
  };

  var params = extends_default()({}, defaults, opts);

  return format(value, params);
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/audit/AuditDetailDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var AuditDetailDialog = ({
  mixins: [DialogMixin],
  props: {
    log: {}
  },
  data: function data() {
    return {};
  },

  computed: {
    classOld: function classOld() {
      return {
        'sm6 offset-sm4 xs12': this.log && this.log.old.length !== 0 && this.log.new.length === 0,
        'sm6 xs12': this.log && this.log.old.length !== 0 && this.log.new.length !== 0,
        'xs12 ': !this.log || this.log.old.length === 0
      };
    },
    classNew: function classNew() {
      return {
        'sm6 offset-sm4 xs12': this.log && this.log.new.length !== 0 && this.log.old.length === 0,
        'sm6 xs12': this.log && this.log.new.length !== 0 && this.log.old.length !== 0,
        'xs12 ': !this.log || this.log.new.length === 0
      };
    }
  },
  methods: {
    verifyImage: function verifyImage(value) {
      return typeof value === 'string' && value.startsWith('data:imag');
    }
  },
  filters: {
    auditDetailTitle: function auditDetailTitle(auditDetail, status) {
      if (auditDetail && auditDetail.type === 'updated') {
        if (status === 'before') {
          return src_i18n.t('dialog.audit.updatedBefore');
        }
        return src_i18n.t('dialog.audit.updatedAfter');
      } else if (auditDetail && auditDetail.type) {
        return src_i18n.t('dialog.audit.' + auditDetail.type);
      }

      return null;
    },
    attrLog: function attrLog(log, key) {
      var modelReplace = log.auditable_type.replace('App\\', '');
      return modelReplace.toLowerCase() + '.' + key;
    },
    auditValue: function auditValue(value, key) {
      if (value instanceof Date || Object(lodash["endsWith"])(key, '_at') || Object(lodash["endsWith"])(key, '_to')) {
        return PrDateTimeFilter(value);
      }

      if (typeof value === 'boolean') {
        return src_i18n.t(value ? 'global.yes' : 'global.no');
      }

      // eslint-disable-next-line
      if (Number(value) === value && value % 1 !== 0) {
        return CurrencyFilter(value);
      }

      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f81d78c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/audit/AuditDetailDialog.vue
var AuditDetailDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.controlDialogVisible),callback:function ($$v) {_vm.controlDialogVisible=$$v},expression:"controlDialogVisible"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{class:_vm.classOld},[(_vm.log && _vm.log.old.length != 0)?_c('pr-box',{attrs:{"title":_vm._f("auditDetailTitle")(_vm.log,'before')}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("close")])],1)],1),_vm._v(" "),_vm._l((_vm.log.old),function(value,key){return _c('div',{key:key},[(_vm.verifyImage(value))?_c('div',{staticClass:"text-xs-center"},[_c('img',{staticClass:"pictureAudit",attrs:{"src":value}})]):_c('div',[_c('span',[_c('b',[_vm._v(_vm._s(_vm._f("tAttr")(_vm._f("attrLog")(_vm.log,key)))+" ")])]),_vm._v(" "+_vm._s(_vm._f("auditValue")(value,key))+"\n                  "),_c('hr')])])})],2):_vm._e()],1),_vm._v(" "),_c('v-flex',{class:_vm.classNew},[(_vm.log && _vm.log.new.length != 0)?_c('pr-box',{attrs:{"title":_vm._f("auditDetailTitle")(_vm.log,'after')}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("close")])],1)],1),_vm._v(" "),_vm._l((_vm.log.new),function(value,key){return _c('div',{key:key},[(_vm.verifyImage(value))?_c('div',{staticClass:"text-xs-center"},[_c('img',{staticClass:"pictureAudit",attrs:{"src":value}})]):_c('div',[_c('span',[_c('b',[_vm._v(_vm._s(_vm._f("tAttr")(_vm._f("attrLog")(_vm.log,key)))+" ")])]),_vm._v(" "+_vm._s(_vm._f("auditValue")(value,key))+"\n                    "),_c('hr')])])})],2):_vm._e()],1)],1)],1)],1)],1)}
var AuditDetailDialog_staticRenderFns = []
var AuditDetailDialog_esExports = { render: AuditDetailDialog_render, staticRenderFns: AuditDetailDialog_staticRenderFns }
/* harmony default export */ var audit_AuditDetailDialog = (AuditDetailDialog_esExports);
// CONCATENATED MODULE: ./src/features/audit/AuditDetailDialog.vue
function AuditDetailDialog_injectStyle (ssrContext) {
  __webpack_require__("OyIo")
}
var AuditDetailDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AuditDetailDialog___vue_template_functional__ = false
/* styles */
var AuditDetailDialog___vue_styles__ = AuditDetailDialog_injectStyle
/* scopeId */
var AuditDetailDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AuditDetailDialog___vue_module_identifier__ = null
var AuditDetailDialog_Component = AuditDetailDialog_normalizeComponent(
  AuditDetailDialog,
  audit_AuditDetailDialog,
  AuditDetailDialog___vue_template_functional__,
  AuditDetailDialog___vue_styles__,
  AuditDetailDialog___vue_scopeId__,
  AuditDetailDialog___vue_module_identifier__
)

/* harmony default export */ var features_audit_AuditDetailDialog = (AuditDetailDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/audit/Audit.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Audit = ({
  name: 'user-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  filters: {
    auditType: function auditType(typeId) {
      var type = audit_AuditService.listTypes().filter(function (t) {
        return t.id === typeId;
      });
      return type[0] ? src_i18n.t(type[0].label) : type[0];
    },
    auditModel: function auditModel(modelId) {
      var modelReplace = modelId.replace('App\\', '');
      var model = src_i18n.t('models.' + modelReplace.toLowerCase());
      return model || modelId;
    }
  },
  data: function data() {
    return {
      queryFilter: {},
      types: [],
      models: [],
      headers: [{
        text: this.$t('models.user'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('views.fields.action'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('views.fields.audit.resource'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('attributes.date'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = audit_AuditService;
      this.routerName = 'audit';
      this.load();
    },
    detail: function detail(item) {
      this.$dialog.component(features_audit_AuditDetailDialog, {
        log: item
      }).then();
    },
    load: function load() {
      var _this = this;

      audit_AuditService.getAuditedModels().then(function (response) {
        for (var index = 0; index < response.data.models.length; index += 1) {
          var model = response.data.models[index];

          _this.models.push({
            id: model,
            label: _this.$t('models.' + model.toLowerCase())
          });
        }
      });
      this.types = audit_AuditService.listTypes();
    },
    applyFilters: function applyFilters(filters) {
      return assign_default()(filters, this.queryFilter);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb97578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/audit/Audit.vue
var Audit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pr-box',{attrs:{"title":_vm.$t('views.titles.auditList')}},[_c('v-form',{staticClass:"flex-condensed px-2"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Id"},model:{value:(_vm.queryFilter.auditable_id),callback:function ($$v) {_vm.$set(_vm.queryFilter, "auditable_id", $$v)},expression:"queryFilter.auditable_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('pr-date',{attrs:{"label":_vm.$t('views.fields.audit.dateStart')},model:{value:(_vm.queryFilter.dateStart),callback:function ($$v) {_vm.$set(_vm.queryFilter, "dateStart", $$v)},expression:"queryFilter.dateStart"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('pr-date',{attrs:{"label":_vm.$t('views.fields.audit.dateEnd')},model:{value:(_vm.queryFilter.dateEnd),callback:function ($$v) {_vm.$set(_vm.queryFilter, "dateEnd", $$v)},expression:"queryFilter.dateEnd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('models.user')},model:{value:(_vm.queryFilter.user),callback:function ($$v) {_vm.$set(_vm.queryFilter, "user", $$v)},expression:"queryFilter.user"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm8":""}},[_c('v-select',{attrs:{"items":_vm.models,"label":_vm.$t('views.fields.audit.resource'),"item-text":"label","item-value":"id","single-line":"","bottom":""},model:{value:(_vm.queryFilter.model),callback:function ($$v) {_vm.$set(_vm.queryFilter, "model", $$v)},expression:"queryFilter.model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm8":""}},[_c('v-radio-group',{attrs:{"row":!_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.queryFilter.type),callback:function ($$v) {_vm.$set(_vm.queryFilter, "type", $$v)},expression:"queryFilter.type"}},_vm._l((_vm.types),function(t){return _c('v-radio',{key:t.id,attrs:{"name":"radio","label":_vm.$t(t.label),"value":t.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":"","sm4":""}},[_c('v-btn',{attrs:{"fab":"","color":"secondary"},on:{"click":function($event){_vm.search()}}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1),_vm._v(" "),_c('pr-box',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"hide-actions":true,"loading":_vm.searchLoading,"no-data-text":_vm.noDataAvailable},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.user.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("auditType")(props.item.type))+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("auditModel")(props.item.auditable_type))+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("prDate")(props.item.created_at))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.detail(props.item)}}},[_c('v-icon',[_vm._v("remove_red_eye")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)],1)}
var Audit_staticRenderFns = []
var Audit_esExports = { render: Audit_render, staticRenderFns: Audit_staticRenderFns }
/* harmony default export */ var audit_Audit = (Audit_esExports);
// CONCATENATED MODULE: ./src/features/audit/Audit.vue
var Audit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Audit___vue_template_functional__ = false
/* styles */
var Audit___vue_styles__ = null
/* scopeId */
var Audit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Audit___vue_module_identifier__ = null
var Audit_Component = Audit_normalizeComponent(
  Audit,
  audit_Audit,
  Audit___vue_template_functional__,
  Audit___vue_styles__,
  Audit___vue_scopeId__,
  Audit___vue_module_identifier__
)

/* harmony default export */ var features_audit_Audit = (Audit_Component.exports);

// CONCATENATED MODULE: ./src/features/mail/MailService.js






var MailService_MailService = function (_BaseService) {
  inherits_default()(MailService, _BaseService);

  function MailService() {
    classCallCheck_default()(this, MailService);

    return possibleConstructorReturn_default()(this, (MailService.__proto__ || get_prototype_of_default()(MailService)).call(this, 'mails'));
  }

  return MailService;
}(features_BaseService);

/* harmony default export */ var mail_MailService = (MailService_MailService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/user/UserDialog.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var UserDialog = ({
  name: 'user-dialog',
  mixins: [CrudMixin, DialogMixin],
  props: {
    usersAdd: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      users: [],
      headers: [{
        text: this.$t('attributes.name'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('attributes.email'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('views.fields.actions'),
        align: 'center',
        sortable: false
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = user_UserService;
      this.routerName = 'users';
      this.users = [].concat(toConsumableArray_default()(this.usersAdd));
    },
    applyFilters: function applyFilters(filter) {
      var usersId = Object(lodash["map"])(this.users, 'id');
      return assign_default()(filter, { notUsers: usersId.join(',') });
    },
    addUser: function addUser(user) {
      var existsUser = this.users.find(function (userFind) {
        return userFind.email === user.email;
      });

      if (!existsUser) {
        this.users.push(user);
      } else {
        this.$toast.info(src_i18n.t('messages.user.userExists'));
      }

      this.search();
    },
    sendParamsOnClose: function sendParamsOnClose(params) {
      this.$emit('close', assign_default()(params, { data: this.users }));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-073e46ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/user/UserDialog.vue
var UserDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":_vm.fullscreen,"max-width":_vm.width,"persistent":!_vm.closeWithMask},model:{value:(_vm.controlDialogVisible),callback:function ($$v) {_vm.controlDialogVisible=$$v},expression:"controlDialogVisible"}},[_c('pr-box',{attrs:{"title":_vm.$t('views.titles.userList')}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"hide-actions":true,"loading":_vm.searchLoading,"no-data-text":_vm.noDataAvailable},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(" "+_vm._s(props.item.name)+" ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(props.item.email)+" ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.addUser(props.item)}}},[_c('v-icon',[_vm._v("swap_horiz")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)],1)],1)}
var UserDialog_staticRenderFns = []
var UserDialog_esExports = { render: UserDialog_render, staticRenderFns: UserDialog_staticRenderFns }
/* harmony default export */ var user_UserDialog = (UserDialog_esExports);
// CONCATENATED MODULE: ./src/features/user/UserDialog.vue
var UserDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserDialog___vue_template_functional__ = false
/* styles */
var UserDialog___vue_styles__ = null
/* scopeId */
var UserDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserDialog___vue_module_identifier__ = null
var UserDialog_Component = UserDialog_normalizeComponent(
  UserDialog,
  user_UserDialog,
  UserDialog___vue_template_functional__,
  UserDialog___vue_styles__,
  UserDialog___vue_scopeId__,
  UserDialog___vue_module_identifier__
)

/* harmony default export */ var features_user_UserDialog = (UserDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/mail/Mail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Mail = ({
  data: function data() {
    return {
      userService: null,
      mailService: null,
      users: [],
      mail: { users: [] },
      loading: false,
      search: null,
      validationErrors: [],
      sendLoading: false
    };
  },
  created: function created() {
    this.userService = new user_UserService();
    this.mailService = new mail_MailService();
    this.querySelections();
  },

  watch: {
    search: function search(val) {
      if (val) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    querySelections: function querySelections(val) {
      var _this = this;

      this.loading = true;
      var query = { limit: 5 };
      if (val) {
        query.email = val;
      }
      this.userService.query(query).then(function (data) {
        _this.users = [].concat(toConsumableArray_default()(data.filter(function (user) {
          var userFind = _this.users.find(function (userSelected) {
            return user.email === userSelected.email;
          });
          return !userFind;
        })), toConsumableArray_default()(_this.users));
      }).finally(function () {
        _this.loading = false;
      });
    },
    save: function save() {
      var _this2 = this;

      this.sendLoading = true;
      this.mailService.save(this.mail).then(function () {
        _this2.$toast.success(src_i18n.t('messages.mail.sendMailSuccess'));
        _this2.validationErrors = {};
        _this2.mail = { users: [] };
      }).catch(function (error) {
        if (error.response && typeof_default()(error.response.data) === 'object') {
          _this2.validationErrors = error.response.data;
        } else {
          _this2.validationErrors = {};
        }
      }).finally(function () {
        _this2.sendLoading = false;
      });
    },
    openModalUsers: function openModalUsers() {
      var _this3 = this;

      this.$dialog.component(features_user_UserDialog, {
        width: 800,
        usersAdd: this.mail.users }).then(function (response) {
        _this3.mail.users = [].concat(toConsumableArray_default()(response.data), toConsumableArray_default()(_this3.mail.users));
        _this3.users = [].concat(toConsumableArray_default()(response.data.filter(function (user) {
          var userFind = _this3.users.find(function (userSelected) {
            return user.email === userSelected.email;
          });
          return !userFind;
        })), toConsumableArray_default()(_this3.users));
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52852c8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/mail/Mail.vue
var Mail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();_vm.save()}}},[_c('pr-box',{attrs:{"title":_vm.$t('views.titles.mailSend')}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs9":"","sm10":"","md11":""}},[_c('v-select',{attrs:{"label":_vm.$t('views.fields.mail.to'),"autocomplete":"","loading":_vm.loading,"multiple":"","cache-items":"","chips":"","item-text":"name","item-value":"id","items":_vm.users,"return-object":"","error-messages":_vm.validationErrors.users,"search-input":_vm.search},on:{"update:searchInput":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:data.item.id,staticClass:"chip--select-multi",attrs:{"selected":data.selected,"close":"","disabled":data.disabled},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',{staticClass:"secondary white--text"},[_vm._v(_vm._s(data.item.name.slice(0, 1).toUpperCase()))]),_vm._v("\n                  "+_vm._s(data.item.email)+"\n                ")],1)]}}]),model:{value:(_vm.mail.users),callback:function ($$v) {_vm.$set(_vm.mail, "users", $$v)},expression:"mail.users"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-all-right",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-btn',{attrs:{"fab":"","color":"secondary"},nativeOn:{"click":function($event){_vm.openModalUsers()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('views.fields.mail.subject'),"error-messages":_vm.validationErrors.subject},model:{value:(_vm.mail.subject),callback:function ($$v) {_vm.$set(_vm.mail, "subject", $$v)},expression:"mail.subject"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('views.fields.mail.message'),"multi-line":"","error-messages":_vm.validationErrors.message},model:{value:(_vm.mail.message),callback:function ($$v) {_vm.$set(_vm.mail, "message", $$v)},expression:"mail.message"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.sendLoading}},[_vm._v("\n          "+_vm._s(_vm.$t('views.actions.send'))+"\n        ")])],1)],1)],1)}
var Mail_staticRenderFns = []
var Mail_esExports = { render: Mail_render, staticRenderFns: Mail_staticRenderFns }
/* harmony default export */ var mail_Mail = (Mail_esExports);
// CONCATENATED MODULE: ./src/features/mail/Mail.vue
function Mail_injectStyle (ssrContext) {
  __webpack_require__("XqS7")
}
var Mail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Mail___vue_template_functional__ = false
/* styles */
var Mail___vue_styles__ = Mail_injectStyle
/* scopeId */
var Mail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Mail___vue_module_identifier__ = null
var Mail_Component = Mail_normalizeComponent(
  Mail,
  mail_Mail,
  Mail___vue_template_functional__,
  Mail___vue_styles__,
  Mail___vue_scopeId__,
  Mail___vue_module_identifier__
)

/* harmony default export */ var features_mail_Mail = (Mail_Component.exports);

// CONCATENATED MODULE: ./src/features/client/ClientService.js







var ClientService_ClientService = function (_BaseService) {
  inherits_default()(ClientService, _BaseService);

  function ClientService() {
    classCallCheck_default()(this, ClientService);

    return possibleConstructorReturn_default()(this, (ClientService.__proto__ || get_prototype_of_default()(ClientService)).call(this, 'clients'));
  }

  createClass_default()(ClientService, null, [{
    key: 'toggleStatus',
    value: function toggleStatus(_ref) {
      var id = _ref.id;

      return features_BaseService.request('POST', 'clients/toggle-status', { id: id });
    }
  }]);

  return ClientService;
}(features_BaseService);

/* harmony default export */ var client_ClientService = (ClientService_ClientService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/user/UserList.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UserList = ({
  name: 'user-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      disabledClient: false,
      showAlert: false,
      loader: null,
      api_user: 'todos',
      headers: [{
        text: this.$t('attributes.name'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('attributes.user.client'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('attributes.user.perfil'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('attributes.user.status'),
        align: 'left',
        sortable: false
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      clientService: new client_ClientService(),
      clients: [],
      apiOptions: [{ id: 1, description: 'SIM', value: 'sim' }, { id: 2, description: 'NÃO', value: 'nao' }, { id: 3, description: 'TODOS', value: 'todos' }],
      client_id: null,
      nameOrEmail: null,
      show: false,
      currentUser: null
    };
  },
  created: function created() {
    this.currentUser = this.$store.state.currentUser;
    if (!user_UserService.hasProfile(this.currentUser, ['master', 'admin', 'analista'])) {
      if (this.currentUser.client) {
        this.client_id = this.currentUser.client.id;
      }
      this.disabledClient = true;
    }
    this.loadCombos();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = user_UserService;
      this.routerName = 'user';
    },
    applyFilters: function applyFilters(filter) {
      var params = {
        nameOrEmail: this.nameOrEmail,
        api_user: this.api_user
      };
      if (this.client_id) params.client_id = this.client_id;
      return assign_default()(filter, params);
    },
    getImage: function getImage(image) {
      var defaultImage = '/static/no_avatar.gif';
      if (image) {
        defaultImage = image;
      }
      return defaultImage;
    },
    loadCombos: function loadCombos() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.clientService.query();

              case 2:
                _this.clients = _context.sent;

                _this.showAlert = _this.clients.length === 0;
                _this.search();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSuccess: function handleSuccess() {
      this.$toast.success('Token copiado com sucesso!');
    },
    handleError: function handleError() {
      this.$toast.error('Erro ao tentar copiar o token, tente novamente.');
    },
    toggleStatus: function toggleStatus(_ref) {
      var _this2 = this;

      var id = _ref.id;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return user_UserService.toggleStatus({ id: id });

              case 2:
                _this2.search(_this2.paginator.currentPage);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d9b83ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/user/UserList.vue
var UserList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'user-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-card',{staticClass:"pa-3"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"nameOrEmail","label":"Nome ou Email"},model:{value:(_vm.nameOrEmail),callback:function ($$v) {_vm.nameOrEmail=$$v},expression:"nameOrEmail"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","clearable":"","disabled":_vm.disabledClient || (_vm.clients.length === 0),"label":"Selecione um cliente"},model:{value:(_vm.client_id),callback:function ($$v) {_vm.client_id=$$v},expression:"client_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.apiOptions,"item-text":"description","item-value":"value","clearable":"","label":"Usuários de Api"},model:{value:(_vm.api_user),callback:function ($$v) {_vm.api_user=$$v},expression:"api_user"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","text-md-center":""}},[_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n              Não existem clientes cadastrados no sistema.\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.search()}}},[_c('v-icon',[_vm._v("search")]),_vm._v("\n              Pesquisar\n            ")],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","text-md-center":""}},[_c('v-alert',{attrs:{"value":['master', 'admin'].includes(_vm.currentUser.roles[0].slug),"type":"info"}},[_vm._v("\n          URL API: http://ciclosweb.com.br/api/v1/dynamic-select/select-table-or-view?tableName=[TABLE_NAME]&token=[USER_TOKEN]\n        ")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-avatar',{attrs:{"slot":"activator","size":"36px"},slot:"activator"},[_c('img',{attrs:{"src":_vm.getImage(props.item.image),"alt":""}})]),_vm._v("  \n\n            "+_vm._s(props.item.name)+" ("+_vm._s(props.item.email)+")\n          ")],1),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.client ? props.item.client.name : 'Nenhum cliente vinculado')+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.roles.length > 0 ? props.item.roles[0].title : 'Nenhum perfil vinculado')+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.active ? "Ativo" : "Inativo")+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":props.item.active ? 'success' : 'dark',"flat":"","icon":""},on:{"click":function($event){_vm.toggleStatus({ id: props.item.id })}},slot:"activator"},[(props.item.active)?_c('v-icon',[_vm._v("toggle_on")]):_c('v-icon',[_vm._v("toggle_off")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.active ? "Desativar" : "Ativar"))])],1),_vm._v(" "),(props.item.api_token)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(props.item.api_token),expression:"props.item.api_token"}],attrs:{"slot":"activator","flat":"","icon":""},on:{"success":_vm.handleSuccess,"error":_vm.handleError},slot:"activator"},[_c('v-icon',[_vm._v("content_copy")])],1),_vm._v(" "),_c('span',[_vm._v("Copiar TOKEN")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, props.item.name)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var UserList_staticRenderFns = []
var UserList_esExports = { render: UserList_render, staticRenderFns: UserList_staticRenderFns }
/* harmony default export */ var user_UserList = (UserList_esExports);
// CONCATENATED MODULE: ./src/features/user/UserList.vue
var UserList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserList___vue_template_functional__ = false
/* styles */
var UserList___vue_styles__ = null
/* scopeId */
var UserList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserList___vue_module_identifier__ = null
var UserList_Component = UserList_normalizeComponent(
  UserList,
  user_UserList,
  UserList___vue_template_functional__,
  UserList___vue_styles__,
  UserList___vue_scopeId__,
  UserList___vue_module_identifier__
)

/* harmony default export */ var features_user_UserList = (UserList_Component.exports);

// CONCATENATED MODULE: ./src/features/role/RoleService.js






var RoleService_RoleService = function (_BaseService) {
  inherits_default()(RoleService, _BaseService);

  function RoleService() {
    classCallCheck_default()(this, RoleService);

    return possibleConstructorReturn_default()(this, (RoleService.__proto__ || get_prototype_of_default()(RoleService)).call(this, 'roles'));
  }

  return RoleService;
}(features_BaseService);

RoleService_RoleService.ADMIN = 'admin';
RoleService_RoleService.ANALISTA = 'analista';
RoleService_RoleService.ADMIN_CLIENTE = 'admin_cliente';
RoleService_RoleService.USUARIO_CLIENTE = 'usuario_cliente';
RoleService_RoleService.MASTER = 'master';
/* harmony default export */ var role_RoleService = (RoleService_RoleService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/user/UserForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var UserForm = ({
  name: 'user-form',
  mixins: [CrudMixin],
  data: function data() {
    return {
      disabledClient: false,
      showAlert: false,
      roleId: null,
      roles: [],
      clients: [],
      client_id: null,
      selectedRoles: [],
      api_user: 'nao',
      roleService: new role_RoleService(),
      clientService: new client_ClientService()
    };
  },
  created: function created() {
    var user = this.$store.state.currentUser;
    if (!user_UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.client_id = user.client.id;
      this.disabledClient = true;
    }
    this.loadClient();
  },

  methods: {
    initCrud: function initCrud() {
      var _this = this;

      this.serviceType = user_UserService;
      this.routerName = 'user';
      this.componentType = 'FORM';

      this.roleService.query().then(function (data) {
        _this.roles = data;
      });
    },
    beforeSave: function beforeSave() {
      this.resource.client_id = this.client_id ? this.client_id : null;
      this.resource.roles = [{ id: this.roleId }];
      this.resource.api_user = this.api_user;
    },
    afterLoadResource: function afterLoadResource() {
      this.roleId = this.resource.roles.length > 0 ? this.resource.roles[0].id : null;
      this.client_id = this.resource.client_id;
      this.api_user = this.resource.api_token ? 'sim' : 'não';
    },
    loadClient: function loadClient() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.clientService.query().then(function (data) {
                  _this2.clients = data;
                  if (_this2.clients.length === 0) {
                    _this2.showAlert = true;
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25469fd1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/user/UserForm.vue
var UserForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nome","counter":100,"error-messages":_vm.validationErrors.name},model:{value:(_vm.resource.name),callback:function ($$v) {_vm.$set(_vm.resource, "name", $$v)},expression:"resource.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email","counter":100,"error-messages":_vm.validationErrors.email},model:{value:(_vm.resource.email),callback:function ($$v) {_vm.$set(_vm.resource, "email", $$v)},expression:"resource.email"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","hint":"Vincular um cliente a este usuário (deixe em branco caso não queira vincular nenhum cliente)","persistent-hint":"","clearable":"","required":"","disabled":(_vm.disabledClient || _vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","placeholder":"Selecione um cliente","error-messages":_vm.validationErrors.client_id},model:{value:(_vm.client_id),callback:function ($$v) {_vm.client_id=$$v},expression:"client_id"}}),_vm._v(" "),_c('v-radio-group',{attrs:{"required":"","error-messages":_vm.validationErrors['roles.id']},model:{value:(_vm.roleId),callback:function ($$v) {_vm.roleId=$$v},expression:"roleId"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('strong',[_vm._v("Perfil de Usuário:")])]),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('v-radio',{key:role.id,attrs:{"label":role.title,"value":role.id}})})],2),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.api_user),callback:function ($$v) {_vm.api_user=$$v},expression:"api_user"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('strong',[_vm._v("Usuário de API:")])]),_vm._v(" "),_c('v-radio',{attrs:{"label":"SIM","value":"sim"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"NÃO","value":"nao"}})],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n        Não existem clientes cadastrados no sistema.\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var UserForm_staticRenderFns = []
var UserForm_esExports = { render: UserForm_render, staticRenderFns: UserForm_staticRenderFns }
/* harmony default export */ var user_UserForm = (UserForm_esExports);
// CONCATENATED MODULE: ./src/features/user/UserForm.vue
var UserForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserForm___vue_template_functional__ = false
/* styles */
var UserForm___vue_styles__ = null
/* scopeId */
var UserForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserForm___vue_module_identifier__ = null
var UserForm_Component = UserForm_normalizeComponent(
  UserForm,
  user_UserForm,
  UserForm___vue_template_functional__,
  UserForm___vue_styles__,
  UserForm___vue_scopeId__,
  UserForm___vue_module_identifier__
)

/* harmony default export */ var features_user_UserForm = (UserForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/client/ClientList.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ClientList = ({
  name: 'client-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      active: false,
      headers: [{
        text: this.$t('attributes.name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.client.cnpj'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.client.status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = client_ClientService;
      this.routerName = 'client';
    },
    toggleStatus: function toggleStatus(_ref) {
      var _this = this;

      var id = _ref.id;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return client_ClientService.toggleStatus({ id: id });

              case 2:
                _this.search(_this.paginator.currentPage);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710ba518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/client/ClientList.vue
var ClientList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'client-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("prCnpj")(props.item.cnpj))+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.active ? "Ativo" : "Inativo")+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":props.item.active ? 'success' : 'dark',"flat":"","icon":""},on:{"click":function($event){_vm.toggleStatus({ id: props.item.id })}},slot:"activator"},[(props.item.active)?_c('v-icon',[_vm._v("toggle_on")]):_c('v-icon',[_vm._v("toggle_off")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.active ? "Desativar" : "Ativar"))])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, props.item.name)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var ClientList_staticRenderFns = []
var ClientList_esExports = { render: ClientList_render, staticRenderFns: ClientList_staticRenderFns }
/* harmony default export */ var client_ClientList = (ClientList_esExports);
// CONCATENATED MODULE: ./src/features/client/ClientList.vue
var ClientList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClientList___vue_template_functional__ = false
/* styles */
var ClientList___vue_styles__ = null
/* scopeId */
var ClientList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClientList___vue_module_identifier__ = null
var ClientList_Component = ClientList_normalizeComponent(
  ClientList,
  client_ClientList,
  ClientList___vue_template_functional__,
  ClientList___vue_styles__,
  ClientList___vue_scopeId__,
  ClientList___vue_module_identifier__
)

/* harmony default export */ var features_client_ClientList = (ClientList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/client/ClientForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ClientForm = ({
  name: 'client-form',
  mixins: [CrudMixin],
  methods: {
    initCrud: function initCrud() {
      this.serviceType = client_ClientService;
      this.routerName = 'client';
      this.componentType = 'FORM';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2d8afe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/client/ClientForm.vue
var ClientForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"Nome","counter":100,"required":"","error-messages":_vm.validationErrors.name},model:{value:(_vm.resource.name),callback:function ($$v) {_vm.$set(_vm.resource, "name", $$v)},expression:"resource.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('##.###.###/####-##'),expression:"'##.###.###/####-##'"}],attrs:{"required":"","error-messages":_vm.validationErrors.cnpj,"label":"CNPJ"},model:{value:(_vm.resource.cnpj),callback:function ($$v) {_vm.$set(_vm.resource, "cnpj", $$v)},expression:"resource.cnpj"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var ClientForm_staticRenderFns = []
var ClientForm_esExports = { render: ClientForm_render, staticRenderFns: ClientForm_staticRenderFns }
/* harmony default export */ var client_ClientForm = (ClientForm_esExports);
// CONCATENATED MODULE: ./src/features/client/ClientForm.vue
var ClientForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClientForm___vue_template_functional__ = false
/* styles */
var ClientForm___vue_styles__ = null
/* scopeId */
var ClientForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClientForm___vue_module_identifier__ = null
var ClientForm_Component = ClientForm_normalizeComponent(
  ClientForm,
  client_ClientForm,
  ClientForm___vue_template_functional__,
  ClientForm___vue_styles__,
  ClientForm___vue_scopeId__,
  ClientForm___vue_module_identifier__
)

/* harmony default export */ var features_client_ClientForm = (ClientForm_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-datepicker/lib/index.js
var lib = __webpack_require__("Ppbp");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/features/cycle/CycleService.js






var CycleService_CycleService = function (_BaseService) {
  inherits_default()(CycleService, _BaseService);

  function CycleService() {
    classCallCheck_default()(this, CycleService);

    return possibleConstructorReturn_default()(this, (CycleService.__proto__ || get_prototype_of_default()(CycleService)).call(this, 'cycles'));
  }

  return CycleService;
}(features_BaseService);

/* harmony default export */ var cycle_CycleService = (CycleService_CycleService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/cycle/CycleList.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var CycleList = ({
  name: 'cycle-list',
  mixins: [CrudMixin],
  components: {
    DatePicker: lib_default.a
  },
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      activeOptions: [{ description: 'ATIVO', value: 'sim' }, { description: 'INATIVO', value: 'nao' }, { description: 'TODOS', value: null }],
      lang: 'pt-br',
      loader: null,
      endDate: null,
      startDate: null,
      clientId: null,
      active: 'sim',
      name: null,
      clients: [],
      headers: [{
        text: this.$t('attributes.name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.client.name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.cycle.start_date'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.cycle.end_date'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.cycle.note'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.cycle.qtd_hours'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.cycle.status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      clientService: new client_ClientService()
    };
  },
  created: function created() {
    this.loadCombos();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = cycle_CycleService;
      this.routerName = 'cycle';
    },
    applyFilters: function applyFilters(filter) {
      var params = {
        name: this.name,
        active: this.active,
        client_id: this.clientId,
        start_date: this.startDate,
        end_date: this.endDate
      };
      return assign_default()(filter, params);
    },
    loadCombos: function loadCombos() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.clientService.query();

              case 2:
                _this.clients = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    startDateBeforeEndDate: function startDateBeforeEndDate() {
      var dateEnd = null;
      if (this.endDate && this.endDate !== '') {
        dateEnd = moment_default()(this.endDate).toDate();
      }
      return dateEnd;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748b571c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/cycle/CycleList.vue
var CycleList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'cycle-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-card',{staticClass:"pa-3"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t('views.fields.cycle.start_date')))]),_vm._v(" "),_c('date-picker',{attrs:{"placeholder":"Selecione a data","not-after":_vm.startDateBeforeEndDate(),"lang":_vm.lang,"editable":false,"format":"DD/MM/YYYY","clearable":""},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t('views.fields.cycle.end_date')))]),_vm._v(" "),_c('date-picker',{attrs:{"placeholder":"Selecione a data","not-before":_vm.startDate,"lang":_vm.lang,"editable":false,"disabled":(!_vm.startDate || _vm.startDate === ''),"format":"DD/MM/YYYY","clearable":""},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Nome do Ciclo"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","clearable":"","disabled":_vm.clients.length === 0,"label":"Selecione um cliente"},model:{value:(_vm.clientId),callback:function ($$v) {_vm.clientId=$$v},expression:"clientId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.activeOptions,"item-text":"description","item-value":"value","label":"Status do Ciclo"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md12":"","text-md-center":""}},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.search()}}},[_c('v-icon',[_vm._v("search")]),_vm._v("\n              Pesquisar\n            ")],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.client.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("prDate")(props.item.start_date))+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("prDate")(props.item.end_date))+"\n          ")]),_vm._v(" "),_c('td',[(props.item.note)?_c('v-tooltip',{staticClass:"mouse-over",attrs:{"top":""}},[_c('v-icon',{attrs:{"slot":"activator","dark":"","color":"primary"},slot:"activator"},[_vm._v("info")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.note))])],1):_vm._e(),_vm._v(" "),(!props.item.note)?_c('span',[_vm._v("Sem observação")]):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.qtd_hours)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.active === 'sim' ? 'ATIVO' : 'INATIVO')+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, 'o clico selecionado')}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var CycleList_staticRenderFns = []
var CycleList_esExports = { render: CycleList_render, staticRenderFns: CycleList_staticRenderFns }
/* harmony default export */ var cycle_CycleList = (CycleList_esExports);
// CONCATENATED MODULE: ./src/features/cycle/CycleList.vue
function CycleList_injectStyle (ssrContext) {
  __webpack_require__("4IFh")
}
var CycleList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CycleList___vue_template_functional__ = false
/* styles */
var CycleList___vue_styles__ = CycleList_injectStyle
/* scopeId */
var CycleList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CycleList___vue_module_identifier__ = null
var CycleList_Component = CycleList_normalizeComponent(
  CycleList,
  cycle_CycleList,
  CycleList___vue_template_functional__,
  CycleList___vue_styles__,
  CycleList___vue_scopeId__,
  CycleList___vue_module_identifier__
)

/* harmony default export */ var features_cycle_CycleList = (CycleList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/cycle/CycleForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var CycleForm = ({
  name: 'cycle-form',
  mixins: [CrudMixin],
  components: { DatePicker: lib_default.a },
  data: function data() {
    return {
      activeOptions: [{ description: 'ATIVO', value: 'sim' }, { description: 'INATIVO', value: 'nao' }],
      showAlert: false,
      lang: 'pt-br',
      clients: [],
      client: {},
      clientService: new client_ClientService()
    };
  },
  created: function created() {
    this.loadClient();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = cycle_CycleService;
      this.routerName = 'cycle';
      this.componentType = 'FORM';
    },
    beforeSave: function beforeSave() {
      this.resource.client_id = this.client ? this.client.id : null;
    },
    afterLoadResource: function afterLoadResource() {
      this.clients.push(this.resource.client);
      this.client = { id: this.resource.client.id, name: this.resource.client.name };
    },
    loadClient: function loadClient() {
      var _this = this;

      this.clientService.query().then(function (data) {
        _this.clients = data;
        if (_this.clients.length === 0) _this.showAlert = true;
      });
    },
    endDateBeforeStartDate: function endDateBeforeStartDate() {
      var dateStart = new Date();
      if (this.resource.start_date && this.resource.start_date !== '') {
        dateStart = moment_default()(this.resource.start_date).toDate();
      }
      return dateStart;
    },
    startDateBeforeEndDate: function startDateBeforeEndDate() {
      var dateEnd = null;
      if (this.resource.end_date && this.resource.end_date !== '') {
        dateEnd = moment_default()(this.resource.end_date).toDate();
      }
      return dateEnd;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf3e7d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/cycle/CycleForm.vue
var CycleForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t('views.fields.cycle.start_date')))]),_vm._v(" "),_c('date-picker',{attrs:{"placeholder":"Selecione a data","not-after":_vm.startDateBeforeEndDate(),"lang":_vm.lang,"editable":false,"format":"DD/MM/YYYY","error-messages":_vm.validationErrors.start_date,"clearable":""},model:{value:(_vm.resource.start_date),callback:function ($$v) {_vm.$set(_vm.resource, "start_date", $$v)},expression:"resource.start_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t('views.fields.cycle.end_date')))]),_vm._v(" "),_c('date-picker',{attrs:{"placeholder":"Selecione a data","not-before":_vm.resource.start_date,"lang":_vm.lang,"editable":false,"disabled":(!_vm.resource.start_date || _vm.resource.start_date === ''),"format":"DD/MM/YYYY","error-messages":_vm.validationErrors.end_date,"clearable":""},model:{value:(_vm.resource.end_date),callback:function ($$v) {_vm.$set(_vm.resource, "end_date", $$v)},expression:"resource.end_date"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"name":"name","label":_vm.$t('views.fields.cycle.name'),"error-messages":_vm.validationErrors.name},model:{value:(_vm.resource.name),callback:function ($$v) {_vm.$set(_vm.resource, "name", $$v)},expression:"resource.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","hint":"Vincular um cliente a este ciclo","required":"","return-object":"","persistent-hint":"","clearable":"","disabled":(_vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","error-messages":_vm.validationErrors.client_id,"label":"Selecione um cliente"},model:{value:(_vm.client),callback:function ($$v) {_vm.client=$$v},expression:"client"}})],1),_vm._v(" "),(_vm.resource.id)?_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.activeOptions,"item-text":"description","item-value":"value","error-messages":_vm.validationErrors.active,"label":"Status do Ciclo"},model:{value:(_vm.resource.active),callback:function ($$v) {_vm.$set(_vm.resource, "active", $$v)},expression:"resource.active"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{attrs:{"mask":'###',"label":"Quantidade Horas","required":"","error-messages":_vm.validationErrors.qtd_hours},model:{value:(_vm.resource.qtd_hours),callback:function ($$v) {_vm.$set(_vm.resource, "qtd_hours", $$v)},expression:"resource.qtd_hours"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-textarea',{attrs:{"name":"note","label":_vm.$t('views.fields.cycle.note')},model:{value:(_vm.resource.note),callback:function ($$v) {_vm.$set(_vm.resource, "note", $$v)},expression:"resource.note"}})],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n        Não existem clientes cadastrados no sistema.\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","disabled":(_vm.clients.length === 0),"loading":_vm.saveLoading}},[_vm._v("\n          Salvar\n        ")])],1)],1)],1)}
var CycleForm_staticRenderFns = []
var CycleForm_esExports = { render: CycleForm_render, staticRenderFns: CycleForm_staticRenderFns }
/* harmony default export */ var cycle_CycleForm = (CycleForm_esExports);
// CONCATENATED MODULE: ./src/features/cycle/CycleForm.vue
var CycleForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CycleForm___vue_template_functional__ = false
/* styles */
var CycleForm___vue_styles__ = null
/* scopeId */
var CycleForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CycleForm___vue_module_identifier__ = null
var CycleForm_Component = CycleForm_normalizeComponent(
  CycleForm,
  cycle_CycleForm,
  CycleForm___vue_template_functional__,
  CycleForm___vue_styles__,
  CycleForm___vue_scopeId__,
  CycleForm___vue_module_identifier__
)

/* harmony default export */ var features_cycle_CycleForm = (CycleForm_Component.exports);

// CONCATENATED MODULE: ./src/features/project/ProjectService.js







var ProjectService_ProjectService = function (_BaseService) {
  inherits_default()(ProjectService, _BaseService);

  function ProjectService() {
    classCallCheck_default()(this, ProjectService);

    return possibleConstructorReturn_default()(this, (ProjectService.__proto__ || get_prototype_of_default()(ProjectService)).call(this, 'projects'));
  }

  createClass_default()(ProjectService, null, [{
    key: 'toggleStatus',
    value: function toggleStatus(_ref) {
      var id = _ref.id;

      return features_BaseService.request('POST', 'projects/toggle-status', { id: id });
    }
  }]);

  return ProjectService;
}(features_BaseService);

/* harmony default export */ var project_ProjectService = (ProjectService_ProjectService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/project/ProjectList.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ProjectList = ({
  name: 'project-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.project.responsible_name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.project.responsible_email'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.project.responsible_tel'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.client.name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.project.status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = project_ProjectService;
      this.routerName = 'project';
    },
    toggleStatus: function toggleStatus(_ref) {
      var _this = this;

      var id = _ref.id;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return project_ProjectService.toggleStatus({ id: id });

              case 2:
                _this.search(_this.paginator.currentPage);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ec34c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/project/ProjectList.vue
var ProjectList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'project-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.responsible_name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.responsible_email)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.responsible_tel)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.client.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.active ? "Ativo" : "Inativo")+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":props.item.active ? 'success' : 'dark',"flat":"","icon":""},on:{"click":function($event){_vm.toggleStatus({ id: props.item.id })}},slot:"activator"},[(props.item.active)?_c('v-icon',[_vm._v("toggle_on")]):_c('v-icon',[_vm._v("toggle_off")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.active ? "Desativar" : "Ativar"))])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, props.item.name)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var ProjectList_staticRenderFns = []
var ProjectList_esExports = { render: ProjectList_render, staticRenderFns: ProjectList_staticRenderFns }
/* harmony default export */ var project_ProjectList = (ProjectList_esExports);
// CONCATENATED MODULE: ./src/features/project/ProjectList.vue
var ProjectList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProjectList___vue_template_functional__ = false
/* styles */
var ProjectList___vue_styles__ = null
/* scopeId */
var ProjectList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProjectList___vue_module_identifier__ = null
var ProjectList_Component = ProjectList_normalizeComponent(
  ProjectList,
  project_ProjectList,
  ProjectList___vue_template_functional__,
  ProjectList___vue_styles__,
  ProjectList___vue_scopeId__,
  ProjectList___vue_module_identifier__
)

/* harmony default export */ var features_project_ProjectList = (ProjectList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/project/ProjectForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ProjectForm = ({
  name: 'project-form',
  mixins: [CrudMixin],
  data: function data() {
    return {
      showAlert: false,
      clients: [],
      client: {},
      clientService: new client_ClientService()
    };
  },
  created: function created() {
    var _this = this;

    this.clientService.query().then(function (data) {
      _this.clients = data;
      if (_this.clients.length === 0) {
        _this.showAlert = true;
      }
    });
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = project_ProjectService;
      this.routerName = 'project';
      this.componentType = 'FORM';
    },
    beforeSave: function beforeSave() {
      this.resource.client_id = this.client ? this.client.id : null;
    },
    afterLoadResource: function afterLoadResource() {
      this.clients.push(this.resource.client);
      this.client = { id: this.resource.client.id, name: this.resource.client.name };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bdcc2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/project/ProjectForm.vue
var ProjectForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Nome do Projeto","counter":100,"required":"","error-messages":_vm.validationErrors.name},model:{value:(_vm.resource.name),callback:function ($$v) {_vm.$set(_vm.resource, "name", $$v)},expression:"resource.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Nome do Responsável","counter":100,"required":"","error-messages":_vm.validationErrors.responsible_name},model:{value:(_vm.resource.responsible_name),callback:function ($$v) {_vm.$set(_vm.resource, "responsible_name", $$v)},expression:"resource.responsible_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"type":"email","label":"Email do Responsável","counter":100,"required":"","error-messages":_vm.validationErrors.responsible_email},model:{value:(_vm.resource.responsible_email),callback:function ($$v) {_vm.$set(_vm.resource, "responsible_email", $$v)},expression:"resource.responsible_email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(['(##) ####-####', '(##) #####-####']),expression:"['(##) ####-####', '(##) #####-####']"}],attrs:{"label":"Telefone do Responsável","required":"","error-messages":_vm.validationErrors.responsible_tel},model:{value:(_vm.resource.responsible_tel),callback:function ($$v) {_vm.$set(_vm.resource, "responsible_tel", $$v)},expression:"resource.responsible_tel"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","hint":"Vincular um cliente a este projeto","required":"","return-object":"","persistent-hint":"","clearable":"","disabled":(_vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","placeholder":"Selecione um cliente","error-messages":_vm.validationErrors.client_id},model:{value:(_vm.client),callback:function ($$v) {_vm.client=$$v},expression:"client"}})],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n        Não existem clientes cadastrados no sistema.\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","disabled":(_vm.clients.length === 0),"loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var ProjectForm_staticRenderFns = []
var ProjectForm_esExports = { render: ProjectForm_render, staticRenderFns: ProjectForm_staticRenderFns }
/* harmony default export */ var project_ProjectForm = (ProjectForm_esExports);
// CONCATENATED MODULE: ./src/features/project/ProjectForm.vue
var ProjectForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProjectForm___vue_template_functional__ = false
/* styles */
var ProjectForm___vue_styles__ = null
/* scopeId */
var ProjectForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProjectForm___vue_module_identifier__ = null
var ProjectForm_Component = ProjectForm_normalizeComponent(
  ProjectForm,
  project_ProjectForm,
  ProjectForm___vue_template_functional__,
  ProjectForm___vue_styles__,
  ProjectForm___vue_scopeId__,
  ProjectForm___vue_module_identifier__
)

/* harmony default export */ var features_project_ProjectForm = (ProjectForm_Component.exports);

// CONCATENATED MODULE: ./src/features/table-manager/TableManagerService.js






var TableManagerService_TableManagerService = function (_BaseService) {
  inherits_default()(TableManagerService, _BaseService);

  function TableManagerService() {
    classCallCheck_default()(this, TableManagerService);

    return possibleConstructorReturn_default()(this, (TableManagerService.__proto__ || get_prototype_of_default()(TableManagerService)).call(this, 'tables-manager'));
  }

  return TableManagerService;
}(features_BaseService);

/* harmony default export */ var table_manager_TableManagerService = (TableManagerService_TableManagerService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/table-manager/TableManagerForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var TableManagerForm = ({
  name: 'table-manager-form',
  mixins: [CrudMixin],
  data: function data() {
    return {
      users: [],
      userService: new user_UserService()
    };
  },
  created: function created() {
    this.loadCombos();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = table_manager_TableManagerService;
      this.routerName = 'table-manager';
      this.componentType = 'FORM';
    },
    beforeSave: function beforeSave() {
      if (this.resource.table_name) {
        this.resource.table_name = this.resource.table_name.toLowerCase();
      }
    },
    loadCombos: function loadCombos() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.userService.query();

              case 2:
                _this.users = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403d428b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/table-manager/TableManagerForm.vue
var TableManagerForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"Nome da Tabela","counter":100,"required":"","error-messages":_vm.validationErrors.table_name},model:{value:(_vm.resource.table_name),callback:function ($$v) {_vm.$set(_vm.resource, "table_name", $$v)},expression:"resource.table_name"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.users,"item-text":"name","item-value":"id","clearable":"","return-object":"","multiple":"","chips":"","small-chips":"","error-messages":_vm.validationErrors.users,"label":"Selecione os usuários"},model:{value:(_vm.resource.users),callback:function ($$v) {_vm.$set(_vm.resource, "users", $$v)},expression:"resource.users"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var TableManagerForm_staticRenderFns = []
var TableManagerForm_esExports = { render: TableManagerForm_render, staticRenderFns: TableManagerForm_staticRenderFns }
/* harmony default export */ var table_manager_TableManagerForm = (TableManagerForm_esExports);
// CONCATENATED MODULE: ./src/features/table-manager/TableManagerForm.vue
var TableManagerForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TableManagerForm___vue_template_functional__ = false
/* styles */
var TableManagerForm___vue_styles__ = null
/* scopeId */
var TableManagerForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TableManagerForm___vue_module_identifier__ = null
var TableManagerForm_Component = TableManagerForm_normalizeComponent(
  TableManagerForm,
  table_manager_TableManagerForm,
  TableManagerForm___vue_template_functional__,
  TableManagerForm___vue_styles__,
  TableManagerForm___vue_scopeId__,
  TableManagerForm___vue_module_identifier__
)

/* harmony default export */ var features_table_manager_TableManagerForm = (TableManagerForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/table-manager/TableManagerList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var TableManagerList = ({
  name: 'table-manager-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.table_manager.table_name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.table_manager.created_by'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.table_manager.users'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = table_manager_TableManagerService;
      this.routerName = 'table-manager';
    },
    joinUsersName: function joinUsersName(users) {
      var joinNames = 'Nenhum usuário associado';
      if (users.length > 0) {
        var names = Object(lodash["map"])(users, function (user) {
          return ' ' + user.name;
        });
        joinNames = names.join(',');
      }
      return joinNames;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08dad5d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/table-manager/TableManagerList.vue
var TableManagerList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'table-manager-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.table_name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.created_by.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm.joinUsersName(props.item.users))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, props.item.table_name)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var TableManagerList_staticRenderFns = []
var TableManagerList_esExports = { render: TableManagerList_render, staticRenderFns: TableManagerList_staticRenderFns }
/* harmony default export */ var table_manager_TableManagerList = (TableManagerList_esExports);
// CONCATENATED MODULE: ./src/features/table-manager/TableManagerList.vue
var TableManagerList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TableManagerList___vue_template_functional__ = false
/* styles */
var TableManagerList___vue_styles__ = null
/* scopeId */
var TableManagerList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TableManagerList___vue_module_identifier__ = null
var TableManagerList_Component = TableManagerList_normalizeComponent(
  TableManagerList,
  table_manager_TableManagerList,
  TableManagerList___vue_template_functional__,
  TableManagerList___vue_styles__,
  TableManagerList___vue_scopeId__,
  TableManagerList___vue_module_identifier__
)

/* harmony default export */ var features_table_manager_TableManagerList = (TableManagerList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/settings/Settings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Settings = ({
  name: 'settings',
  data: function data() {
    return {
      endPoint: "/api/v1",
      titleBox: 'Configurações',
      pagination: { rowsPerPage: -1 },
      headersRequest: [{ text: 'Parâmetro', sortable: false }, { text: 'Tipo', sortable: false }, { text: 'Formato', sortable: false }, { text: 'Obrigatório', sortable: false }, { text: 'Opções disponíveis', sortable: false }, { text: 'Exemplo', sortable: false }],
      requestItems: [{
        param: 'token',
        type: 'Texto',
        format: 'Padrão 60 caracteres',
        required: 'Sim',
        options: 'Sem opções',
        sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M'
      }, {
        param: 'called_id',
        type: 'Inteiro',
        format: 'Sem formato',
        required: 'Sim',
        options: 'Sem opções',
        sample: '1'
      }, {
        param: 'title',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'Finalizando o chamado'
      }, {
        param: 'date',
        type: 'Data',
        format: 'RFC 2822 date time',
        required: 'Não',
        options: 'Sem opções',
        sample: 'Sun Nov 29 2020 13:24:01 GMT-0300'
      }, {
        param: 'worked_hours',
        type: 'Texto',
        format: 'Hora sem os dois pontos',
        required: 'Não',
        options: 'Sem opções',
        sample: 'Exemplo para 10 horas (1000), exemplo para 5 horas (0500), exemplo para 30 minutos (0030)'
      }, {
        param: 'description',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'Descrição do chamado.'
      }, {
        param: 'called_status',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'aberto | fechado',
        sample: 'aberto'
      }, {
        param: 'priority',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'urgente | normal | baixo',
        sample: 'urgente'
      }],
      requestItemsLoadConf: [{
        param: 'token',
        type: 'Texto',
        format: 'Padrão 60 caracteres',
        required: 'Sim',
        options: 'Sem opções',
        sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M'
      }, {
        param: 'load_conf_id',
        type: 'Inteiro',
        format: 'Sem formato',
        required: 'Sim',
        options: 'Sem opções',
        sample: '1'
      }, {
        param: 'ds_job',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'CARGA_TSTE'
      }, {
        param: 'ds_map',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'Sem exemplo'
      }, {
        param: 'st_load',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'erro'
      }, {
        param: 'dt_start_load',
        type: 'Data',
        format: 'YYYY-MM-DD HH:mm:ss',
        required: 'Não',
        options: 'Sem opções',
        sample: '2021-11-16 12:00:00'
      }, {
        param: 'dt_end_load',
        type: 'Data',
        format: 'YYYY-MM-DD HH:mm:ss',
        required: 'Não',
        options: 'Sem opções',
        sample: '2021-11-16 12:00:00'
      }, {
        param: 'tx_log',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'erro na carga dos dados, campo texto era esperado para a coluna nom_funcionario'
      }],
      requestItemsLoadNotification: [{
        param: 'token',
        type: 'Texto',
        format: 'Padrão 60 caracteres',
        required: 'Sim',
        options: 'Sem opções',
        sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M'
      }, {
        param: 'load_log_id',
        type: 'Inteiro',
        format: 'Sem formato',
        required: 'Sim',
        options: 'Sem opções',
        sample: '1'
      }, {
        param: 'ds_notification_type',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'whatsApp'
      }, {
        param: 'ds_text',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'Foi identificado um erro na carga do projeto Ciclos teste.'
      }, {
        param: 'ds_group',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'AER'
      }, {
        param: 'dt_log_notification',
        type: 'Data',
        format: 'YYYY-MM-DD HH:mm:ss',
        required: 'Não',
        options: 'Sem opções',
        sample: '2021-11-16 12:00:00'
      }, {
        param: 'fl_send_notification',
        type: 'Inteiro',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: '1'
      }],
      requestItemsTableManager: [{
        param: 'token',
        type: 'Texto',
        format: 'Padrão 60 caracteres',
        required: 'Sim',
        options: 'Sem opções',
        sample: '11GROe1Ry5Fy3WCDADO3YeX5W7ABRKX1eXLckrYzA7OOmdoQcx8jhCDy0H9M'
      }, {
        param: 'tableName',
        type: 'Texto',
        format: 'Sem formato',
        required: 'Não',
        options: 'Sem opções',
        sample: 'call_histories'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff4a760a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/settings/Settings.vue
var Settings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('template',{slot:"header"},[_c('div',[_c('strong',[_vm._v("API - Busca os registros nas tabelas ou views informadas")]),_vm._v(" "),_c('small',[_vm._v("(ENDPOINT: "+_vm._s((_vm.endPoint + "/dynamic-select/select-table-or-view"))+" | MÉTODO: GET)")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Requisição")]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRequest,"items":_vm.requestItemsTableManager,"pagination":_vm.pagination,"hide-actions":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.param))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.format))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.required))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.options))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.sample))])]}}])}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Resposta: Retorna um ou mais dados da tabela informada nos parâmetros.")])],1)],2),_vm._v(" "),_c('v-expansion-panel-content',[_c('template',{slot:"header"},[_c('div',[_c('strong',[_vm._v("API - Atualização de Chamado ")]),_vm._v(" "),_c('small',[_vm._v("(ENDPOINT: "+_vm._s((_vm.endPoint + "/called-update"))+" | MÉTODO: POST)")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Requisição")]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRequest,"items":_vm.requestItems,"pagination":_vm.pagination,"hide-actions":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.param))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.format))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.required))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.options))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.sample))])]}}])}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Resposta - Exemplo(JSON)")]),_vm._v(" "),_c('code',[_vm._v("\n  {\n    \"called_id\": \"1\",\n    \"title\": \"Testando direto via api\",\n    \"date\": {\n        \"date\": \"2020-11-29 16:15:01.000000\",\n        \"timezone_type\": 1,\n        \"timezone\": \"-03:00\"\n    },\n    \"worked_hours\": 780,\n    \"description\": \"Testando direto via api\",\n    \"user_id\": 1,\n    \"before_called_status_id\": 1,\n    \"after_called_status_id\": 1,\n    \"before_priority_id\": 2,\n    \"after_priority_id\": 2,\n    \"updated_at\": \"2020-11-29 19:36:16\",\n    \"created_at\": \"2020-11-29 19:36:16\",\n    \"id\": 13\n  }\n        ")])],1)],2),_vm._v(" "),_c('v-expansion-panel-content',[_c('template',{slot:"header"},[_c('div',[_c('strong',[_vm._v("API - Inserção de dados na tabela load_log ")]),_vm._v(" "),_c('small',[_vm._v("(ENDPOINT: "+_vm._s((_vm.endPoint + "/insert-load-log"))+" | MÉTODO: POST)")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Requisição")]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRequest,"items":_vm.requestItemsLoadConf,"pagination":_vm.pagination,"hide-actions":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.param))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.format))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.required))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.options))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.sample))])]}}])}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Resposta: Registro inserido com sucesso!")])],1)],2),_vm._v(" "),_c('v-expansion-panel-content',[_c('template',{slot:"header"},[_c('div',[_c('strong',[_vm._v("API - Inserção de dados na tabela load_notification ")]),_vm._v(" "),_c('small',[_vm._v("(ENDPOINT: "+_vm._s((_vm.endPoint + "/insert-load-notification"))+" | MÉTODO: POST)")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Requisição")]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRequest,"items":_vm.requestItemsLoadNotification,"pagination":_vm.pagination,"hide-actions":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.param))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.format))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.required))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.options))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.sample))])]}}])}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Resposta: Registro inserido com sucesso!")])],1)],2)],1)}
var Settings_staticRenderFns = []
var Settings_esExports = { render: Settings_render, staticRenderFns: Settings_staticRenderFns }
/* harmony default export */ var settings_Settings = (Settings_esExports);
// CONCATENATED MODULE: ./src/features/settings/Settings.vue
var Settings_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Settings___vue_template_functional__ = false
/* styles */
var Settings___vue_styles__ = null
/* scopeId */
var Settings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Settings___vue_module_identifier__ = null
var Settings_Component = Settings_normalizeComponent(
  Settings,
  settings_Settings,
  Settings___vue_template_functional__,
  Settings___vue_styles__,
  Settings___vue_scopeId__,
  Settings___vue_module_identifier__
)

/* harmony default export */ var features_settings_Settings = (Settings_Component.exports);

// CONCATENATED MODULE: ./src/features/billing-report/BillingReportService.js






var BillingReportService_BillingReportService = function (_BaseService) {
  inherits_default()(BillingReportService, _BaseService);

  function BillingReportService() {
    classCallCheck_default()(this, BillingReportService);

    return possibleConstructorReturn_default()(this, (BillingReportService.__proto__ || get_prototype_of_default()(BillingReportService)).call(this, 'billing-report'));
  }

  return BillingReportService;
}(features_BaseService);

/* harmony default export */ var billing_report_BillingReportService = (BillingReportService_BillingReportService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/billing-report/BillingReportList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var BillingReportList = ({
  name: 'billing-report-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      cycleStatus: [{ id: 1, description: 'ATIVO', value: 'sim' }, { id: 2, description: 'INATIVO', value: 'nao' }, { id: 3, description: 'TODOS', value: 'todos' }],
      filter: {},
      headers: [{
        text: this.$t('attributes.billing_report.client'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.billing_report.hours_performed'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.billing_report.billed_hours'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.billing_report.authorized_by'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.billing_report.cycle'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.billing_report.cycle_status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = billing_report_BillingReportService;
      this.routerName = 'billing-report';
    },
    applyFilters: function applyFilters(filter) {
      return assign_default()(filter, this.filter);
    },
    getColor: function getColor(cycleStatus) {
      var color = 'gray';
      if (cycleStatus.toUpperCase() === 'sim'.toUpperCase()) {
        color = 'green';
      }
      return color;
    },
    clearFilters: function clearFilters() {
      this.filter = {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afa31ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/billing-report/BillingReportList.vue
var BillingReportList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'billing-report-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"pa-3"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"name":"clientName","label":"Cliente"},model:{value:(_vm.filter.client_name),callback:function ($$v) {_vm.$set(_vm.filter, "client_name", $$v)},expression:"filter.client_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"name":"cycleName","label":"Nome do Ciclo"},model:{value:(_vm.filter.cycle_name),callback:function ($$v) {_vm.$set(_vm.filter, "cycle_name", $$v)},expression:"filter.cycle_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.cycleStatus,"item-text":"description","item-value":"value","clearable":"","label":"Status do Ciclo"},model:{value:(_vm.filter.cycle_status),callback:function ($$v) {_vm.$set(_vm.filter, "cycle_status", $$v)},expression:"filter.cycle_status"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","text-md-right":""}},[_c('v-btn',{attrs:{"flat":"","color":"error"},on:{"click":function($event){_vm.clearFilters()}}},[_c('v-icon',[_vm._v("close")]),_vm._v("\n            Limpar\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.search()}}},[_c('v-icon',[_vm._v("search")]),_vm._v("\n            Pesquisar\n          ")],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.cycle.client.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.hours_performed)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.billed_hours)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.authorized_by)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.cycle.name)+"\n          ")]),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"label":"","outline":"","color":_vm.getColor(props.item.cycle.active)}},[_vm._v("\n              "+_vm._s(props.item.cycle.active.toUpperCase() === 'sim'.toUpperCase() ? 'Ativo' : 'Inativo')+"\n            ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, props.item.cycle.name)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)],1)}
var BillingReportList_staticRenderFns = []
var BillingReportList_esExports = { render: BillingReportList_render, staticRenderFns: BillingReportList_staticRenderFns }
/* harmony default export */ var billing_report_BillingReportList = (BillingReportList_esExports);
// CONCATENATED MODULE: ./src/features/billing-report/BillingReportList.vue
var BillingReportList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BillingReportList___vue_template_functional__ = false
/* styles */
var BillingReportList___vue_styles__ = null
/* scopeId */
var BillingReportList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BillingReportList___vue_module_identifier__ = null
var BillingReportList_Component = BillingReportList_normalizeComponent(
  BillingReportList,
  billing_report_BillingReportList,
  BillingReportList___vue_template_functional__,
  BillingReportList___vue_styles__,
  BillingReportList___vue_scopeId__,
  BillingReportList___vue_module_identifier__
)

/* harmony default export */ var features_billing_report_BillingReportList = (BillingReportList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/billing-report/BillingReportForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var BillingReportForm = ({
  name: 'billing-report-form',
  mixins: [CrudMixin],
  data: function data() {
    return {
      loading: false,
      showAlert: false,
      cycleStatusList: [{ id: 1, description: 'ATIVO', value: 'sim' }, { id: 2, description: 'INATIVO', value: 'nao' }],
      cycles: [],
      clients: [],
      cycleStatus: null,
      client: null,
      cycleService: new cycle_CycleService(),
      clientService: new client_ClientService()
    };
  },

  watch: {
    client: function client() {
      this.loadCycles();
    },
    cycleStatus: function cycleStatus() {
      this.loadCycles();
    }
  },
  mounted: function mounted() {
    this.loadClient();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = billing_report_BillingReportService;
      this.routerName = 'billing-report';
      this.componentType = 'FORM';
    },
    afterLoadResource: function afterLoadResource() {
      this.resource.cycle_id = parseInt(this.resource.cycle_id, 10);
    },
    loadCycles: function loadCycles() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var filter;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = {};

                if (_this.client) {
                  filter.client_id = _this.client.id;
                }
                if (_this.cycleStatus) {
                  filter.active = _this.cycleStatus;
                }
                _context.next = 5;
                return _this.cycleService.query(filter);

              case 5:
                _this.cycles = _context.sent;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadClient: function loadClient() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.clientService.query();

              case 2:
                _this2.clients = _context2.sent;

                if (_this2.clients.length === 0) _this2.showAlert = true;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ce73de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/billing-report/BillingReportForm.vue
var BillingReportForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n        Não existem clientes cadastrados no sistema.\n      ")]),_vm._v(" "),(!_vm.showAlert)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","hint":"Selecione um cliente para filtrar os ciclos","required":"","return-object":"","persistent-hint":"","clearable":"","disabled":(_vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","error-messages":_vm.validationErrors.client_id,"label":"Selecione um cliente"},model:{value:(_vm.client),callback:function ($$v) {_vm.client=$$v},expression:"client"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.cycleStatusList,"item-text":"description","item-value":"value","clearable":"","label":"Status do Ciclo"},model:{value:(_vm.cycleStatus),callback:function ($$v) {_vm.cycleStatus=$$v},expression:"cycleStatus"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.showAlert)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.cycles,"item-text":"name","item-value":"id","no-data-text":"Nenhuma registro encontrado","required":"","hint":"Vincular um ciclo a este faturamento","label":"Selecione um ciclo","persistent-hint":"","disabled":(!_vm.client && !_vm.cycleStatus) || _vm.cycles.length === 0,"error-messages":_vm.validationErrors.cycle_id},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.name)+"\n            ")]}},{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('small',[_vm._v(_vm._s(_vm._f("prDate")(data.item.start_date))+" até "+_vm._s(_vm._f("prDate")(data.item.end_date)))])])],1)]]}}]),model:{value:(_vm.resource.cycle_id),callback:function ($$v) {_vm.$set(_vm.resource, "cycle_id", $$v)},expression:"resource.cycle_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"mask":"####","label":"Horas Executadas","disabled":!_vm.client && !_vm.cycleStatus,"required":"","error-messages":_vm.validationErrors.hours_performed},model:{value:(_vm.resource.hours_performed),callback:function ($$v) {_vm.$set(_vm.resource, "hours_performed", $$v)},expression:"resource.hours_performed"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"mask":"####","label":"Horas Faturadas","disabled":!_vm.client && !_vm.cycleStatus,"required":"","error-messages":_vm.validationErrors.billed_hours},model:{value:(_vm.resource.billed_hours),callback:function ($$v) {_vm.$set(_vm.resource, "billed_hours", $$v)},expression:"resource.billed_hours"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Autorizado Por","disabled":!_vm.client && !_vm.cycleStatus,"required":"","error-messages":_vm.validationErrors.authorized_by},model:{value:(_vm.resource.authorized_by),callback:function ($$v) {_vm.$set(_vm.resource, "authorized_by", $$v)},expression:"resource.authorized_by"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.showAlert)?_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","disabled":!_vm.client && !_vm.cycleStatus,"loading":_vm.saveLoading}},[_vm._v("Salvar")])],1):_vm._e()],1)],1)}
var BillingReportForm_staticRenderFns = []
var BillingReportForm_esExports = { render: BillingReportForm_render, staticRenderFns: BillingReportForm_staticRenderFns }
/* harmony default export */ var billing_report_BillingReportForm = (BillingReportForm_esExports);
// CONCATENATED MODULE: ./src/features/billing-report/BillingReportForm.vue
var BillingReportForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BillingReportForm___vue_template_functional__ = false
/* styles */
var BillingReportForm___vue_styles__ = null
/* scopeId */
var BillingReportForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BillingReportForm___vue_module_identifier__ = null
var BillingReportForm_Component = BillingReportForm_normalizeComponent(
  BillingReportForm,
  billing_report_BillingReportForm,
  BillingReportForm___vue_template_functional__,
  BillingReportForm___vue_styles__,
  BillingReportForm___vue_scopeId__,
  BillingReportForm___vue_module_identifier__
)

/* harmony default export */ var features_billing_report_BillingReportForm = (BillingReportForm_Component.exports);

// CONCATENATED MODULE: ./src/features/zoho-report-credential/ZohoCredentialService.js






var ZohoCredentialService_ZohoReportCredentialService = function (_BaseService) {
  inherits_default()(ZohoReportCredentialService, _BaseService);

  function ZohoReportCredentialService() {
    classCallCheck_default()(this, ZohoReportCredentialService);

    return possibleConstructorReturn_default()(this, (ZohoReportCredentialService.__proto__ || get_prototype_of_default()(ZohoReportCredentialService)).call(this, 'zoho-reports-credential'));
  }

  return ZohoReportCredentialService;
}(features_BaseService);

/* harmony default export */ var ZohoCredentialService = (ZohoCredentialService_ZohoReportCredentialService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/zoho-report-credential/ZohoReportCredentialList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ZohoReportCredentialList = ({
  name: 'zoho-report-credential-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.zoho.client_id'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.zoho.client_secret'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.zoho.refresh_token'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'right'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = ZohoCredentialService;
      this.routerName = 'zoho-report-credential';
      this.options.skipPagination = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdc28c0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/zoho-report-credential/ZohoReportCredentialList.vue
var ZohoReportCredentialList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.resources || _vm.resources.length === 0),expression:"!resources || resources.length === 0"}],attrs:{"icon":"","to":{ name: 'zoho-report-credential-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.client_id)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.client_secret)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.refresh_token)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var ZohoReportCredentialList_staticRenderFns = []
var ZohoReportCredentialList_esExports = { render: ZohoReportCredentialList_render, staticRenderFns: ZohoReportCredentialList_staticRenderFns }
/* harmony default export */ var zoho_report_credential_ZohoReportCredentialList = (ZohoReportCredentialList_esExports);
// CONCATENATED MODULE: ./src/features/zoho-report-credential/ZohoReportCredentialList.vue
var ZohoReportCredentialList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZohoReportCredentialList___vue_template_functional__ = false
/* styles */
var ZohoReportCredentialList___vue_styles__ = null
/* scopeId */
var ZohoReportCredentialList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ZohoReportCredentialList___vue_module_identifier__ = null
var ZohoReportCredentialList_Component = ZohoReportCredentialList_normalizeComponent(
  ZohoReportCredentialList,
  zoho_report_credential_ZohoReportCredentialList,
  ZohoReportCredentialList___vue_template_functional__,
  ZohoReportCredentialList___vue_styles__,
  ZohoReportCredentialList___vue_scopeId__,
  ZohoReportCredentialList___vue_module_identifier__
)

/* harmony default export */ var features_zoho_report_credential_ZohoReportCredentialList = (ZohoReportCredentialList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/zoho-report-credential/ZohoReportCredentialForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ZohoReportCredentialForm = ({
  name: 'zoho-report-credential-form',
  mixins: [CrudMixin],
  methods: {
    initCrud: function initCrud() {
      this.serviceType = ZohoCredentialService;
      this.routerName = 'zoho-report-credential';
      this.componentType = 'FORM';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a15164e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/zoho-report-credential/ZohoReportCredentialForm.vue
var ZohoReportCredentialForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Client ID","required":"","error-messages":_vm.validationErrors.client_id},model:{value:(_vm.resource.client_id),callback:function ($$v) {_vm.$set(_vm.resource, "client_id", $$v)},expression:"resource.client_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Client Secret","required":"","error-messages":_vm.validationErrors.client_secret},model:{value:(_vm.resource.client_secret),callback:function ($$v) {_vm.$set(_vm.resource, "client_secret", $$v)},expression:"resource.client_secret"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Refresh Token","required":"","error-messages":_vm.validationErrors.refresh_token},model:{value:(_vm.resource.refresh_token),callback:function ($$v) {_vm.$set(_vm.resource, "refresh_token", $$v)},expression:"resource.refresh_token"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var ZohoReportCredentialForm_staticRenderFns = []
var ZohoReportCredentialForm_esExports = { render: ZohoReportCredentialForm_render, staticRenderFns: ZohoReportCredentialForm_staticRenderFns }
/* harmony default export */ var zoho_report_credential_ZohoReportCredentialForm = (ZohoReportCredentialForm_esExports);
// CONCATENATED MODULE: ./src/features/zoho-report-credential/ZohoReportCredentialForm.vue
var ZohoReportCredentialForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZohoReportCredentialForm___vue_template_functional__ = false
/* styles */
var ZohoReportCredentialForm___vue_styles__ = null
/* scopeId */
var ZohoReportCredentialForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ZohoReportCredentialForm___vue_module_identifier__ = null
var ZohoReportCredentialForm_Component = ZohoReportCredentialForm_normalizeComponent(
  ZohoReportCredentialForm,
  zoho_report_credential_ZohoReportCredentialForm,
  ZohoReportCredentialForm___vue_template_functional__,
  ZohoReportCredentialForm___vue_styles__,
  ZohoReportCredentialForm___vue_scopeId__,
  ZohoReportCredentialForm___vue_module_identifier__
)

/* harmony default export */ var features_zoho_report_credential_ZohoReportCredentialForm = (ZohoReportCredentialForm_Component.exports);

// CONCATENATED MODULE: ./src/features/zoho-report/ZohoReportService.js






var ZohoReportService_ZohoReportService = function (_BaseService) {
  inherits_default()(ZohoReportService, _BaseService);

  function ZohoReportService() {
    classCallCheck_default()(this, ZohoReportService);

    return possibleConstructorReturn_default()(this, (ZohoReportService.__proto__ || get_prototype_of_default()(ZohoReportService)).call(this, 'zoho-reports'));
  }

  return ZohoReportService;
}(features_BaseService);

/* harmony default export */ var zoho_report_ZohoReportService = (ZohoReportService_ZohoReportService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/zoho-report/ZohoReportGroupList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ZohoReportGroupList = ({
  name: 'zoho-report-group-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.zoho.email'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.zoho.db_name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.zoho.table_name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'right'
      }]
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = zoho_report_ZohoReportService;
      this.routerName = 'zoho-report-group';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4711b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/zoho-report/ZohoReportGroupList.vue
var ZohoReportGroupList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'zoho-report-group-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.email)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.db_name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.table_name)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var ZohoReportGroupList_staticRenderFns = []
var ZohoReportGroupList_esExports = { render: ZohoReportGroupList_render, staticRenderFns: ZohoReportGroupList_staticRenderFns }
/* harmony default export */ var zoho_report_ZohoReportGroupList = (ZohoReportGroupList_esExports);
// CONCATENATED MODULE: ./src/features/zoho-report/ZohoReportGroupList.vue
var ZohoReportGroupList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZohoReportGroupList___vue_template_functional__ = false
/* styles */
var ZohoReportGroupList___vue_styles__ = null
/* scopeId */
var ZohoReportGroupList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ZohoReportGroupList___vue_module_identifier__ = null
var ZohoReportGroupList_Component = ZohoReportGroupList_normalizeComponent(
  ZohoReportGroupList,
  zoho_report_ZohoReportGroupList,
  ZohoReportGroupList___vue_template_functional__,
  ZohoReportGroupList___vue_styles__,
  ZohoReportGroupList___vue_scopeId__,
  ZohoReportGroupList___vue_module_identifier__
)

/* harmony default export */ var features_zoho_report_ZohoReportGroupList = (ZohoReportGroupList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/zoho-report/ZohoReportGroupForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ZohoReportGroupForm = ({
  name: 'zoho-report-group-form',
  mixins: [CrudMixin],
  methods: {
    initCrud: function initCrud() {
      this.serviceType = zoho_report_ZohoReportService;
      this.routerName = 'zoho-report-group';
      this.componentType = 'FORM';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4e76c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/zoho-report/ZohoReportGroupForm.vue
var ZohoReportGroupForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Email","required":"","error-messages":_vm.validationErrors.email},model:{value:(_vm.resource.email),callback:function ($$v) {_vm.$set(_vm.resource, "email", $$v)},expression:"resource.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Workspace","required":"","error-messages":_vm.validationErrors.db_name},model:{value:(_vm.resource.db_name),callback:function ($$v) {_vm.$set(_vm.resource, "db_name", $$v)},expression:"resource.db_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Tabela","required":"","error-messages":_vm.validationErrors.table_name},model:{value:(_vm.resource.table_name),callback:function ($$v) {_vm.$set(_vm.resource, "table_name", $$v)},expression:"resource.table_name"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var ZohoReportGroupForm_staticRenderFns = []
var ZohoReportGroupForm_esExports = { render: ZohoReportGroupForm_render, staticRenderFns: ZohoReportGroupForm_staticRenderFns }
/* harmony default export */ var zoho_report_ZohoReportGroupForm = (ZohoReportGroupForm_esExports);
// CONCATENATED MODULE: ./src/features/zoho-report/ZohoReportGroupForm.vue
var ZohoReportGroupForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZohoReportGroupForm___vue_template_functional__ = false
/* styles */
var ZohoReportGroupForm___vue_styles__ = null
/* scopeId */
var ZohoReportGroupForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ZohoReportGroupForm___vue_module_identifier__ = null
var ZohoReportGroupForm_Component = ZohoReportGroupForm_normalizeComponent(
  ZohoReportGroupForm,
  zoho_report_ZohoReportGroupForm,
  ZohoReportGroupForm___vue_template_functional__,
  ZohoReportGroupForm___vue_styles__,
  ZohoReportGroupForm___vue_scopeId__,
  ZohoReportGroupForm___vue_module_identifier__
)

/* harmony default export */ var features_zoho_report_ZohoReportGroupForm = (ZohoReportGroupForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/zoho-report/ZohoReportView.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ZohoReportView = ({
  name: 'zoho-report-view',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  watch: {
    groupId: function groupId() {
      this.getZohoReport();
    }
  },
  data: function data() {
    return {
      zohoReport: null,
      reportGroups: [],
      groupId: null
    };
  },
  beforeMount: function beforeMount() {
    this.loadCombos();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = zoho_report_ZohoReportService;
      this.routerName = 'zoho-report-view';
      this.onSearchInit = false;
    },
    getZohoReport: function getZohoReport() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.service.request('GET', 'get-view', null, { params: { id: _this.groupId } });

              case 3:
                response = _context.sent;

                _this.zohoReport = response.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.$log.error(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    openNewWindow: function openNewWindow() {
      window.open(this.zohoReport, '_blank');
    },
    loadCombos: function loadCombos() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.service.query();

              case 2:
                _this2.reportGroups = _context2.sent;

                if (!(_this2.reportGroups.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                _this2.groupId = _this2.reportGroups[0].id;
                _context2.next = 7;
                return _this2.getZohoReport();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1cd532e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/zoho-report/ZohoReportView.vue
var ZohoReportView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.openNewWindow()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("launch")])],1),_vm._v(" "),_c('span',[_vm._v("Abrir em nova aba")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg4":""}},[_c('v-select',{attrs:{"items":_vm.reportGroups,"item-text":"table_name","item-value":"id","disabled":(_vm.reportGroups.length === 0),"label":"Selecione um Grupo de Relatórios"},model:{value:(_vm.groupId),callback:function ($$v) {_vm.groupId=$$v},expression:"groupId"}})],1),_vm._v(" "),(_vm.reportGroups.length > 0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.zohoReport,"width":"100%","height":"800px","title":"Zoho Analytics"}})]):_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-alert',{attrs:{"value":true,"type":"info"}},[_vm._v("\n          Nenhum grupo cadastrado para exibir o relatório.\n        ")])],1)],1)],1)}
var ZohoReportView_staticRenderFns = []
var ZohoReportView_esExports = { render: ZohoReportView_render, staticRenderFns: ZohoReportView_staticRenderFns }
/* harmony default export */ var zoho_report_ZohoReportView = (ZohoReportView_esExports);
// CONCATENATED MODULE: ./src/features/zoho-report/ZohoReportView.vue
var ZohoReportView_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ZohoReportView___vue_template_functional__ = false
/* styles */
var ZohoReportView___vue_styles__ = null
/* scopeId */
var ZohoReportView___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ZohoReportView___vue_module_identifier__ = null
var ZohoReportView_Component = ZohoReportView_normalizeComponent(
  ZohoReportView,
  zoho_report_ZohoReportView,
  ZohoReportView___vue_template_functional__,
  ZohoReportView___vue_styles__,
  ZohoReportView___vue_scopeId__,
  ZohoReportView___vue_module_identifier__
)

/* harmony default export */ var features_zoho_report_ZohoReportView = (ZohoReportView_Component.exports);

// CONCATENATED MODULE: ./src/features/load-conf/LoadConfService.js






var LoadConfService_LoadConfService = function (_BaseService) {
  inherits_default()(LoadConfService, _BaseService);

  function LoadConfService() {
    classCallCheck_default()(this, LoadConfService);

    return possibleConstructorReturn_default()(this, (LoadConfService.__proto__ || get_prototype_of_default()(LoadConfService)).call(this, 'load-conf'));
  }

  return LoadConfService;
}(features_BaseService);

/* harmony default export */ var load_conf_LoadConfService = (LoadConfService_LoadConfService);
// CONCATENATED MODULE: ./src/features/load-notification-type/LoadNotificationTypeService.js






var LoadNotificationTypeService_LoadNotificationTypeService = function (_BaseService) {
  inherits_default()(LoadNotificationTypeService, _BaseService);

  function LoadNotificationTypeService() {
    classCallCheck_default()(this, LoadNotificationTypeService);

    return possibleConstructorReturn_default()(this, (LoadNotificationTypeService.__proto__ || get_prototype_of_default()(LoadNotificationTypeService)).call(this, 'load-notification-types'));
  }

  return LoadNotificationTypeService;
}(features_BaseService);

/* harmony default export */ var load_notification_type_LoadNotificationTypeService = (LoadNotificationTypeService_LoadNotificationTypeService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/load-conf/LoadConfForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var LoadConfForm = ({
  name: 'load-conf-form',
  mixins: [CrudMixin],
  watch: {
    loadNotificationType: function loadNotificationType() {
      this.selectNotificationType();
    },
    whatsAppType: function whatsAppType() {
      this.selectWhatsAppType();
    }
  },
  data: function data() {
    return {
      isActive: false,
      isEditing: false,
      showWhatsAppType: false,
      showWhatsAppGroup: false,
      showWhatsAppTelephone: false,
      showTelephone: false,
      projects: [],
      loadNotificationTypes: [],
      loadNotificationType: {},
      whatsAppType: null,
      whatsAppGroupName: null,
      whatsAppTelephone: null,
      sendFileTypes: [{ description: 'PDF', slug: 'pdf' }, { description: 'Nenhum', slug: 'nenhum' }],
      periodicityList: [{ description: 'Minuto', slug: 'minute' }, { description: 'Hora', slug: 'hour' }, { description: 'Diariamente', slug: 'daily' }, { description: 'Semanalmente', slug: 'weekly' }, { description: 'Mensalmente', slug: 'monthly' }, { description: 'Anualmente', slug: 'yearly' }],
      whatsAppTypeList: [{ description: 'Telefone', slug: 'Telefone' }, { description: 'Grupo', slug: 'Grupo' }],
      projectService: new project_ProjectService(),
      loadNotificationTypeService: new load_notification_type_LoadNotificationTypeService()
    };
  },
  beforeMount: function beforeMount() {
    this.fetchProjects();
    this.fetchLoadNotificationType();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = load_conf_LoadConfService;
      this.routerName = 'load-conf';
      this.componentType = 'FORM';
    },
    beforeSave: function beforeSave() {
      this.resource.fl_active = this.isActive ? '1' : '0';
      this.resource.load_notification_type_id = this.loadNotificationType.id;
      this.resource.whatsAppType = this.whatsAppType;
      this.resource.whatsAppContact = this.whatsAppGroupName || this.whatsAppTelephone;
    },
    afterLoadResource: function afterLoadResource() {
      this.isEditing = true;
      this.isActive = this.resource.fl_active === '1';
      this.resource.project_id = parseInt(this.resource.project_id, 10);
      this.loadNotificationType = this.resource.load_notification_conf.load_notification_type;
      this.resource.sendFile = this.resource.load_notification_conf.sendFile;
      this.whatsAppType = this.resource.load_notification_conf.whatsAppType;
      if (this.whatsAppType === 'Grupo') {
        this.whatsAppGroupName = this.resource.load_notification_conf.whatsAppContact;
      } else if (this.whatsAppType === 'Telefone') {
        this.whatsAppTelephone = this.resource.load_notification_conf.whatsAppContact;
      }
    },
    selectWhatsAppType: function selectWhatsAppType() {
      if (!this.isEditing) {
        this.whatsAppGroupName = null;
        this.whatsAppTelephone = null;
      }
      this.showWhatsAppTelephone = this.whatsAppType === 'Telefone';
      this.showWhatsAppGroup = this.whatsAppType === 'Grupo';
    },
    selectNotificationType: function selectNotificationType() {
      if (!this.isEditing) {
        this.cleanWhatsAppData();
        this.cleanTelephoneData();
      }
      if (this.loadNotificationType && this.loadNotificationType.slug === 'whatsapp') {
        this.showWhatsAppType = true;
      } else if (this.loadNotificationType && (this.loadNotificationType.slug === 'sms' || this.loadNotificationType.slug === 'celphone')) {
        this.showTelephone = true;
      }
    },
    cleanWhatsAppData: function cleanWhatsAppData() {
      this.showWhatsAppType = false;
      this.showWhatsAppGroup = false;
      this.showWhatsAppTelephone = false;
      this.whatsAppType = null;
      this.whatsAppGroupName = null;
      this.whatsAppTelephone = null;
    },
    cleanTelephoneData: function cleanTelephoneData() {
      this.showTelephone = false;
      this.resource.telephone = null;
    },
    fetchProjects: function fetchProjects() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.projectService.query();

              case 2:
                _this.projects = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchLoadNotificationType: function fetchLoadNotificationType() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.loadNotificationTypeService.query();

              case 2:
                _this2.loadNotificationTypes = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0461d579","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/load-conf/LoadConfForm.vue
var LoadConfForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.projects,"item-text":"name","item-value":"id","clearable":"","chips":"","small-chips":"","error-messages":_vm.validationErrors.project_id,"label":"Selecione o projeto"},model:{value:(_vm.resource.project_id),callback:function ($$v) {_vm.$set(_vm.resource, "project_id", $$v)},expression:"resource.project_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.loadNotificationTypes,"item-text":"description","item-value":"id","clearable":"","chips":"","small-chips":"","return-object":"","error-messages":_vm.validationErrors.load_notification_type_id,"label":"Selecione o tipo de notificação"},model:{value:(_vm.loadNotificationType),callback:function ($$v) {_vm.loadNotificationType=$$v},expression:"loadNotificationType"}})],1),_vm._v(" "),(_vm.showTelephone)?_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('(##)#####-####'),expression:"'(##)#####-####'"}],attrs:{"label":"Telefone","error-messages":_vm.validationErrors.telephone},model:{value:(_vm.resource.telephone),callback:function ($$v) {_vm.$set(_vm.resource, "telephone", $$v)},expression:"resource.telephone"}})],1):_vm._e(),_vm._v(" "),(_vm.showWhatsAppType)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.whatsAppTypeList,"item-text":"description","item-value":"slug","clearable":"","chips":"","small-chips":"","error-messages":_vm.validationErrors.whatsAppType,"label":"Selecione o tipo do WhastApp"},model:{value:(_vm.whatsAppType),callback:function ($$v) {_vm.whatsAppType=$$v},expression:"whatsAppType"}})],1):_vm._e(),_vm._v(" "),(_vm.showWhatsAppTelephone)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('(##)#####-####'),expression:"'(##)#####-####'"}],key:"group_telephone",attrs:{"label":"Telefone","error-messages":_vm.validationErrors.whatsAppTelephone},model:{value:(_vm.whatsAppTelephone),callback:function ($$v) {_vm.whatsAppTelephone=$$v},expression:"whatsAppTelephone"}})],1):_vm._e(),_vm._v(" "),(_vm.showWhatsAppGroup)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{key:"group_whatsapp",attrs:{"label":"Nome do Grupo","error-messages":_vm.validationErrors.whatsAppGroupName},model:{value:(_vm.whatsAppGroupName),callback:function ($$v) {_vm.whatsAppGroupName=$$v},expression:"whatsAppGroupName"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"Descrição","error-messages":_vm.validationErrors.ds_load_conf},model:{value:(_vm.resource.ds_load_conf),callback:function ($$v) {_vm.$set(_vm.resource, "ds_load_conf", $$v)},expression:"resource.ds_load_conf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.periodicityList,"item-text":"description","item-value":"slug","clearable":"","chips":"","small-chips":"","error-messages":_vm.validationErrors.ds_charge_periodicity,"label":"Selecione a periodicidade"},model:{value:(_vm.resource.ds_charge_periodicity),callback:function ($$v) {_vm.$set(_vm.resource, "ds_charge_periodicity", $$v)},expression:"resource.ds_charge_periodicity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Por Período","type":"number","min":"1","error-messages":_vm.validationErrors.qt_charge_periodicity},model:{value:(_vm.resource.qt_charge_periodicity),callback:function ($$v) {_vm.$set(_vm.resource, "qt_charge_periodicity", $$v)},expression:"resource.qt_charge_periodicity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.sendFileTypes,"item-text":"description","item-value":"slug","clearable":"","chips":"","small-chips":"","error-messages":_vm.validationErrors.sendFile,"label":"Envio de arquivo"},model:{value:(_vm.resource.sendFile),callback:function ($$v) {_vm.$set(_vm.resource, "sendFile", $$v)},expression:"resource.sendFile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-switch',{attrs:{"label":("Ativo: " + (_vm.isActive ? 'SIM' : 'NÃO'))},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var LoadConfForm_staticRenderFns = []
var LoadConfForm_esExports = { render: LoadConfForm_render, staticRenderFns: LoadConfForm_staticRenderFns }
/* harmony default export */ var load_conf_LoadConfForm = (LoadConfForm_esExports);
// CONCATENATED MODULE: ./src/features/load-conf/LoadConfForm.vue
var LoadConfForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoadConfForm___vue_template_functional__ = false
/* styles */
var LoadConfForm___vue_styles__ = null
/* scopeId */
var LoadConfForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LoadConfForm___vue_module_identifier__ = null
var LoadConfForm_Component = LoadConfForm_normalizeComponent(
  LoadConfForm,
  load_conf_LoadConfForm,
  LoadConfForm___vue_template_functional__,
  LoadConfForm___vue_styles__,
  LoadConfForm___vue_scopeId__,
  LoadConfForm___vue_module_identifier__
)

/* harmony default export */ var features_load_conf_LoadConfForm = (LoadConfForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/load-conf/LoadConfList.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var LoadConfList = ({
  name: 'load-conf-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      projects: [],
      projectId: null,
      clients: [],
      clientId: null,
      clientService: new client_ClientService(),
      projectService: new project_ProjectService(),
      headers: [{
        text: this.$t('attributes.load_conf.project'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.load_conf.description'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.load_conf.periodicity'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.load_conf.qtd_periodicity'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.load_conf.types'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.load_conf.active'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }]
    };
  },

  watch: {
    clientId: function clientId() {
      this.projectId = null;
      this.fetchProjects();
    }
  },
  beforeMount: function beforeMount() {
    this.fetchProjects();
    this.fetchClients();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = load_conf_LoadConfService;
      this.routerName = 'load-conf';
    },
    applyFilters: function applyFilters(filter) {
      var params = {
        project_id: this.projectId,
        client_id: this.clientId
      };
      return assign_default()(filter, params);
    },
    filterProjects: function filterProjects(item, queryText) {
      var textOne = item.name.toLowerCase();
      var textTwo = item.responsible_name.toLowerCase();
      var searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    filterClients: function filterClients(item, queryText) {
      var textOne = item.name.toLowerCase();
      var searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    fetchProjects: function fetchProjects() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var params;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {};

                if (_this.clientId) {
                  params.client_id = _this.clientId;
                }
                _context.next = 4;
                return _this.projectService.query(params);

              case 4:
                _this.projects = _context.sent;

                if (_this.projects.length === 1) {
                  _this.projectId = _this.projects[0].id;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchClients: function fetchClients() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.clientService.query();

              case 2:
                _this2.clients = _context2.sent;

                if (_this2.clients.length === 1) {
                  _this2.clientId = _this2.clients[0].id;
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6563f640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/load-conf/LoadConfList.vue
var LoadConfList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'load-conf-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{attrs:{"items":_vm.clients,"filter":_vm.filterClients,"item-text":"name","item-value":"id","hint":"Selecionar cliente","required":"","persistent-hint":"","clearable":"","disabled":(_vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","error-messages":_vm.validationErrors.clientId},model:{value:(_vm.clientId),callback:function ($$v) {_vm.clientId=$$v},expression:"clientId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{attrs:{"items":_vm.projects,"filter":_vm.filterProjects,"item-text":"name","item-value":"id","hint":"Selecionar projeto","required":"","persistent-hint":"","clearable":"","disabled":(_vm.projects.length === 0),"no-data-text":"Nenhuma registro encontrado","error-messages":_vm.validationErrors.projectId},model:{value:(_vm.projectId),callback:function ($$v) {_vm.projectId=$$v},expression:"projectId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","text-md-center":""}},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.search()}}},[_c('v-icon',[_vm._v("search")]),_vm._v("\n          Pesquisar\n        ")],1)],1)],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.project.name)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.ds_load_conf)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.ds_charge_periodicity)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.qt_charge_periodicity)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.load_notification_conf.load_notification_type.description)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.fl_active === '1' ? 'SIM' : 'NÃO')+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id, props.item.project.name)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)],1)}
var LoadConfList_staticRenderFns = []
var LoadConfList_esExports = { render: LoadConfList_render, staticRenderFns: LoadConfList_staticRenderFns }
/* harmony default export */ var load_conf_LoadConfList = (LoadConfList_esExports);
// CONCATENATED MODULE: ./src/features/load-conf/LoadConfList.vue
var LoadConfList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoadConfList___vue_template_functional__ = false
/* styles */
var LoadConfList___vue_styles__ = null
/* scopeId */
var LoadConfList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LoadConfList___vue_module_identifier__ = null
var LoadConfList_Component = LoadConfList_normalizeComponent(
  LoadConfList,
  load_conf_LoadConfList,
  LoadConfList___vue_template_functional__,
  LoadConfList___vue_styles__,
  LoadConfList___vue_scopeId__,
  LoadConfList___vue_module_identifier__
)

/* harmony default export */ var features_load_conf_LoadConfList = (LoadConfList_Component.exports);

// CONCATENATED MODULE: ./src/router/AdminRoutes.js
























vue_esm["default"].component('audit', features_audit_Audit);
vue_esm["default"].component('audit', features_mail_Mail);
vue_esm["default"].component('user-list', features_user_UserList);

/* harmony default export */ var AdminRoutes = ([{
  path: 'audit',
  name: 'audit',
  component: features_audit_Audit,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'mail',
  name: 'mail',
  component: features_mail_Mail,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'client',
  name: 'client-list',
  component: features_client_ClientList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'client/:id',
  name: 'client-form',
  component: features_client_ClientForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'table-manager',
  name: 'table-manager-list',
  component: features_table_manager_TableManagerList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'table-manager/:id',
  name: 'table-manager-form',
  component: features_table_manager_TableManagerForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'cycle',
  name: 'cycle-list',
  component: features_cycle_CycleList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'cycle/:id',
  name: 'cycle-form',
  component: features_cycle_CycleForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'project',
  name: 'project-list',
  component: features_project_ProjectList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'project/:id',
  name: 'project-form',
  component: features_project_ProjectForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'user',
  name: 'user-list',
  component: features_user_UserList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] }
}, {
  path: 'user/:id',
  name: 'user-form',
  component: features_user_UserForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] }
}, {
  path: 'load-conf',
  name: 'load-conf-list',
  component: features_load_conf_LoadConfList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] }
}, {
  path: 'load-conf/:id',
  name: 'load-conf-form',
  component: features_load_conf_LoadConfForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente'] }
}, {
  path: 'settings',
  name: 'settings-list',
  component: features_settings_Settings,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'billing-report',
  name: 'billing-report-list',
  component: features_billing_report_BillingReportList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'billing-report/:id',
  name: 'billing-report-form',
  component: features_billing_report_BillingReportForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin'] }
}, {
  path: 'zoho-report-credential',
  name: 'zoho-report-credential-list',
  component: features_zoho_report_credential_ZohoReportCredentialList,
  meta: { requiresAuth: true, requireRoles: ['master'] }
}, {
  path: 'zoho-report-credential/:id',
  name: 'zoho-report-credential-form',
  component: features_zoho_report_credential_ZohoReportCredentialForm,
  meta: { requiresAuth: true, requireRoles: ['master'] }
}, {
  path: 'zoho-report-group',
  name: 'zoho-report-group-list',
  component: features_zoho_report_ZohoReportGroupList,
  meta: { requiresAuth: true, requireRoles: ['master'] }
}, {
  path: 'zoho-report-group/:id',
  name: 'zoho-report-group-form',
  component: features_zoho_report_ZohoReportGroupForm,
  meta: { requiresAuth: true, requireRoles: ['master'] }
}, {
  path: 'zoho-report-view',
  name: 'zoho-report-view',
  component: features_zoho_report_ZohoReportView,
  meta: { requiresAuth: true, requireRoles: ['master'] }
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/user/Profile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Profile = ({
  name: 'profile',
  data: function data() {
    return {
      imageSize: 3,
      valdationErrors: [],
      saveLoading: false,
      resource: assign_default()({}, this.$store.state.currentUser)
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      if (this.resource.password && this.resource.password !== this.resource.password_confirmation) {
        this.$toast.error('A confirmação da senha não corresponde a senha digitada.');
      } else {
        this.$store.dispatch('updateProfile', this.resource).then(function () {
          _this.$toast.success(_this.$t('messages.saveSuccess'));
        }).catch(function (error) {
          _this.valdationErrors = error.response.data;
        });
      }
    },
    onLoad: function onLoad(dataUri) {
      this.resource.image = dataUri;
    },
    onSizeExceeded: function onSizeExceeded(size) {
      this.$toast.success('Imagem com ' + size + ' mb, o tamanho permitido \xE9 ' + this.imageSize);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c7619be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/user/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.$t('views.titles.update')}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm7":"","md9":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('attributes.name'),"counter":100,"error-messages":_vm.valdationErrors.name},model:{value:(_vm.resource.name),callback:function ($$v) {_vm.$set(_vm.resource, "name", $$v)},expression:"resource.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('attributes.email'),"counter":100,"error-messages":_vm.valdationErrors.email},model:{value:(_vm.resource.email),callback:function ($$v) {_vm.$set(_vm.resource, "email", $$v)},expression:"resource.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('attributes.password'),"type":"password","error-messages":_vm.valdationErrors.password},model:{value:(_vm.resource.password),callback:function ($$v) {_vm.$set(_vm.resource, "password", $$v)},expression:"resource.password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('views.fields.login.confirmPassword'),"type":"password","error-messages":_vm.valdationErrors.password_confirmation},model:{value:(_vm.resource.password_confirmation),callback:function ($$v) {_vm.$set(_vm.resource, "password_confirmation", $$v)},expression:"resource.password_confirmation"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-all-center",attrs:{"d-flex":"","xs12":"","sm5":"","md3":""}},[_c('pr-upload-file',{attrs:{"avatar":true,"defaultPreview":_vm.$store.state.currentUser.image ? _vm.$store.state.currentUser.image : '/static/no_avatar.gif',"accept":"image/png,image/jpeg","max-size":_vm.imageSize},on:{"size-exceeded":_vm.onSizeExceeded,"load":_vm.onLoad}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v(_vm._s(_vm.$t('views.actions.update')))])],1)],1)],1)}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var user_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/features/user/Profile.vue
function Profile_injectStyle (ssrContext) {
  __webpack_require__("pMeG")
}
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = Profile_injectStyle
/* scopeId */
var Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  user_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var features_user_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/dashboard/Dashboard.vue
//
//
//
//
//
//



/* harmony default export */ var Dashboard = ({
  name: 'dashboard',
  data: function data() {
    return {
      userDialogVisible: false
    };
  },

  components: {
    UserDialog: features_user_UserDialog
  },
  methods: {
    componentInlineClose: function componentInlineClose(data) {
      this.$log.debug(data);
    },
    component: function component() {
      var _this = this;

      this.$dialog.component(features_user_UserDialog, { closeWithEsc: false, widget: false }).then(function (response) {
        _this.$log.debug('Action', response.action);
        _this.$log.debug('Data', response.data);
      });
    },
    alert: function alert() {
      var _this2 = this;

      this.$dialog.alert({ title: 'Titulo do Alert', content: 'Descritivo do alert' }).then(function (response) {
        _this2.$log.debug('Action', response.action);
        _this2.$log.debug('Data', response.data);
      });
    },
    prompt: function prompt() {
      var _this3 = this;

      this.$dialog.prompt({ title: 'Titulo do Prompt ', content: 'Descritivo do prompt' }).then(function (response) {
        _this3.$log.debug('Action', response.action);
        _this3.$log.debug('Data', response.data);
      });
    },
    confirm: function confirm() {
      var _this4 = this;

      this.$dialog.confirm({ title: 'Titulo do Confirm ', content: 'Descritivo do confirm' }).then(function (response) {
        _this4.$log.debug('Action', response.action);
        _this4.$log.debug('Data', response.data);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f6f31b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/dashboard/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Dashboard_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-5",staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"ciclos-img-logo",attrs:{"src":"/static/logo_ciclos_transparente.png","alt":"logo"}})])}]
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var dashboard_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/features/dashboard/Dashboard.vue
function Dashboard_injectStyle (ssrContext) {
  __webpack_require__("txop")
}
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = Dashboard_injectStyle
/* scopeId */
var Dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  dashboard_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var features_dashboard_Dashboard = (Dashboard_Component.exports);

// CONCATENATED MODULE: ./src/features/called/CalledService.js






var CalledService_CalledService = function (_BaseService) {
  inherits_default()(CalledService, _BaseService);

  function CalledService() {
    classCallCheck_default()(this, CalledService);

    return possibleConstructorReturn_default()(this, (CalledService.__proto__ || get_prototype_of_default()(CalledService)).call(this, 'called'));
  }

  return CalledService;
}(features_BaseService);

/* harmony default export */ var called_CalledService = (CalledService_CalledService);
// CONCATENATED MODULE: ./src/features/called-status/CalledStatusService.js






var CalledStatusService_CalledStatusService = function (_BaseService) {
  inherits_default()(CalledStatusService, _BaseService);

  function CalledStatusService() {
    classCallCheck_default()(this, CalledStatusService);

    return possibleConstructorReturn_default()(this, (CalledStatusService.__proto__ || get_prototype_of_default()(CalledStatusService)).call(this, 'called-status'));
  }

  return CalledStatusService;
}(features_BaseService);

/* harmony default export */ var called_status_CalledStatusService = (CalledStatusService_CalledStatusService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/called/CalledList.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var CalledList = ({
  name: 'called-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo'
      },
      headers: [{
        text: this.$t('attributes.called.number'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.title'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.project'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.priority'),
        sortable: false,
        align: 'center'
      }, {
        text: this.$t('attributes.called.cycle'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.cycle_status'),
        sortable: false,
        align: 'center'
      }, {
        text: this.$t('attributes.called.createBy'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.status'),
        sortable: false,
        align: 'center'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'center'
      }],
      clientService: new client_ClientService(),
      projectService: new project_ProjectService(),
      calledStatusService: new called_status_CalledStatusService(),
      clients: [],
      client_id: null,
      projects: [],
      project_id: null,
      calledStatus: [],
      called_status_id: null,
      term: null,
      disabledClient: false,
      showAlert: false
    };
  },

  watch: {
    client_id: function client_id(value) {
      var _this = this;

      if (value) {
        var params = {
          client_id: value
        };
        this.projectService.query(params).then(function (projects) {
          if (projects.length > 0) {
            _this.projects = projects;
          } else {
            _this.project_id = null;
            _this.projects = [];
          }
        });
      }
    }
  },
  created: function created() {
    var user = this.$store.state.currentUser;
    if (!user_UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.client_id = user && user.client ? user.client.id : null;
      this.disabledClient = true;
    }
    this.loadCombos();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = called_CalledService;
      this.routerName = 'called';
      this.onSearchInit = false;
    },
    applyFilters: function applyFilters(filter) {
      var params = {
        client_id: this.client_id,
        project_id: this.project_id,
        called_status_id: this.called_status_id,
        term: this.term
      };
      return assign_default()(filter, params);
    },
    followCalled: function followCalled(calledId) {
      var params = { id: calledId };
      this.$router.push({ name: 'follow-called', params: params });
    },
    setDefaultCalledStatus: function setDefaultCalledStatus() {
      var status = Object(lodash["find"])(this.calledStatus, { slug: 'aberto' });
      if (status) {
        this.called_status_id = status.id;
      }
    },
    loadCombos: function loadCombos() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var request;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = [_this2.clientService.query(), _this2.calledStatusService.query()];

                axios_default.a.all(request).then(axios_default.a.spread(function (clients, calledStatus) {
                  _this2.clients = clients;
                  _this2.calledStatus = calledStatus;
                  if (_this2.clients.length === 0) {
                    _this2.showAlert = true;
                  } else {
                    _this2.showAlert = false;
                    _this2.setDefaultCalledStatus();
                    _this2.search();
                  }
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleSuccess: function handleSuccess() {
      this.$toast.success('Chamado copiado com sucesso!');
    },
    handleError: function handleError() {
      this.$toast.error('Erro ao tentar copiar o chamado, tente novamente.');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c5dcf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/called/CalledList.vue
var CalledList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"disabled":(_vm.clients.length === 0),"icon":"","to":{ name: 'called-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-card',{staticClass:"pa-3"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","clearable":"","disabled":_vm.disabledClient || (_vm.clients.length === 0),"label":"Selecione um cliente"},model:{value:(_vm.client_id),callback:function ($$v) {_vm.client_id=$$v},expression:"client_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.projects,"item-text":"name","item-value":"id","clearable":"","disabled":!_vm.client_id || _vm.projects.length === 0,"label":"Selecione um projeto"},model:{value:(_vm.project_id),callback:function ($$v) {_vm.project_id=$$v},expression:"project_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.calledStatus,"item-text":"description","item-value":"id","clearable":"","label":"Selecione um status"},model:{value:(_vm.called_status_id),callback:function ($$v) {_vm.called_status_id=$$v},expression:"called_status_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"term","label":"Pesquise por termos no chamado"},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","text-md-center":""}},[_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n              Não existem clientes cadastrados no sistema.\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":(_vm.clients.length === 0),"flat":"","color":"primary"},on:{"click":function($event){_vm.search()}}},[_c('v-icon',[_vm._v("search")]),_vm._v("\n              Pesquisar\n            ")],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            #"+_vm._s(props.item.id)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.title)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.project.name)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(props.item.priority.description)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.cycle.name)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.cycleStatus[props.item.cycle.active])+"\n          ")]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.called_users[0].user.name)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(props.item.called_status.description)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(props.item.id),expression:"props.item.id"}],attrs:{"color":"primary","flat":"","icon":""},on:{"success":_vm.handleSuccess,"error":_vm.handleError}},[_c('v-icon',[_vm._v("content_copy")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Copiar Número")])],2),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.followCalled(props.item.id)}}},[_c('v-icon',[_vm._v("search")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Visualizar")])],2)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var CalledList_staticRenderFns = []
var CalledList_esExports = { render: CalledList_render, staticRenderFns: CalledList_staticRenderFns }
/* harmony default export */ var called_CalledList = (CalledList_esExports);
// CONCATENATED MODULE: ./src/features/called/CalledList.vue
var CalledList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CalledList___vue_template_functional__ = false
/* styles */
var CalledList___vue_styles__ = null
/* scopeId */
var CalledList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CalledList___vue_module_identifier__ = null
var CalledList_Component = CalledList_normalizeComponent(
  CalledList,
  called_CalledList,
  CalledList___vue_template_functional__,
  CalledList___vue_styles__,
  CalledList___vue_scopeId__,
  CalledList___vue_module_identifier__
)

/* harmony default export */ var features_called_CalledList = (CalledList_Component.exports);

// CONCATENATED MODULE: ./src/features/priority/PriorityService.js






var PriorityService_PriorityService = function (_BaseService) {
  inherits_default()(PriorityService, _BaseService);

  function PriorityService() {
    classCallCheck_default()(this, PriorityService);

    return possibleConstructorReturn_default()(this, (PriorityService.__proto__ || get_prototype_of_default()(PriorityService)).call(this, 'priorities'));
  }

  return PriorityService;
}(features_BaseService);

/* harmony default export */ var priority_PriorityService = (PriorityService_PriorityService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/called/CalledForm.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var CalledForm = ({
  name: 'called-form',
  mixins: [CrudMixin],
  data: function data() {
    return {
      isVisible: false,
      isMonitor: false,
      monitor: null,
      monitors: [],
      showDescriptionFieldError: false,
      required: [function (v) {
        return !!v || 'O preenchimento deste campo é obrigatório.';
      }],
      validURL: [function (value) {
        if (value && value !== '') {
          var pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
          return pattern.test(value) || 'O link informado é inválido';
        }
        return true;
      }],
      headers: [{
        text: 'Nome',
        sortable: false,
        align: 'left'
      }, {
        text: 'Formato',
        sortable: false,
        align: 'left'
      }, {
        text: 'Tamanho',
        sortable: false,
        align: 'left'
      }, {
        text: 'Ação',
        sortable: false,
        align: 'right'
      }],
      headersLinked: [{
        text: this.$t('attributes.called.number'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.title'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.project'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.priority'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.cycle'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      editorOption: {
        placeholder: 'Descrição do chamado...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ header: 1 }, { header: 2 }], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ script: 'sub' }, { script: 'super' }], [{ indent: '-1' }, { indent: '+1' }], [{ size: ['small', false, 'large', 'huge'] }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ font: [] }], [{ align: [] }], ['link', 'video']]
        }
      },
      clientName: null,
      fileList: [],
      loading: false,
      projects: [],
      project: null,
      cycles: [],
      cycle: {},
      priorities: [],
      priority: {},
      listCalled: [],
      loadingCalled: false,
      searchTerm: null,
      linkedSelected: null,
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo'
      },
      updatedLinked: 0,
      projectService: new project_ProjectService(),
      cycleService: new cycle_CycleService(),
      priorityService: new priority_PriorityService()
    };
  },

  watch: {
    project: function project(newValue, oldValue) {
      var _this = this;

      if (newValue) {
        if (oldValue && newValue.id !== oldValue.id) {
          this.resource.cycle_id = null;
        }
        var params = {
          client_id: this.project.client_id,
          active: 'sim'
        };
        this.cycleService.query(params).then(function (cycles) {
          _this.cycles = cycles;
        });
      }
    },

    'resource.description': {
      handler: function handler(newValue) {
        if (newValue && newValue !== '') {
          this.showDescriptionFieldError = false;
        }
      },

      deep: true
    },
    searchTerm: function searchTerm() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.searchTerm && _this2.searchTerm !== '')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this2.loadCalledListBySearchTerm();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  created: function created() {
    var user = this.$store.state.currentUser;
    if (!user_UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.clientName = user.client.name;
      this.isVisible = true;
    }
  },

  methods: {
    initCrud: function initCrud() {
      var _this3 = this;

      this.serviceType = called_CalledService;
      this.routerName = 'called';
      this.componentType = 'FORM';

      var requests = [this.priorityService.query(), this.projectService.query({
        only_project_active: true,
        only_client_active: true
      })];
      called_CalledService.manyRequests(requests).then(axios_default.a.spread(function (priorities, projects) {
        _this3.priorities = priorities;
        _this3.projects = projects;
      }));
    },
    customCalledListFilter: function customCalledListFilter(item, queryText) {
      var textOne = item.title.toLowerCase();
      var textTwo = item.description.toLowerCase();
      var textThree = '' + item.id;
      var searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1;
    },
    loadCalledListBySearchTerm: function loadCalledListBySearchTerm() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var params;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this4.loadingCalled = true;
                params = { term: _this4.searchTerm };

                if (_this4.resource.linked && _this4.resource.linked.length > 0) {
                  params.notIn = _this4.resource.linked.map(function (item) {
                    return item.id;
                  });
                }
                _context2.next = 6;
                return _this4.service.query(params);

              case 6:
                _this4.listCalled = _context2.sent;

                _this4.loadingCalled = false;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this4.$log.error(_context2.t0);
                _this4.loadingCalled = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 10]]);
      }))();
    },
    beforeSave: function beforeSave() {
      this.stopSaveData = true;
      this.showDescriptionFieldError = !this.resource.description || this.resource.description === '';
      if (this.$refs.form.validate()) {
        this.stopSaveData = false;
        this.reqSaveConfig = { headers: { 'Content-Type': 'multipart/form-data' } };
        var formData = new FormData();
        if (this.resource.title) formData.append('title', this.resource.title);
        if (this.resource.description) formData.append('description', this.resource.description);
        if (this.project && this.project.id) formData.append('project_id', this.project.id);
        if (this.resource.cycle_id) formData.append('cycle_id', this.resource.cycle_id);
        if (this.resource.priority_id) formData.append('priority_id', this.resource.priority_id);

        if (this.resource.linked && this.resource.linked.length) {
          var linked = this.resource.linked.map(function (item) {
            return item.id;
          });
          linked.forEach(function (item, index) {
            formData.append('linked[' + index + ']', item);
          });
        }

        if (this.fileList && this.fileList.length) {
          this.fileList.forEach(function (file, index) {
            formData.append('attachments[' + index + ']', file);
          });
        }

        if (this.isMonitor && this.monitors.length > 0) {
          formData.append('monitors', this.monitors);
        }

        this.resource = formData;
      }
    },
    afterLoadResource: function afterLoadResource() {
      this.projects.push(this.resource.project);
      this.project = { id: this.resource.project.id, name: this.resource.project.name };
    },
    openBrowserAddFile: function openBrowserAddFile() {
      this.$refs.files.click();
    },
    handleFileUploads: function handleFileUploads() {
      this.fileList = [].concat(toConsumableArray_default()(this.fileList), toConsumableArray_default()(this.$refs.files.files));
      this.reset();
    },
    deleteFileInList: function deleteFileInList(file) {
      var _this5 = this;

      var index = this.fileList.indexOf(file);
      this.$dialog.confirm({ title: 'Atenção', content: 'Deseja remover o arquivo ' + file.name + '?' }).then(function (response) {
        if (response.action === 'ok') {
          _this5.fileList.splice(index, 1);
          _this5.$toast.success(_this5.$t('messages.removeSuccess'));
        }
      });
    },
    reset: function reset() {
      var input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';
    },
    getExtension: function getExtension(filename) {
      if (filename) {
        var split = filename.split('.');
        return split[split.length - 1].toUpperCase();
      }
      return '';
    },
    removeLink: function removeLink(linkedId) {
      var indexOf = this.resource.linked.findIndex(function (item) {
        return item.id === linkedId;
      });
      this.resource.linked.splice(indexOf, 1);
      this.updatedLinked += 1;
    },
    onSelectedLinked: function onSelectedLinked(selected) {
      if (!this.resource.linked) {
        this.resource.linked = [selected];
      } else {
        this.resource.linked.push(selected);
      }
      this.listCalled = [];
      this.linkedSelected = null;
    },
    deleteMonitorInList: function deleteMonitorInList(_ref) {
      var monitor = _ref.monitor;

      this.monitors = this.monitors.filter(function (item) {
        return item !== monitor;
      });
    },
    addMonitorInList: function addMonitorInList() {
      if (this.isMonitor && this.monitor && this.monitor !== '') {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var phonePattern = /^\d{2}\s?\d{4,5}\d{4}$/;

        if (emailPattern.test(this.monitor) || phonePattern.test(this.monitor)) {
          this.monitors.push(this.monitor);
          this.monitor = null;
        } else {
          this.$toast.error('O email ou número de whatsapp informado é inválido.');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e962134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/called/CalledForm.vue
var CalledForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Titulo do Chamado","required":"","rules":_vm.required},model:{value:(_vm.resource.title),callback:function ($$v) {_vm.$set(_vm.resource, "title", $$v)},expression:"resource.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.isVisible)?_c('v-text-field',{attrs:{"label":"Cliente","disabled":""},model:{value:(_vm.clientName),callback:function ($$v) {_vm.clientName=$$v},expression:"clientName"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mb-2":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Link do Painel","hint":"Caso seja um painel, adicione aqui o link","persistent-hint":"","rules":_vm.validURL},model:{value:(_vm.resource.panel_link),callback:function ($$v) {_vm.$set(_vm.resource, "panel_link", $$v)},expression:"resource.panel_link"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('quill-editor',{ref:"description",attrs:{"options":_vm.editorOption},model:{value:(_vm.resource.description),callback:function ($$v) {_vm.$set(_vm.resource, "description", $$v)},expression:"resource.description"}}),_vm._v(" "),(_vm.showDescriptionFieldError)?_c('small',{staticClass:"v-messages theme--light error--text"},[_vm._v("O preenchimento deste campo é obrigatório.")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.projects,"no-data-text":"Nenhuma registro encontrado","clearable":"","required":"","item-text":"name","item-value":"id","label":"Selecione um projeto","hint":"Vincular um projeto a este chamado","persistent-hint":"","return-object":"","rules":_vm.required},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.cycles,"item-text":"name","item-value":"id","no-data-text":"Nenhuma registro encontrado","required":"","hint":"Vincular um ciclo a este chamado","label":"Selecione um ciclo","persistent-hint":"","disabled":!_vm.project || _vm.cycles.length === 0,"rules":_vm.required},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.name)+"\n            ")]}},{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('small',[_vm._v(_vm._s(_vm._f("prDate")(data.item.start_date))+" até "+_vm._s(_vm._f("prDate")(data.item.end_date)))])])],1)]]}}]),model:{value:(_vm.resource.cycle_id),callback:function ($$v) {_vm.$set(_vm.resource, "cycle_id", $$v)},expression:"resource.cycle_id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.priorities,"item-text":"description","item-value":"id","required":"","hint":"Vincular uma prioridade a este chamado","label":"Selecione a prioridade","persistent-hint":"","disabled":_vm.priorities.length === 0,"rules":_vm.required},model:{value:(_vm.resource.priority_id),callback:function ($$v) {_vm.$set(_vm.resource, "priority_id", $$v)},expression:"resource.priority_id"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',[_c('v-card-title',[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"label":"Monitorar","hide-details":""},model:{value:(_vm.isMonitor),callback:function ($$v) {_vm.isMonitor=$$v},expression:"isMonitor"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":!_vm.isMonitor,"label":"Email/WhatsApp","clearable":"","density":"compact","placeholder":"Digite aqui o email ou whatsapp","hint":"Digite um email ou celular válido. (ex.: meuemail@domain.com ou 71988990101)","persistent-hint":""},model:{value:(_vm.monitor),callback:function ($$v) {_vm.monitor=$$v},expression:"monitor"}}),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){_vm.addMonitorInList()}}},[_vm._v("ADD")])],1),_vm._v(" "),(_vm.isMonitor)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.monitors,"headers":[
                {
                  text: 'Email/WhatsApp',
                  sortable: false,
                  align: 'left',
                },
                {
                  text: 'Ação',
                  sortable: false,
                  align: 'right',
                } ],"hide-actions":"","no-data-text":"Nenhum dado foi adicionado."},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item))]),_vm._v(" "),_c('td',{staticClass:"text-md-right"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteMonitorInList({ monitor: props.item })}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1)]}}])}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n              Anexos\n              "),_c('v-spacer'),_vm._v(" "),_c('input',{ref:"files",staticClass:"input-file",attrs:{"multiple":"","name":"file","type":"file"},on:{"change":function($event){_vm.handleFileUploads()}}}),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.openBrowserAddFile($event)}},slot:"activator"},[_vm._v("Anexar Arquivo")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.fileList,"headers":_vm.headers,"hide-actions":"","no-data-text":"Nenhum arquivo anexado."},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getExtension(props.item.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("convertToByte")(props.item.size)))]),_vm._v(" "),_c('td',{staticClass:"text-md-right"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteFileInList(props.item)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-autocomplete',{attrs:{"label":"Vincular Chamado","loading":_vm.loadingCalled,"items":_vm.listCalled,"filter":_vm.customCalledListFilter,"item-text":"title","search-input":_vm.searchTerm,"hide-selected":"","return-object":"","no-data-text":"Nenhuma registro encontrado","hint":"Informe acima o número do chamado","persistent-hint":""},on:{"update:searchInput":function($event){_vm.searchTerm=$event},"change":_vm.onSelectedLinked},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                  #"+_vm._s(props.item.id)+" - "+_vm._s(props.item.title)+"\n                ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                  Ciclo: "+_vm._s(props.item.cycle.name)+" / Status: "+_vm._s(_vm.cycleStatus[props.item.cycle.active])+"\n                ")])],1)]}}]),model:{value:(_vm.linkedSelected),callback:function ($$v) {_vm.linkedSelected=$$v},expression:"linkedSelected"}})],1)],1),_vm._v(" "),(_vm.resource.linked && _vm.resource.linked.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"data-called-linked",attrs:{"xs12":""}},[_c('strong',[_vm._v("Chamados Vinculados:")])]),_vm._v(" "),_c('v-flex',{staticClass:"data-called-linked",attrs:{"xs12":""}},[_c('v-data-table',{key:("linked_" + _vm.updatedLinked),staticClass:"elevation-0",attrs:{"headers":_vm.headersLinked,"items":_vm.resource.linked,"total-items":_vm.resource.linked.length,"hide-actions":true},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n                #"+_vm._s(props.item.id)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(props.item.title)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(props.item.project.name)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(props.item.priority.description)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(props.item.cycle.name)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(props.item.called_status.description)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.removeLink(props.item.id)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Remover Vínculo")])],2)],1)]}}])})],1)],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var CalledForm_staticRenderFns = []
var CalledForm_esExports = { render: CalledForm_render, staticRenderFns: CalledForm_staticRenderFns }
/* harmony default export */ var called_CalledForm = (CalledForm_esExports);
// CONCATENATED MODULE: ./src/features/called/CalledForm.vue
function CalledForm_injectStyle (ssrContext) {
  __webpack_require__("VQyD")
}
var CalledForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CalledForm___vue_template_functional__ = false
/* styles */
var CalledForm___vue_styles__ = CalledForm_injectStyle
/* scopeId */
var CalledForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CalledForm___vue_module_identifier__ = null
var CalledForm_Component = CalledForm_normalizeComponent(
  CalledForm,
  called_CalledForm,
  CalledForm___vue_template_functional__,
  CalledForm___vue_styles__,
  CalledForm___vue_scopeId__,
  CalledForm___vue_module_identifier__
)

/* harmony default export */ var features_called_CalledForm = (CalledForm_Component.exports);

// CONCATENATED MODULE: ./src/features/event/EventService.js






var EventService_EventService = function (_BaseService) {
  inherits_default()(EventService, _BaseService);

  function EventService() {
    classCallCheck_default()(this, EventService);

    return possibleConstructorReturn_default()(this, (EventService.__proto__ || get_prototype_of_default()(EventService)).call(this, 'events'));
  }

  return EventService;
}(features_BaseService);

/* harmony default export */ var event_EventService = (EventService_EventService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/event/EventList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var EventList = ({
  name: 'event-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.client.name'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.event.date'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.event.event_type'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      user: null
    };
  },
  created: function created() {
    this.user = this.$store.state.currentUser;
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = event_EventService;
      this.routerName = 'event';
    },
    isVisible: function isVisible() {
      return this.user && user_UserService.hasProfile(this.user, ['master', 'admin', 'analista']);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d808338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/event/EventList.vue
var EventList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget && _vm.isVisible())?_c('v-btn',{attrs:{"icon":"","to":{ name: 'event-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.resources,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.client.name)+"\n          ")]),_vm._v(" "),(props.item.date)?_c('td',[_vm._v("\n            "+_vm._s(_vm._f("prDate")(props.item.date))+"\n          ")]):_vm._e(),_vm._v(" "),(!props.item.date)?_c('td',[_vm._v("\n            --\n          ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.event_type.description)+"\n          ")]),_vm._v(" "),(_vm.isVisible())?_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.destroy(props.item.id)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var EventList_staticRenderFns = []
var EventList_esExports = { render: EventList_render, staticRenderFns: EventList_staticRenderFns }
/* harmony default export */ var event_EventList = (EventList_esExports);
// CONCATENATED MODULE: ./src/features/event/EventList.vue
var EventList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EventList___vue_template_functional__ = false
/* styles */
var EventList___vue_styles__ = null
/* scopeId */
var EventList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EventList___vue_module_identifier__ = null
var EventList_Component = EventList_normalizeComponent(
  EventList,
  event_EventList,
  EventList___vue_template_functional__,
  EventList___vue_styles__,
  EventList___vue_scopeId__,
  EventList___vue_module_identifier__
)

/* harmony default export */ var features_event_EventList = (EventList_Component.exports);

// CONCATENATED MODULE: ./src/features/event-type/EventTypeService.js






var EventTypeService_EventTypeService = function (_BaseService) {
  inherits_default()(EventTypeService, _BaseService);

  function EventTypeService() {
    classCallCheck_default()(this, EventTypeService);

    return possibleConstructorReturn_default()(this, (EventTypeService.__proto__ || get_prototype_of_default()(EventTypeService)).call(this, 'event-types'));
  }

  return EventTypeService;
}(features_BaseService);

/* harmony default export */ var event_type_EventTypeService = (EventTypeService_EventTypeService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/event/EventForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var EventForm = ({
  name: 'project-form',
  mixins: [CrudMixin],
  components: { DatePicker: lib_default.a },
  data: function data() {
    return {
      showAlert: false,
      lang: 'pt-br',
      clients: [],
      cycles: [],
      eventTypes: [],
      editorOption: {
        placeholder: 'Descrição do chamado...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ header: 1 }, { header: 2 }], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ script: 'sub' }, { script: 'super' }], [{ indent: '-1' }, { indent: '+1' }], [{ size: ['small', false, 'large', 'huge'] }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ font: [] }], [{ align: [] }], ['link', 'video']]
        }
      },
      clientService: new client_ClientService(),
      cycleService: new cycle_CycleService(),
      eventTypeService: new event_type_EventTypeService(),
      disabledClient: false
    };
  },

  watch: {
    clientId: function clientId() {
      var _this = this;

      if (this.clientId) {
        var params = {
          client_id: this.clientId,
          active: 'sim'
        };
        this.cycleService.query(params).then(function (cycles) {
          _this.cycles = cycles;
        });
      }
    }
  },
  computed: {
    clientId: function clientId() {
      return this.resource.client_id;
    }
  },
  created: function created() {
    var user = this.$store.state.currentUser;
    if (!user_UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.resource.client_id = user.client.id;
      this.disabledClient = true;
    }
    this.loadCombos();
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = event_EventService;
      this.routerName = 'event';
      this.componentType = 'FORM';
    },
    afterLoadResource: function afterLoadResource() {
      if (!this.resource.date) this.resource.date = new Date();
    },
    setLabelCycle: function setLabelCycle() {
      var label = 'Selecione um ciclo';
      if (!this.resource.client_id) {
        label = 'Nenhum cliente selecionado';
      } else if (this.resource.client_id && this.cycles.length === 0) {
        label = 'Nenhum ciclo cadastrado para este cliente';
      }
      return label;
    },
    reset: function reset() {
      this.resource.cycle_id = null;
    },
    loadCombos: function loadCombos() {
      var _this2 = this;

      var requests = [this.eventTypeService.query(), this.clientService.query()];
      event_EventService.manyRequests(requests).then(axios_default.a.spread(function (eventTypes, clients) {
        _this2.eventTypes = eventTypes;
        _this2.clients = clients;
        if (_this2.clients.length === 0) {
          _this2.showAlert = true;
        }
      }));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbff456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/event/EventForm.vue
var EventForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t('views.fields.event.date')))]),_vm._v(" "),_c('date-picker',{attrs:{"placeholder":"Selecione a data","lang":_vm.lang,"editable":false,"format":"DD/MM/YYYY","clearable":""},model:{value:(_vm.resource.date),callback:function ($$v) {_vm.$set(_vm.resource, "date", $$v)},expression:"resource.date"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","hint":"Vincular um cliente a este projeto","required":"","persistent-hint":"","clearable":"","disabled":_vm.disabledClient || (_vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","placeholder":"Selecione um cliente"},on:{"click:clear":_vm.reset},model:{value:(_vm.resource.client_id),callback:function ($$v) {_vm.$set(_vm.resource, "client_id", $$v)},expression:"resource.client_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.cycles,"item-text":"name","item-value":"id","required":"","hint":"Vincular um ciclo a este evento","label":_vm.setLabelCycle(),"persistent-hint":"","disabled":!_vm.resource.client_id || _vm.cycles.length === 0},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.name)+"\n            ")]}},{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")])],1)]]}}]),model:{value:(_vm.resource.cycle_id),callback:function ($$v) {_vm.$set(_vm.resource, "cycle_id", $$v)},expression:"resource.cycle_id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.eventTypes,"item-text":"description","item-value":"id","required":"","hint":"Vincular um tipo a este evento","label":"Selecione um tipo","persistent-hint":"","disabled":_vm.eventTypes.length === 0},model:{value:(_vm.resource.event_type_id),callback:function ($$v) {_vm.$set(_vm.resource, "event_type_id", $$v)},expression:"resource.event_type_id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('quill-editor',{ref:"description",attrs:{"options":_vm.editorOption},model:{value:(_vm.resource.description),callback:function ($$v) {_vm.$set(_vm.resource, "description", $$v)},expression:"resource.description"}})],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.showAlert || (_vm.resource.client_id && _vm.cycles.length === 0),"type":"error"}},[((_vm.clients.length === 0))?_c('span',[_vm._v("Não existem clientes cadastrados no sistema.")]):_vm._e(),_vm._v(" "),((_vm.clients.length > 0) && (_vm.cycles.length === 0))?_c('span',[_vm._v("\n          Não existem ciclos cadastrados para o cliente selecionado.\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","disabled":(_vm.clients.length === 0) || (_vm.cycles.length === 0),"loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var EventForm_staticRenderFns = []
var EventForm_esExports = { render: EventForm_render, staticRenderFns: EventForm_staticRenderFns }
/* harmony default export */ var event_EventForm = (EventForm_esExports);
// CONCATENATED MODULE: ./src/features/event/EventForm.vue
function EventForm_injectStyle (ssrContext) {
  __webpack_require__("7sQc")
}
var EventForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EventForm___vue_template_functional__ = false
/* styles */
var EventForm___vue_styles__ = EventForm_injectStyle
/* scopeId */
var EventForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EventForm___vue_module_identifier__ = null
var EventForm_Component = EventForm_normalizeComponent(
  EventForm,
  event_EventForm,
  EventForm___vue_template_functional__,
  EventForm___vue_styles__,
  EventForm___vue_scopeId__,
  EventForm___vue_module_identifier__
)

/* harmony default export */ var features_event_EventForm = (EventForm_Component.exports);

// CONCATENATED MODULE: ./src/features/call-histories/CallHistoryService.js






var CallHistoryService_CallHistoryService = function (_BaseService) {
  inherits_default()(CallHistoryService, _BaseService);

  function CallHistoryService() {
    classCallCheck_default()(this, CallHistoryService);

    return possibleConstructorReturn_default()(this, (CallHistoryService.__proto__ || get_prototype_of_default()(CallHistoryService)).call(this, 'call-histories'));
  }

  return CallHistoryService;
}(features_BaseService);

/* harmony default export */ var call_histories_CallHistoryService = (CallHistoryService_CallHistoryService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/follow-called/EditCalledDialog.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var EditCalledDialog = ({
  name: 'edit-called-dialog',
  mixins: [DialogMixin],
  components: { DatePicker: lib_default.a },
  props: {
    dataValue: {
      required: true
    }
  },
  data: function data() {
    return {
      lang: 'pt-br',
      isMonitor: false,
      monitor: null,
      monitors: [],
      headers: [{
        text: 'Nome',
        sortable: false,
        align: 'left'
      }, {
        text: 'Formato',
        sortable: false,
        align: 'left'
      }, {
        text: 'Tamanho',
        sortable: false,
        align: 'left'
      }, {
        text: 'Ação',
        sortable: false,
        align: 'center'
      }],
      headersLinked: [{
        text: this.$t('attributes.called.number'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.title'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.project'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.priority'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.cycle'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      fileList: [],
      description: '',
      worked_hours: null,
      date: new Date(),
      priorityId: null,
      calledStatusId: null,
      editorOption: {
        placeholder: 'Descrição do chamado...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ header: 1 }, { header: 2 }], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ script: 'sub' }, { script: 'super' }], [{ indent: '-1' }, { indent: '+1' }], [{ size: ['small', false, 'large', 'huge'] }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ font: [] }], [{ align: [] }], ['link', 'video']]
        }
      },
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo'
      },
      validURL: [function (value) {
        if (value && value !== '') {
          var pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
          return pattern.test(value) || 'O link informado é inválido';
        }
        return true;
      }],
      priorities: [],
      calledStatus: [],
      linked: null,
      listCalled: [],
      linkedSelected: null,
      loadingCalled: false,
      searchTerm: null,
      updatedLinked: 0,
      panelLink: null,
      calledService: new called_CalledService(),
      priorityService: new priority_PriorityService(),
      calledStatusService: new called_status_CalledStatusService(),
      callHistoryService: new call_histories_CallHistoryService()
    };
  },

  watch: {
    searchTerm: function searchTerm() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.searchTerm && _this.searchTerm !== '')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.loadCalledListBySearchTerm();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  beforeMount: function beforeMount() {
    if (this.dataValue.after_called_status) {
      this.calledStatusId = this.dataValue.after_called_status.id;
    } else if (this.dataValue.called_status) {
      this.calledStatusId = this.dataValue.called_status.id;
    }
  },
  mounted: function mounted() {
    this.description = this.dataValue.called_id ? this.dataValue.description : '';
  },
  created: function created() {
    this.fillData();
    this.loadPriorities();
    this.loadCalledStatus();
  },

  methods: {
    loadPriorities: function loadPriorities() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.priorityService.query();

              case 2:
                _this2.priorities = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadCalledStatus: function loadCalledStatus() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.calledStatusService.query();

              case 2:
                _this3.calledStatus = _context3.sent;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    openBrowserAddFile: function openBrowserAddFile() {
      this.$refs.files.click();
    },
    handleFileUploads: function handleFileUploads() {
      this.fileList = [].concat(toConsumableArray_default()(this.fileList), toConsumableArray_default()(this.$refs.files.files));
      this.reset();
    },
    deleteFileInList: function deleteFileInList(file) {
      var _this4 = this;

      var index = this.fileList.indexOf(file);
      this.$dialog.confirm({ title: 'Atenção', content: 'Deseja remover o arquivo ' + file.name + '?' }).then(function (response) {
        if (response.action === 'ok') {
          _this4.fileList.splice(index, 1);
          _this4.$toast.success(_this4.$t('messages.removeSuccess'));
        }
      });
    },
    reset: function reset() {
      var input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';
    },
    saveOrUpdateHistory: function saveOrUpdateHistory() {
      var requestOptions = { headers: { 'Content-Type': 'multipart/form-data' } };
      var formData = new FormData();
      if (this.dataValue.called_id) {
        formData.append('called_id', this.dataValue.called_id);
      } else {
        formData.append('called_id', this.dataValue.id);
      }
      formData.append('title', this.dataValue.title);
      formData.append('date', this.date);
      if (this.worked_hours) formData.append('worked_hours', this.worked_hours);
      if (this.description) formData.append('description', this.description);
      if (this.dataValue.called_id) formData.append('id', this.dataValue.id);
      if (this.panelLink && this.panelLink !== '') {
        formData.append('panel_link', this.panelLink);
      }
      formData.append('called_status_id', this.calledStatusId);
      formData.append('priority_id', this.priorityId);
      if (this.dataValue.linked && this.dataValue.linked.length) {
        var allLinked = this.dataValue.linked.map(function (item) {
          return item.id;
        });
        allLinked.forEach(function (item, index) {
          formData.append('linked[' + index + ']', item);
        });
      }
      if (this.fileList && this.fileList.length) {
        this.fileList.forEach(function (file, index) {
          formData.append('attachments[' + index + ']', file);
        });
      }

      if (this.isMonitor && this.monitors.length > 0) {
        formData.append('monitors', this.monitors);
      }

      if (this.dataValue.called_id) {
        this.updateHistory(formData, requestOptions);
      } else {
        this.saveHistory(formData, requestOptions);
      }
    },
    saveHistory: function saveHistory(formData, requestOptions) {
      var _this5 = this;

      this.reqSaveConfig = requestOptions;
      this.callHistoryService.save(formData).then().finally(function () {
        _this5.closeDialog();
        _this5.$toast.success(_this5.$t('messages.operationSuccess'));
      });
    },
    updateHistory: function updateHistory(formData, requestOptions) {
      var _this6 = this;

      this.callHistoryService.request('POST', 'update-call-history', formData, requestOptions).then().finally(function () {
        _this6.closeDialog();
        _this6.$toast.success(_this6.$t('messages.operationSuccess'));
      });
    },
    getExtension: function getExtension(filename) {
      if (filename) {
        var split = filename.split('.');
        return split[split.length - 1].toUpperCase();
      }
      return '';
    },
    fillData: function fillData() {
      this.worked_hours = this.convertMinutesToHours(this.dataValue.worked_hours);
      if (this.dataValue.date) this.date = this.dataValue.date;
      this.calledStatusId = parseInt(this.dataValue.called_status_id, 10);
      if (this.dataValue.after_called_status) {
        this.calledStatusId = parseInt(this.dataValue.after_called_status.id, 10);
      }
      this.priorityId = parseInt(this.dataValue.priority_id, 10);
      if (this.dataValue.after_priority) {
        this.priorityId = parseInt(this.dataValue.after_priority.id, 10);
      }
      this.panelLink = this.dataValue.panel_link;

      if (this.dataValue.monitors && this.dataValue.monitors.length > 0) {
        this.monitors = this.dataValue.monitors.map(function (item) {
          return item.target;
        });
        this.isMonitor = true;
      }
    },
    convertMinutesToHours: function convertMinutesToHours(time) {
      if (!time || time < 1) {
        return null;
      }
      var hours = Math.floor(time / 60);
      var minutes = time % 60;
      return '' + Object(lodash["padStart"])(hours, 2, '0') + Object(lodash["padStart"])(minutes, 2, '0');
    },
    customCalledListFilter: function customCalledListFilter(item, queryText) {
      var textOne = item.title.toLowerCase();
      var textTwo = item.description.toLowerCase();
      var textThree = '' + item.id;
      var searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1;
    },
    loadCalledListBySearchTerm: function loadCalledListBySearchTerm() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this7.loadingCalled = true;
                _context4.next = 4;
                return _this7.calledService.query({
                  term: _this7.searchTerm,
                  notIn: [_this7.dataValue.called_id ? _this7.dataValue.called_id : _this7.dataValue.id].concat(toConsumableArray_default()(_this7.dataValue.linked.map(function (item) {
                    return item.id;
                  })))
                });

              case 4:
                _this7.listCalled = _context4.sent;

                _this7.loadingCalled = false;
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                _this7.$log.error(_context4.t0);
                _this7.loadingCalled = false;

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 8]]);
      }))();
    },
    removeLink: function removeLink(linkedId) {
      var indexOf = this.dataValue.linked.findIndex(function (item) {
        return item.id === linkedId;
      });
      this.dataValue.linked.splice(indexOf, 1);
      this.updatedLinked += 1;
    },
    onSelectedLinked: function onSelectedLinked(selected) {
      if (!this.dataValue.linked) {
        this.dataValue.linked = [selected];
      } else {
        this.dataValue.linked.push(selected);
      }
      this.listCalled = [];
      this.linkedSelected = null;
    },
    deleteMonitorInList: function deleteMonitorInList(_ref) {
      var monitor = _ref.monitor;

      this.monitors = this.monitors.filter(function (item) {
        return item !== monitor;
      });
    },
    addMonitorInList: function addMonitorInList() {
      if (this.isMonitor && this.monitor && this.monitor !== '') {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var phonePattern = /^\d{2}\s?\d{4,5}\d{4}$/;

        if (emailPattern.test(this.monitor) || phonePattern.test(this.monitor)) {
          this.monitors.push(this.monitor);
          this.monitor = null;
        } else {
          this.$toast.error('O email ou número de whatsapp informado é inválido.');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd873ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/follow-called/EditCalledDialog.vue
var EditCalledDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"scrollable":"","fullscreen":_vm.fullscreen,"max-width":_vm.width,"persistent":!_vm.closeWithMask},model:{value:(_vm.controlDialogVisible),callback:function ($$v) {_vm.controlDialogVisible=$$v},expression:"controlDialogVisible"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n          Editar Chamado #"+_vm._s(_vm.dataValue.called_id ? _vm.dataValue.called_id : _vm.dataValue.id)+"\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-subheader',{staticClass:"pl-0 date-label"},[_vm._v(_vm._s(_vm.$t('views.fields.called.date')))]),_vm._v(" "),_c('date-picker',{attrs:{"placeholder":"Selecione a data","lang":_vm.lang,"editable":false,"format":"DD/MM/YYYY","value-type":"format","clearable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":"","md9":"","pr-1":""}},[_c('v-text-field',{attrs:{"label":"Titulo do Chamado","counter":100,"disabled":""},model:{value:(_vm.dataValue.title),callback:function ($$v) {_vm.$set(_vm.dataValue, "title", $$v)},expression:"dataValue.title"}})],1),_vm._v(" "),(_vm.dataValue.cycle && _vm.dataValue.cycle.active === 'sim')?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"mask":'time',"label":"Horas Trabalhadas"},model:{value:(_vm.worked_hours),callback:function ($$v) {_vm.worked_hours=$$v},expression:"worked_hours"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","pr-1":""}},[_c('v-select',{attrs:{"items":_vm.priorities,"item-text":"description","item-value":"id","required":"","hint":"Vincular uma prioridade a este chamado","label":"Selecione a prioridade","persistent-hint":"","disabled":_vm.priorities.length === 0},model:{value:(_vm.priorityId),callback:function ($$v) {_vm.priorityId=$$v},expression:"priorityId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","pl-1":""}},[_c('v-select',{attrs:{"items":_vm.calledStatus,"item-text":"description","item-value":"id","required":"","hint":"Vincular um status para este chamado","label":"Selecione o status","persistent-hint":"","disabled":_vm.calledStatus.length === 0},model:{value:(_vm.calledStatusId),callback:function ($$v) {_vm.calledStatusId=$$v},expression:"calledStatusId"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-autocomplete',{attrs:{"label":"Vincular Chamado","loading":_vm.loadingCalled,"items":_vm.listCalled,"filter":_vm.customCalledListFilter,"item-text":"title","hide-selected":"","return-object":"","search-input":_vm.searchTerm,"no-data-text":"Nenhuma registro encontrado","hint":"Informe acima o número do chamado","persistent-hint":""},on:{"update:searchInput":function($event){_vm.searchTerm=$event},"change":_vm.onSelectedLinked},scopedSlots:_vm._u([{key:"selection",fn:function(props){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"selected":props.selected,"close":""}},[_vm._v("\n                    #"+_vm._s(props.item.id)+" - "+_vm._s(props.item.title)+"\n                  ")])]}},{key:"item",fn:function(props){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                      #"+_vm._s(props.item.id)+" - "+_vm._s(props.item.title)+"\n                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                      Ciclo: "+_vm._s(props.item.cycle.name)+" / Status: "+_vm._s(_vm.cycleStatus[props.item.cycle.active])+"\n                    ")])],1)]}}]),model:{value:(_vm.linkedSelected),callback:function ($$v) {_vm.linkedSelected=$$v},expression:"linkedSelected"}})],1)],1),_vm._v(" "),(_vm.dataValue.linked && _vm.dataValue.linked.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"data-called-linked",attrs:{"xs12":""}},[_c('strong',[_vm._v("Chamados Vinculados:")])]),_vm._v(" "),_c('v-flex',{staticClass:"data-called-linked",attrs:{"xs12":""}},[_c('v-data-table',{key:("linked_" + _vm.updatedLinked),staticClass:"elevation-0",attrs:{"headers":_vm.headersLinked,"items":_vm.dataValue.linked,"total-items":_vm.dataValue.linked.length,"hide-actions":true},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n                    #"+_vm._s(props.item.id)+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(props.item.title)+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(props.item.project.name)+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(props.item.priority.description)+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(props.item.cycle.name)+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(props.item.called_status.description)+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.removeLink(props.item.id)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Remover Vínculo")])],2)],1)]}}])})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Link do Painel","hint":"Caso seja um painel, adicione aqui o link","persistent-hint":"","rules":_vm.validURL},model:{value:(_vm.panelLink),callback:function ($$v) {_vm.panelLink=$$v},expression:"panelLink"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('quill-editor',{ref:"description",attrs:{"options":_vm.editorOption},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',[_c('v-card-title',[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"label":"Monitorar","hide-details":""},model:{value:(_vm.isMonitor),callback:function ($$v) {_vm.isMonitor=$$v},expression:"isMonitor"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":!_vm.isMonitor,"label":"Email/WhatsApp","clearable":"","density":"compact","placeholder":"Digite aqui o email ou whatsapp","hint":"Digite um email ou celular válido. (ex.: meuemail@domain.com ou 71988990101)","persistent-hint":""},model:{value:(_vm.monitor),callback:function ($$v) {_vm.monitor=$$v},expression:"monitor"}}),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){_vm.addMonitorInList()}}},[_vm._v("ADD")])],1),_vm._v(" "),(_vm.isMonitor)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.monitors,"headers":[
                {
                  text: 'Email/WhatsApp',
                  sortable: false,
                  align: 'left',
                },
                {
                  text: 'Ação',
                  sortable: false,
                  align: 'right',
                } ],"hide-actions":"","no-data-text":"Nenhum arquivo anexado."},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item))]),_vm._v(" "),_c('td',{staticClass:"text-md-right"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteMonitorInList({ monitor: props.item })}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1)]}}])}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n                  Anexos\n                  "),_c('v-spacer'),_vm._v(" "),_c('input',{ref:"files",staticClass:"input-file",attrs:{"multiple":"","name":"file","type":"file"},on:{"change":function($event){_vm.handleFileUploads()}}}),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.openBrowserAddFile($event)}},slot:"activator"},[_vm._v("Anexar Arquivo")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.fileList,"headers":_vm.headers,"hide-actions":"","no-data-text":"Nenhum dado foi adicionado."},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getExtension(props.item.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("convertToByte")(props.item.size)))]),_vm._v(" "),_c('td',{staticClass:"text-md-center"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteFileInList(props.item)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","flat":""},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n            Cancelar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.saveOrUpdateHistory()}}},[_vm._v("\n            Salvar\n          ")])],1)],1)],1)],1)}
var EditCalledDialog_staticRenderFns = []
var EditCalledDialog_esExports = { render: EditCalledDialog_render, staticRenderFns: EditCalledDialog_staticRenderFns }
/* harmony default export */ var follow_called_EditCalledDialog = (EditCalledDialog_esExports);
// CONCATENATED MODULE: ./src/features/follow-called/EditCalledDialog.vue
function EditCalledDialog_injectStyle (ssrContext) {
  __webpack_require__("NwXJ")
}
var EditCalledDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditCalledDialog___vue_template_functional__ = false
/* styles */
var EditCalledDialog___vue_styles__ = EditCalledDialog_injectStyle
/* scopeId */
var EditCalledDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditCalledDialog___vue_module_identifier__ = null
var EditCalledDialog_Component = EditCalledDialog_normalizeComponent(
  EditCalledDialog,
  follow_called_EditCalledDialog,
  EditCalledDialog___vue_template_functional__,
  EditCalledDialog___vue_styles__,
  EditCalledDialog___vue_scopeId__,
  EditCalledDialog___vue_module_identifier__
)

/* harmony default export */ var features_follow_called_EditCalledDialog = (EditCalledDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/follow-called/FollowCalled.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var FollowCalled = ({
  name: 'follow-called',
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.called.number'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.title'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.project'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.priority'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.called.cycle'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.status'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      showBottomSheet: false,
      calledId: null,
      callHistories: [],
      tabActive: 'tab-dados',
      called: {},
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo'
      },
      calledService: new called_CalledService(),
      callHistoryService: new call_histories_CallHistoryService()
    };
  },
  created: function created() {
    this.calledId = this.$route.params.id;
    this.searchCalled();
  },

  watch: {
    tabActive: function tabActive() {
      if (this.tabActive === 'tab-historico') {
        this.searchCalledHistory();
      } else {
        this.searchCalled();
      }
    }
  },
  methods: {
    searchCalled: function searchCalled() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.calledService.get(_this.calledId);

              case 2:
                _this.called = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    download: function download(filename, archivableType, archivableId) {
      var type = archivableType.split('\\');
      axios_default.a.get('file-download', {
        params: { id: archivableId, archivable_type: type[1], name_file: filename },
        responseType: 'blob'
      }).then(function (res) {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        var file = new Blob([res.data], { type: res.headers['content-type'] });
        var fileURL = URL.createObjectURL(file);
        a.href = fileURL;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(fileURL);
      });
    },
    editCalled: function editCalled(history) {
      var _this2 = this;

      var dataValue = this.called;
      if (history) {
        dataValue = this.callHistories.find(function (item) {
          return item.id === history.id;
        });
      }

      this.$dialog.component(features_follow_called_EditCalledDialog, {
        closeWithEsc: false,
        closeWithMask: false,
        widget: false,
        width: '60%',
        dataValue: dataValue
      }).then(function () {
        if (_this2.tabActive === 'tab-historico') {
          _this2.searchCalledHistory();
          if (history) {
            _this2.$refs['bottomSheet' + history.id][0].click();
          }
        }
        _this2.searchCalled();
      });
    },
    verifyColorCalledStatus: function verifyColorCalledStatus(calledStatus) {
      var color = {
        fechado: 'error',
        aberto: 'primary'
      };
      if (!(calledStatus.slug in color)) return 'success';
      return color[calledStatus.slug];
    },
    verifyIconCalledStatus: function verifyIconCalledStatus(calledStatus) {
      var icon = {
        fechado: 'lock',
        aberto: 'lock_open'
      };
      if (!(calledStatus.slug in icon)) return 'assignment_turned_in';
      return icon[calledStatus.slug];
    },
    verifyColorCycleStatus: function verifyColorCycleStatus(cycleStatus) {
      var color = {
        nao: 'error',
        sim: 'primary'
      };
      return color[cycleStatus];
    },
    verifyIconCycleStatus: function verifyIconCycleStatus(cycleStatus) {
      var icon = {
        nao: 'lock',
        sim: 'lock_open'
      };
      return icon[cycleStatus];
    },
    goToBack: function goToBack() {
      this.$router.push({ name: 'called-list' });
    },
    updateCalledData: function updateCalledData() {
      this.searchCalled();
    },
    convertMinutesToHours: function convertMinutesToHours(time) {
      if (time < 1) {
        return '--';
      }
      var hours = Math.floor(time / 60);
      var minutes = time % 60;
      return Object(lodash["padStart"])(hours, 2, '0') + ':' + Object(lodash["padStart"])(minutes, 2, '0');
    },
    searchCalledHistory: function searchCalledHistory() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.callHistoryService.query({ called_id: _this3.calledId }).then(function (response) {
                  _this3.callHistories = response;
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    deleteCallHistory: function deleteCallHistory(id) {
      var _this4 = this;

      this.$dialog.confirm({ title: 'Atenção', content: 'Deseja apagar o histórico selecionado?' }).then(function (response) {
        if (response.action === 'ok') {
          _this4.callHistoryService.destroy(id).then(function () {
            _this4.$toast.success(src_i18n.t('messages.removeSuccess'));
            _this4.searchCalledHistory();
            _this4.updateCalledData();
          });
        }
      });
    },
    removeLink: function removeLink(linkedId) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var dialog, linked, result;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.$dialog.confirm({
                  title: 'Confirmação ',
                  content: 'Deseja realmente excluir o chamado #' + linkedId + ' vinculado?'
                });

              case 2:
                dialog = _context3.sent;

                if (!(dialog.action === 'ok')) {
                  _context3.next = 9;
                  break;
                }

                linked = _this5.called.linked.filter(function (item) {
                  return item.id !== linkedId;
                });
                _context3.next = 7;
                return _this5.calledService.request('POST', 'update-linked', {
                  id: _this5.called.id,
                  linked: linked.map(function (item) {
                    return item.id;
                  })
                });

              case 7:
                result = _context3.sent;

                _this5.called.linked = result.data;

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    openCalledNewTab: function openCalledNewTab(_ref) {
      var similar = _ref.similar;

      var params = { id: similar };
      var routeData = this.$router.resolve({ name: 'follow-called', params: params });
      window.open(routeData.href, '_blank');
    },
    getSimilarCalled: function getSimilarCalled(_ref2) {
      var similarCalled = _ref2.similarCalled;

      return similarCalled.split(';').map(Number).sort(function (a, b) {
        return a - b;
      });
    },
    showCalledSimilars: function showCalledSimilars(_ref3) {
      var called = _ref3.called;

      return called && called.similar_called && user_UserService.hasProfile(this.$store.state.currentUser, ['master', 'admin', 'analista']);
    },
    handleSuccess: function handleSuccess() {
      this.$toast.success('Link copiado com sucesso!');
    },
    handleError: function handleError() {
      this.$toast.error('Erro ao tentar copiar o link, tente novamente.');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-489075c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/follow-called/FollowCalled.vue
var FollowCalled_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","wrap":"","ma-2":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md9":"","align-self-center":""}},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"subheading",attrs:{"xs12":""}},[(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"200px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.1}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{staticClass:"title font-weight-black primary--text"},[_vm._v("\n                  #"+_vm._s(_vm.called.id)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{staticClass:"title font-weight-regular primary--text"},[_vm._v(" - "+_vm._s(_vm.called.title))]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"subheading black--text",attrs:{"xs12":""}},[(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"150px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.1}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v("Projeto")]):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{staticClass:"font-weight-regular primary--text"},[_vm._v(_vm._s(_vm.called.project ? _vm.called.project.name : ''))]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"300px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{staticClass:"subheading grey--text"},[_vm._v("\n                  Criado por "),_c('strong',[_vm._v(_vm._s(_vm.called.called_users[0].user.name))]),_vm._v(" em "+_vm._s(_vm._f("prDateTime")(_vm.called.created_at))+" - Atualizado em "+_vm._s(_vm._f("prDateTime")(_vm.called.updated_at))+"\n                ")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-0",attrs:{"xs12":"","md3":"","pt-0":"","text-md-right":"","align-self-start":""}},[_c('v-btn',{staticClass:"primary--text ma-0",attrs:{"small":"","flat":"","disabled":!_vm.called.id},on:{"click":function($event){_vm.editCalled()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")]),_vm._v("\n            Editar\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text ma-0",attrs:{"small":"","flat":""},on:{"click":function($event){_vm.updateCalledData()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("autorenew")]),_vm._v("\n            Atualizar\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text ma-0",attrs:{"small":"","flat":""},on:{"click":function($event){_vm.goToBack()}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")]),_vm._v("\n            Voltar\n          ")],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"column":"","wrap":"","mt-3":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pa-0":""}},[_c('v-tabs',{attrs:{"color":"primary","slider-color":"white"},model:{value:(_vm.tabActive),callback:function ($$v) {_vm.tabActive=$$v},expression:"tabActive"}},[_c('v-tab',{staticClass:"white--text",attrs:{"ripple":"","href":"#tab-dados"}},[_vm._v("\n              Dados\n            ")]),_vm._v(" "),_c('v-tab',{staticClass:"white--text",attrs:{"disabled":!_vm.called.call_histories_count,"ripple":"","href":"#tab-historico"}},[_c('v-badge',{attrs:{"color":"success"}},[(_vm.called.call_histories_count)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("\n                  "+_vm._s(_vm.called.call_histories_count)+"\n                ")]):_vm._e(),_vm._v("\n                Histórico\n              ")])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"tab-dados"}},[_c('v-layout',{attrs:{"column":"","wrap":"","ml-0":"","mr-0":"","mt-3":""}},[(_vm.called.called_status)?_c('v-layout',{attrs:{"row":"","wrap":"","mb-3":""}},[_c('v-flex',{staticClass:"alert-status-height",attrs:{"xs2":""}},[_c('v-alert',{attrs:{"value":true,"color":_vm.verifyColorCalledStatus(_vm.called.called_status),"outline":"","icon":_vm.verifyIconCalledStatus(_vm.called.called_status)}},[_vm._v("\n                      Status do Chamado: "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.called.called_status.description))]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"alert-status-height",attrs:{"xs2":""}},[_c('v-alert',{attrs:{"value":true,"color":_vm.verifyColorCycleStatus(_vm.called.cycle.active),"outline":"","icon":_vm.verifyIconCycleStatus(_vm.called.cycle.active)}},[_vm._v("\n                      Status do Ciclo: "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.cycleStatus[_vm.called.cycle.active]))]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-system-bar',{staticClass:"pa-3",attrs:{"status":"","color":"grey lighten-2"}},[_c('span',{staticClass:"primary--text"},[_vm._v("Dados do Chamado")])]),_vm._v(" "),_c('v-card-text',{staticClass:"cart-text-border"},[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"grey--text"},[_vm._v("Projeto:")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v(_vm._s(_vm.called.project ? _vm.called.project.name : ''))]):_vm._e()],1),_vm._v(" "),(_vm.called.cycle)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"grey--text"},[_vm._v("Ciclo:")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v(_vm._s(_vm._f("prDate")(_vm.called.cycle.start_date)))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"grey--text"},[_vm._v("Prioridade:")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v(_vm._s(_vm.called.priority ? _vm.called.priority.description : ''))]):_vm._e()],1),_vm._v(" "),(_vm.called.total_worked_hours)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"grey--text"},[_vm._v("Total Horas Trabalhadas")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v(_vm._s(_vm.called.total_worked_hours)+"h")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.called.panel_link && _vm.called.panel_link !== '')?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"grey--text"},[_vm._v("Painel:")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"100px"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.2}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('a',{staticClass:"follow-called-panel-link",attrs:{"href":_vm.called.panel_link,"target":"_blank"}},[_vm._v("\n                                ABRIR PAINEL\n                                "),_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("open_in_new")])],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.called.panel_link),expression:"called.panel_link"}],attrs:{"color":"primary","flat":"","icon":"","small":""},on:{"success":_vm.handleSuccess,"error":_vm.handleError}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("content_copy")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Copiar Link")])],2):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.called.linked && _vm.called.linked.length > 0)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.called.linked && _vm.called.linked.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"data-called-linked",attrs:{"xs12":""}},[_c('strong',[_vm._v("Chamados Vinculados:")])]),_vm._v(" "),_c('v-flex',{staticClass:"data-called-linked",attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.called.linked,"total-items":_vm.called.linked.length,"hide-actions":true},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('router-link',{attrs:{"to":{ name: 'follow-called', params: { id: props.item.id }},"target":"_blank"}},[_vm._v("\n                                      #"+_vm._s(props.item.id)+"\n                                    ")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'follow-called', params: { id: props.item.id }},"target":"_blank"}},[_vm._v("\n                                      "+_vm._s(props.item.title)+"\n                                    ")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("open_in_new")])],1),_vm._v(" "),_c('td',[_vm._v("\n                                    "+_vm._s(props.item.project.name)+"\n                                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    "+_vm._s(props.item.priority.description)+"\n                                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    "+_vm._s(props.item.cycle.name)+"\n                                  ")]),_vm._v(" "),_c('td',[_vm._v("\n                                    "+_vm._s(props.item.called_status.description)+"\n                                  ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.removeLink(props.item.id)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Remover Vínculo")])],2)],1)]}}])})],1)],1):_vm._e(),_vm._v(" "),((_vm.called.files && _vm.called.files.length > 0))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("Anexos:")]),_vm._v(" "),_vm._l((_vm.called.files),function(file){return _c('v-list-tile',{key:file.id,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.download(file.filename, file.archivable_type, file.archivable_id)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey white--text"},[_vm._v("attach_file")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(file.filename))]),_vm._v(" "),(file)?_c('v-list-tile-sub-title',[_vm._v("\n                                      "+_vm._s(_vm._f("convertToByte")(file.size))+" - Data de criação: "+_vm._s(_vm._f("prDate")(file.created_at))+"\n                                    ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("archive")])],1)],1)})],2)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"data-called-desciption",attrs:{"xs12":""}},[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"65%"},attrs:{"duration":".6","theme":"flex-outer","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.called.description)}}):_vm._e()],1)],1),_vm._v(" "),(_vm.called.monitors && _vm.called.monitors.length > 0)?_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',[_c('v-card-title',[_c('strong',[_vm._v("Monitorado Por:")])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.called.monitors,"hide-headers":"","hide-actions":"","no-data-text":"Nenhum dado foi adicionado.","density":"compact"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.target))])]}}])})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showCalledSimilars({ called: _vm.called }))?_c('v-layout',{attrs:{"row":"","wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"data-called-desciption",attrs:{"xs12":""}},[_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('strong',[_vm._v("Indicação de solução Biana:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.called.similar_called.solucao_indicada ? _vm.called.similar_called.solucao_indicada : 'Nenhuma solução foi encontrada'))]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('strong',[_vm._v("Chamado Relacionados:")]),_vm._v(" "),(_vm.called.similar_called.similar_historical_chamados)?_vm._l((_vm.getSimilarCalled({ similarCalled: _vm.called.similar_called.similar_historical_chamados })),function(similar){return _c('v-btn',{key:similar,attrs:{"color":"primary","small":"","round":""},on:{"click":function($event){_vm.openCalledNewTab({ similar: similar })}}},[_vm._v("\n                                      "+_vm._s(similar)+"\n                                    ")])}):_vm._e()],2)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-system-bar',{staticClass:"pa-3",attrs:{"status":"","color":"blue lighten-4"}},[_c('span',{staticClass:"primary--text"},[_vm._v("Pessoas")])]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.called.called_users),function(csu,index){return [_c('v-list-tile',{key:index,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":(csu.user.image) ? csu.user.image : '/static/no_avatar.gif',"alt":"no image"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"280px"},attrs:{"duration":".6","theme":"flex-inner","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.07}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v(_vm._s(csu.user.name))]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-sub-title',[(!_vm.called.id)?_c('skeleton',{staticStyle:{"width":"300px"},attrs:{"duration":".6","theme":"flex-inner","shape":"radius","bg-color":"#dcdcdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1):_vm._e(),_vm._v(" "),(_vm.called.id)?_c('span',[_vm._v(_vm._s(csu.event + ' o chamado em: ')+" "+_vm._s(_vm._f("prDateTime")(csu.created_at)))]):_vm._e()],1)],1)],1)]})],2)],1)],1)],1)],1),_vm._v(" "),(_vm.called.id)?_c('v-tab-item',{staticClass:"tab-historico",attrs:{"value":"tab-historico"}},[_c('v-timeline',_vm._l((_vm.callHistories),function(history){return _c('v-timeline-item',{key:history.id,attrs:{"small":"","color":"info darken-3"}},[(history.user.image)?_c('v-avatar',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"src":history.user.image}})]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"opposite"},slot:"opposite"},[_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm._f("prDate")(history.date)))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"primary--text display-2"},[_vm._v("\n                      "+_vm._s(_vm._f("prTime")(history.created_at))+"\n                    ")])]),_vm._v(" "),_c('v-card',{attrs:{"ripple":""}},[_c('v-bottom-sheet',{attrs:{"full-width":"","disabled":history.is_first}},[_c('v-card-title',{ref:("bottomSheet" + (history.id)),refInFor:true,staticClass:"title white--text info darken-3 card-hover",attrs:{"slot":"activator"},slot:"activator"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('span',{staticClass:"subheading"},[_vm._v("\n                              "+_vm._s(history.is_first ? 'Criado por:' : 'Atualizado por:')+"\n                            ")]),_c('br'),_vm._v("\n                            "+_vm._s(history.user.name)+"\n                          ")]),_vm._v(" "),(history.worked_hours)?_c('v-flex',{attrs:{"xs12":"","md5":"","text-md-right":""}},[_c('v-chip',{attrs:{"label":"","color":"white","text-color":"primary"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"left":""}},[_vm._v("query_builder")]),_vm._v("\n                              Horas Trabalhadas: "+_vm._s(_vm.convertMinutesToHours(history.worked_hours))+"h\n                            ")],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"value":true,"color":"info darken-3"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{on:{"click":function($event){_vm.editCalled(history)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")]),_vm._v(" Editar")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){_vm.deleteCallHistory(history.id)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete")]),_vm._v(" Remover\n                          ")],1)],1)])],1),_vm._v(" "),_c('v-card-text',{staticClass:"white grey--text text--darken-2"},[(history.before_called_status_id !== history.after_called_status_id)?_c('v-chip',{staticClass:"caption",attrs:{"disabled":"","label":"","small":"","outline":"","color":"secondary ma-0"}},[_vm._v("\n                        Status Alterado de "),_c('i',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(history.before_called_status.description)+" ")]),_vm._v("\n                        para "),_c('i',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(history.after_called_status.description)+" ")])]):_vm._e(),_vm._v(" "),(history.before_priority_id !== history.after_priority_id)?_c('v-chip',{staticClass:"caption",attrs:{"disabled":"","label":"","small":"","outline":"","color":"error ma-0"}},[_vm._v("\n                        Prioridade Alterada de "),_c('i',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(history.before_priority.description)+" ")]),_vm._v("\n                        para "),_c('i',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(history.after_priority.description)+" ")])]):_vm._e(),_vm._v(" "),(history.description)?_c('p',{staticClass:"mt-3 called-description",domProps:{"innerHTML":_vm._s(history.description)}}):_vm._e(),_vm._v(" "),(history.files && history.files.length > 0)?_c('v-list',{staticClass:"pa-0"},[_c('v-subheader',[_vm._v("Anexos:")]),_vm._v(" "),_vm._l((history.files),function(file){return _c('v-list-tile',{key:file.id,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.download(file.filename, file.archivable_type, file.archivable_id)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey white--text"},[_vm._v("attach_file")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(file.filename))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                              "+_vm._s(_vm._f("convertToByte")(file.size))+" - Data de criação: "+_vm._s(_vm._f("prDate")(file.created_at))+"\n                            ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("archive")])],1)],1)})],2):_vm._e()],1)],1)],1)}),1)],1):_vm._e()],1)],1)],1)],1)],1)}
var FollowCalled_staticRenderFns = []
var FollowCalled_esExports = { render: FollowCalled_render, staticRenderFns: FollowCalled_staticRenderFns }
/* harmony default export */ var follow_called_FollowCalled = (FollowCalled_esExports);
// CONCATENATED MODULE: ./src/features/follow-called/FollowCalled.vue
function FollowCalled_injectStyle (ssrContext) {
  __webpack_require__("GY5a")
}
var FollowCalled_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FollowCalled___vue_template_functional__ = false
/* styles */
var FollowCalled___vue_styles__ = FollowCalled_injectStyle
/* scopeId */
var FollowCalled___vue_scopeId__ = "data-v-489075c4"
/* moduleIdentifier (server only) */
var FollowCalled___vue_module_identifier__ = null
var FollowCalled_Component = FollowCalled_normalizeComponent(
  FollowCalled,
  follow_called_FollowCalled,
  FollowCalled___vue_template_functional__,
  FollowCalled___vue_styles__,
  FollowCalled___vue_scopeId__,
  FollowCalled___vue_module_identifier__
)

/* harmony default export */ var features_follow_called_FollowCalled = (FollowCalled_Component.exports);

// EXTERNAL MODULE: ./node_modules/v-charts/lib/style.css
var style = __webpack_require__("Qbfk");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/features/report/ReportService.js






var ReportService_ReportService = function (_BaseService) {
  inherits_default()(ReportService, _BaseService);

  function ReportService() {
    classCallCheck_default()(this, ReportService);

    return possibleConstructorReturn_default()(this, (ReportService.__proto__ || get_prototype_of_default()(ReportService)).call(this, 'reports'));
  }

  return ReportService;
}(features_BaseService);

/* harmony default export */ var report_ReportService = (ReportService_ReportService);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/report/DataTableCalledHistory.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DataTableCalledHistory = ({
  name: 'data-table-called-history',
  mixins: [DialogMixin],
  props: {
    dataValue: {
      required: true
    },
    cycleId: {
      required: true
    },
    isDialog: false
  },
  data: function data() {
    return {
      headers: [{
        text: 'Chamado Nº',
        sortable: false,
        align: 'left'
      }, {
        text: 'Chamado',
        sortable: false,
        align: 'left'
      }, {
        text: 'Status',
        sortable: false,
        align: 'left'
      }, {
        text: 'Prioridade',
        sortable: false,
        align: 'left'
      }, {
        text: 'Data',
        sortable: false,
        align: 'left'
      }, {
        text: 'Horas Alocadas',
        sortable: false,
        align: 'left'
      }],
      reportService: new report_ReportService()
    };
  },

  methods: {
    convertMinutesToHours: function convertMinutesToHours(value) {
      var hourAndMinutes = '--:--';
      if (value) {
        var hours = Math.floor(value / 60).toString().padStart(2, '0');
        var minutes = (value % 60).toString().padStart(2, '0');
        hourAndMinutes = hours + ':' + minutes;
      }
      return hourAndMinutes;
    },
    printDataTable: function printDataTable() {
      window.print();
    },
    downloadDataTable: function downloadDataTable() {
      var _this = this;

      var queryParams = { params: { cycle_id: this.cycleId } };
      this.reportService.request('GET', 'generate-pdf', null, queryParams).then(function (response) {
        _this.downloadPDF(response.data.filePath);
      });
    },
    downloadPDF: function downloadPDF(filePath) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var downloadOpts, res, file, a, fileName;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                downloadOpts = {
                  responseType: 'blob',
                  params: { filePath: filePath }
                };
                _context.next = 3;
                return _this2.reportService.request('GET', 'download-pdf', null, downloadOpts);

              case 3:
                res = _context.sent;
                file = new Blob([res.data], { type: res.headers['content-type'] });
                a = window.document.createElement('a');

                a.href = window.URL.createObjectURL(file);
                fileName = filePath.split('__');

                a.download = fileName[fileName.length - 1];
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bfefea0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/report/DataTableCalledHistory.vue
var DataTableCalledHistory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataValue && _vm.dataValue.length > 0)?_c('div',{staticClass:"text-xs-center data-table-histories"},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":"","text-md-left":""}},[_vm._v("\n            Histórico do Ciclo\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"md2":"","text-md-right":""}},[_c('v-btn',{attrs:{"flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.downloadDataTable()}}},[_c('v-icon',[_vm._v("cloud_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"primary"},on:{"click":function($event){_vm.printDataTable()}}},[_c('v-icon',[_vm._v("print")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dataValue,"hide-actions":"","total-items":_vm.dataValue.length,"rows-per-page-text":"Linhas por Página"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"td-align-left"},[_vm._v("#"+_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"td-align-left"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"td-align-left"},[_vm._v(_vm._s(props.item.called_status.description))]),_vm._v(" "),_c('td',{staticClass:"td-align-left"},[_vm._v(_vm._s(props.item.priority.description))]),_vm._v(" "),_c('td',{staticClass:"td-align-left"},[_vm._v(_vm._s(_vm._f("prDate")(props.item.created_at)))]),_vm._v(" "),_c('td',{staticClass:"td-align-left"},[_vm._v(_vm._s(props.item.total_worked_hours)+"h")])]}},{key:"pageText",fn:function(props){return [_vm._v("\n                "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n              ")]}}])})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.isDialog)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","flat":""},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n          Fechar\n        ")])],1):_vm._e()],1)],1):_vm._e()}
var DataTableCalledHistory_staticRenderFns = []
var DataTableCalledHistory_esExports = { render: DataTableCalledHistory_render, staticRenderFns: DataTableCalledHistory_staticRenderFns }
/* harmony default export */ var report_DataTableCalledHistory = (DataTableCalledHistory_esExports);
// CONCATENATED MODULE: ./src/features/report/DataTableCalledHistory.vue
function DataTableCalledHistory_injectStyle (ssrContext) {
  __webpack_require__("moTl")
}
var DataTableCalledHistory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataTableCalledHistory___vue_template_functional__ = false
/* styles */
var DataTableCalledHistory___vue_styles__ = DataTableCalledHistory_injectStyle
/* scopeId */
var DataTableCalledHistory___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DataTableCalledHistory___vue_module_identifier__ = null
var DataTableCalledHistory_Component = DataTableCalledHistory_normalizeComponent(
  DataTableCalledHistory,
  report_DataTableCalledHistory,
  DataTableCalledHistory___vue_template_functional__,
  DataTableCalledHistory___vue_styles__,
  DataTableCalledHistory___vue_scopeId__,
  DataTableCalledHistory___vue_module_identifier__
)

/* harmony default export */ var features_report_DataTableCalledHistory = (DataTableCalledHistory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/report/DataTableDialog.vue
//
//
//
//
//
//
//
//





/* harmony default export */ var DataTableDialog = ({
  name: 'data-table-called-history-dialog',
  mixins: [DialogMixin],
  components: {
    DataTableCalledHistory: features_report_DataTableCalledHistory
  },
  props: {
    dataValue: {
      required: true
    }
  },
  data: function data() {
    return {
      calledHitories: [],
      callHistoryService: new call_histories_CallHistoryService()
    };
  },
  created: function created() {
    this.calledHitories = this.dataValue;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15a7c81e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/report/DataTableDialog.vue
var DataTableDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"scrollable":"","fullscreen":_vm.fullscreen,"max-width":"80%","persistent":!_vm.closeWithMask},model:{value:(_vm.controlDialogVisible),callback:function ($$v) {_vm.controlDialogVisible=$$v},expression:"controlDialogVisible"}},[_c('data-table-called-history',{attrs:{"data-value":_vm.calledHitories,"is-dialog":true}})],1)],1)}
var DataTableDialog_staticRenderFns = []
var DataTableDialog_esExports = { render: DataTableDialog_render, staticRenderFns: DataTableDialog_staticRenderFns }
/* harmony default export */ var report_DataTableDialog = (DataTableDialog_esExports);
// CONCATENATED MODULE: ./src/features/report/DataTableDialog.vue
var DataTableDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataTableDialog___vue_template_functional__ = false
/* styles */
var DataTableDialog___vue_styles__ = null
/* scopeId */
var DataTableDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DataTableDialog___vue_module_identifier__ = null
var DataTableDialog_Component = DataTableDialog_normalizeComponent(
  DataTableDialog,
  report_DataTableDialog,
  DataTableDialog___vue_template_functional__,
  DataTableDialog___vue_styles__,
  DataTableDialog___vue_scopeId__,
  DataTableDialog___vue_module_identifier__
)

/* harmony default export */ var features_report_DataTableDialog = (DataTableDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/report/CycleConsolidated.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var CycleConsolidated = ({
  name: 'cycle-consolidated',
  components: {
    DataTableCalledHistory: features_report_DataTableCalledHistory
  },
  data: function data() {
    var _this = this;

    return {
      showAlert: false,
      isBalanceNegative: false,
      cycle: null,
      loading: false,
      dataEmpty: true,
      totalCycle: null,
      used: null,
      balance: null,
      chartSettings: {
        itemStyle: {
          normal: {
            color: function color(param) {
              var colors = ['#DC3C37', '#2AB249'];
              return colors[param.dataIndex];
            }
          }
        },
        radius: 150,
        selectedMode: 'single',
        dataType: function dataType(v) {
          return _this.convertMinutesToHours(v);
        }
      },
      loadReportDetail: {
        click: function click(e) {
          if (e.dataIndex === 0) {
            _this.showDataTableHistory(_this.showDataTableHistoryDialog.bind(_this));
          }
        }
      },
      calledHistories: [],
      chartData: null,
      clients: [],
      client: null,
      cycles: null,
      cycleId: null,
      calledSetvice: new called_CalledService(),
      clientService: new client_ClientService(),
      reportService: new report_ReportService(),
      cycleService: new cycle_CycleService(),
      callHistoryService: new call_histories_CallHistoryService(),
      disabledClient: false
    };
  },

  watch: {
    client: function client(value) {
      var _this2 = this;

      if (value) {
        this.reset();
        var params = {
          client_id: value.id,
          active: 'sim'
        };
        this.cycleService.query(params).then(function (data) {
          _this2.cycles = data;
          if (_this2.cycles.length === 0) _this2.loading = false;
        });
      }
    },
    cycleId: function cycleId() {
      if (this.cycleId) {
        this.loading = true;
        this.searchData();
      }
    }
  },
  created: function created() {
    var user = this.$store.state.currentUser;
    if (!user_UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.client = user.client;
      this.disabledClient = true;
    }
    this.loadClient();
  },

  methods: {
    searchData: function searchData() {
      var _this3 = this;

      var options = {
        params: { cycleID: this.cycleId }
      };
      this.reportService.request('GET', 'cycle-consolidated', null, options).then(function (response) {
        _this3.totalCycle = response.data.hour;
        _this3.used = response.data.used;
        _this3.balance = response.data.balance;
        _this3.loading = false;
        _this3.dataEmpty = false;
        _this3.loadDataChart();
      });
    },
    loadClient: function loadClient() {
      var _this4 = this;

      this.clientService.query().then(function (data) {
        _this4.clients = data;
        if (_this4.clients.length === 0) {
          _this4.showAlert = true;
        }
      });
    },
    loadDataChart: function loadDataChart() {
      this.showDataTableHistory();
      this.chartData = {
        columns: ['name', 'value'],
        rows: [{ name: 'Horas Utilizadas', value: this.used }, { name: 'Saldo de Horas', value: this.balanceNegative() }]
      };
    },
    balanceNegative: function balanceNegative() {
      var hour = this.totalCycle * 60;
      var balance = void 0;
      this.isBalanceNegative = false;
      if (!this.used) {
        balance = hour;
      } else if (this.used && this.used < hour) {
        balance = hour - this.used;
      } else if (this.used && this.used > hour) {
        balance = 0;
        this.isBalanceNegative = true;
      } else {
        balance = this.balance;
      }
      return balance;
    },
    reset: function reset() {
      this.totalCycle = null;
      this.used = null;
      this.balance = null;
      this.cycles = null;
      this.cycleId = null;
      this.chartData = {};
    },
    resetClearIconCb: function resetClearIconCb() {
      this.reset();

      this.client = null;
    },
    convertMinutesToHours: function convertMinutesToHours(value) {
      var hourAndMinutes = '00:00';
      if (value) {
        var hours = Math.floor(value / 60).toString().padStart(2, '0');
        var minutes = (value % 60).toString().padStart(2, '0');
        hourAndMinutes = hours + ':' + minutes;
      }
      return hourAndMinutes;
    },
    setClassBalance: function setClassBalance() {
      var klass = 'card-border';
      if (!this.balance || this.isBalanceNegative) {
        klass = klass + ' error--text';
      } else {
        klass = klass + ' success--text';
      }
      return klass;
    },
    showDataTableHistory: function showDataTableHistory(callback) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var filter;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = { cycle_id: _this5.cycleId, isReport: true };
                _context.next = 3;
                return _this5.calledSetvice.query(filter);

              case 3:
                _this5.calledHistories = _context.sent;

                if (callback) callback(_this5.calledHistories);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    showDataTableHistoryDialog: function showDataTableHistoryDialog(dataValue) {
      this.$dialog.component(features_report_DataTableDialog, {
        closeWithEsc: false,
        widget: false,
        width: '60%',
        dataValue: dataValue,
        cycleId: this.cycleId
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71753e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/report/CycleConsolidated.vue
var CycleConsolidated_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.clients,"item-text":"name","item-value":"id","hint":"Vincular um cliente a este ciclo","required":"","return-object":"","persistent-hint":"","clearable":"","disabled":_vm.disabledClient || (_vm.clients.length === 0),"no-data-text":"Nenhuma registro encontrado","label":"Selecione um cliente"},on:{"click:clear":_vm.resetClearIconCb},model:{value:(_vm.client),callback:function ($$v) {_vm.client=$$v},expression:"client"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.cycles && _vm.cycles.length > 0)?_c('v-select',{attrs:{"items":_vm.cycles,"item-text":"start_date","item-value":"id","required":"","hint":"Vincular um ciclo a este chamado","label":"Selecione um ciclo","persistent-hint":"","disabled":_vm.cycles && _vm.cycles.length === 0},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.name)+"\n            ")]}},{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('small',[_vm._v(_vm._s(_vm._f("prDate")(data.item.start_date))+" até "+_vm._s(_vm._f("prDate")(data.item.end_date)))])])],1)]]}}]),model:{value:(_vm.cycleId),callback:function ($$v) {_vm.cycleId=$$v},expression:"cycleId"}}):_vm._e()],1)],1),_vm._v(" "),(_vm.totalCycle)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"primary--text card-border"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"full-width"},[_c('div',{staticClass:"headline"},[_vm._v("Horas do Ciclo")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"display-3 text-md-right"},[_vm._v("\n                  "+_vm._s(_vm.totalCycle ? _vm.totalCycle + 'h' : '--')+"\n                ")])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"orange--text card-border"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"full-width"},[_c('div',{staticClass:"headline"},[_vm._v("Horas Utilizadas")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"display-3 text-md-right"},[_vm._v("\n                  "+_vm._s(_vm.used ? _vm.convertMinutesToHours(_vm.used) + 'h' : '--')+"\n                ")])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{class:_vm.setClassBalance()},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"full-width"},[_c('div',{staticClass:"headline"},[_vm._v("Saldo Atual")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"display-3 text-md-right"},[_vm._v("\n                  "+_vm._s(_vm.convertMinutesToHours(_vm.balanceNegative()))+"h\n                ")])],1)])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.calledHistories.length > 0)?_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('data-table-called-history',{attrs:{"data-value":_vm.calledHistories,"cycle-id":_vm.cycleId}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('ve-pie',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings,"legend-visible":false,"loading":_vm.loading,"events":_vm.loadReportDetail}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n            Não existem clientes cadastrados no sistema.\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":(!_vm.totalCycle && _vm.cycles && _vm.cycles.length === 0),"type":"error"}},[_vm._v("\n            Nenhum ciclo cadastrado para este cliente.\n          ")])],1)],1)],1)],1)}
var CycleConsolidated_staticRenderFns = []
var CycleConsolidated_esExports = { render: CycleConsolidated_render, staticRenderFns: CycleConsolidated_staticRenderFns }
/* harmony default export */ var report_CycleConsolidated = (CycleConsolidated_esExports);
// CONCATENATED MODULE: ./src/features/report/CycleConsolidated.vue
function CycleConsolidated_injectStyle (ssrContext) {
  __webpack_require__("SMvC")
}
var CycleConsolidated_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CycleConsolidated___vue_template_functional__ = false
/* styles */
var CycleConsolidated___vue_styles__ = CycleConsolidated_injectStyle
/* scopeId */
var CycleConsolidated___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CycleConsolidated___vue_module_identifier__ = null
var CycleConsolidated_Component = CycleConsolidated_normalizeComponent(
  CycleConsolidated,
  report_CycleConsolidated,
  CycleConsolidated___vue_template_functional__,
  CycleConsolidated___vue_styles__,
  CycleConsolidated___vue_scopeId__,
  CycleConsolidated___vue_module_identifier__
)

/* harmony default export */ var features_report_CycleConsolidated = (CycleConsolidated_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/user-project/UserProjectList.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UserProjectList = ({
  name: 'user-project-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: this.$t('attributes.userProject'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('attributes.projects'),
        sortable: false,
        align: 'left'
      }, {
        text: this.$t('views.fields.actions'),
        sortable: false,
        align: 'rigth'
      }],
      users: []
    };
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = user_UserService;
      this.routerName = 'user-project';
      this.onSearchInit = false;
    },
    fetchUsersWithProjects: function fetchUsersWithProjects() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.service.request('GET', 'get-all-with-projects');

              case 2:
                response = _context.sent;

                _this.users = response.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deleteData: function deleteData(_ref) {
      var _this2 = this;

      var id = _ref.id,
          name = _ref.name;

      this.$dialog.confirm({ title: 'Atenção', content: 'Deseja remover os projetos de ' + name + '?' }).then(function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(response) {
          return regenerator_default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(response.action === 'ok')) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 3;
                  return _this2.service.request('DELETE', 'detach-projects', null, { params: { id: id } });

                case 3:
                  _this2.fetchUsersWithProjects();
                  _this2.$toast.success(_this2.$t('messages.removeSuccess'));

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  beforeMount: function beforeMount() {
    this.fetchUsersWithProjects();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dcffb82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/user-project/UserProjectList.vue
var UserProjectList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[(!_vm.widget)?_c('v-btn',{attrs:{"icon":"","to":{ name: 'user-project-form', params: { id: 'new' }}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.users,"total-items":_vm.totalResources,"pagination":_vm.orderSync,"no-data-text":_vm.noDataAvailable,"hide-actions":true,"loading":_vm.searchLoading},on:{"update:pagination":function($event){_vm.orderSync=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.name)),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(props.item.email))])]),_vm._v(" "),_c('td',[_c('ul',_vm._l((props.item.projects),function(project){return _c('li',{key:("prt_" + (project.id))},[_vm._v("\n                "+_vm._s(project.name)+"\n              ")])}))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":""},on:{"click":function($event){_vm.goToForm(props.item.id)}}},[_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"error"},on:{"click":function($event){_vm.deleteData({
                id: props.item.id,
                name: props.item.name,
              })}}},[_c('v-icon',[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('pr-pagination',{attrs:{"paginator":_vm.paginator}})],1)])}
var UserProjectList_staticRenderFns = []
var UserProjectList_esExports = { render: UserProjectList_render, staticRenderFns: UserProjectList_staticRenderFns }
/* harmony default export */ var user_project_UserProjectList = (UserProjectList_esExports);
// CONCATENATED MODULE: ./src/features/user-project/UserProjectList.vue
var UserProjectList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserProjectList___vue_template_functional__ = false
/* styles */
var UserProjectList___vue_styles__ = null
/* scopeId */
var UserProjectList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserProjectList___vue_module_identifier__ = null
var UserProjectList_Component = UserProjectList_normalizeComponent(
  UserProjectList,
  user_project_UserProjectList,
  UserProjectList___vue_template_functional__,
  UserProjectList___vue_styles__,
  UserProjectList___vue_scopeId__,
  UserProjectList___vue_module_identifier__
)

/* harmony default export */ var features_user_project_UserProjectList = (UserProjectList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/features/user-project/UserProjectForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UserProjectForm = ({
  name: 'project-form',
  mixins: [CrudMixin],
  computed: {
    likesAllProjects: function likesAllProjects() {
      return this.projectsSelected.length === this.projects.length;
    },
    likesSomeProjects: function likesSomeProjects() {
      return this.projectsSelected.length > 0 && !this.likesAllProjects;
    },
    icon: function icon() {
      if (this.likesAllProjects) return 'close';
      if (this.likesSomeProjects) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    }
  },
  watch: {
    user: function user() {
      if (this.user) {
        this.fetchProjects();
      }
    }
  },
  data: function data() {
    return {
      loadingUsers: false,
      searchUsers: null,
      showAlert: false,
      projects: [],
      users: [],
      user: null,
      projectsSelected: [],
      projectService: new project_ProjectService(),
      currentUser: this.$store.state.currentUser
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.fetchUsers();
    this.user = this.users.find(function (item) {
      return item.id === _this.getId();
    });
  },

  methods: {
    initCrud: function initCrud() {
      this.serviceType = user_UserService;
      this.routerName = 'user-project';
      this.componentType = 'FORM';
      this.onSearchInit = false;
    },
    filterUsers: function filterUsers(item, queryText) {
      var textOne = item.name.toLowerCase();
      var textTwo = item.email.toLowerCase();
      var searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    fetchProjects: function fetchProjects() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var params;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {};

                if (!user_UserService.hasProfile(_this2.currentUser, ['master', 'admin', 'analista'])) {
                  params.client_id = _this2.user.client_id;
                }

                _context.next = 4;
                return _this2.projectService.query(params);

              case 4:
                _this2.projects = _context.sent;


                if (_this2.projects.length === 0) {
                  _this2.showAlert = true;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchUsers: function fetchUsers() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.service.query();

              case 2:
                _this3.users = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    toggle: function toggle() {
      var _this4 = this;

      this.$nextTick(function () {
        if (_this4.likesAllProjects) {
          _this4.projectsSelected = [];
        } else {
          _this4.projectsSelected = _this4.projects.slice();
        }
      });
    },
    linkProjectsToUser: function linkProjectsToUser() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.service.request('POST', 'sync-to-projects', {
                  id: _this5.user.id,
                  projectIds: _this5.projectsSelected.map(function (item) {
                    return item.id;
                  })
                });

              case 2:
                response = _context3.sent;

                _this5.$toast.success(response.data);
                _this5.goToList();

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    disabledUserSelect: function disabledUserSelect() {
      var id = this.getId();
      return id !== 'new';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20dbcef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/user-project/UserProjectForm.vue
var UserProjectForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.linkProjectsToUser($event)}}},[_c('pr-box',{attrs:{"title":_vm.titleBox}},[_c('div',{attrs:{"slot":"buttons-header"},slot:"buttons-header"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.users,"filter":_vm.filterUsers,"item-text":"name","item-value":"id","hint":"Selecionar usuário","required":"","return-object":"","persistent-hint":"","clearable":"","disabled":(_vm.users.length === 0 || _vm.disabledUserSelect()),"no-data-text":"Nenhuma registro encontrado","placeholder":"Selecione um usuário para prosseguir","error-messages":_vm.validationErrors.user},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.projects,"item-text":"name","item-value":"id","hint":"Vincular projetos ao usuário selecionado","required":"","return-object":"","persistent-hint":"","clearable":"","multiple":"","chips":"","disabled":(_vm.projects.length === 0 || !_vm.user),"no-data-text":"Nenhuma registro encontrado","placeholder":"Selecione um projeto","error-messages":_vm.validationErrors.projectsSelected},model:{value:(_vm.projectsSelected),callback:function ($$v) {_vm.projectsSelected=$$v},expression:"projectsSelected"}},[_c('template',{slot:"prepend-item"},[_c('v-list-tile',{attrs:{"ripple":""},on:{"click":_vm.toggle}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.projectsSelected.length > 0 ? 'indigo darken-4' : ''}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Selecionar Todos")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})],1)],2)],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.showAlert,"type":"error"}},[_vm._v("\n        Não existem projetos cadastrados no sistema.\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"buttons-footer"},slot:"buttons-footer"},[_c('v-btn',{attrs:{"flat":"","type":"submit","color":"primary","disabled":(_vm.projects.length === 0),"loading":_vm.saveLoading}},[_vm._v("Salvar")])],1)],1)],1)}
var UserProjectForm_staticRenderFns = []
var UserProjectForm_esExports = { render: UserProjectForm_render, staticRenderFns: UserProjectForm_staticRenderFns }
/* harmony default export */ var user_project_UserProjectForm = (UserProjectForm_esExports);
// CONCATENATED MODULE: ./src/features/user-project/UserProjectForm.vue
var UserProjectForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserProjectForm___vue_template_functional__ = false
/* styles */
var UserProjectForm___vue_styles__ = null
/* scopeId */
var UserProjectForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserProjectForm___vue_module_identifier__ = null
var UserProjectForm_Component = UserProjectForm_normalizeComponent(
  UserProjectForm,
  user_project_UserProjectForm,
  UserProjectForm___vue_template_functional__,
  UserProjectForm___vue_styles__,
  UserProjectForm___vue_scopeId__,
  UserProjectForm___vue_module_identifier__
)

/* harmony default export */ var features_user_project_UserProjectForm = (UserProjectForm_Component.exports);

// CONCATENATED MODULE: ./src/router/AuthenticatedRoutes.js











/* harmony default export */ var AuthenticatedRoutes = ([{
  path: 'pofile',
  name: 'profile',
  component: features_user_Profile,
  meta: { requiresAuth: true }
}, {
  path: '',
  name: 'dashboard',
  component: features_dashboard_Dashboard,
  meta: { requiresAuth: true }
}, {
  path: 'called',
  name: 'called-list',
  component: features_called_CalledList,
  meta: { requiresAuth: true }
}, {
  path: 'called/:id',
  name: 'called-form',
  component: features_called_CalledForm,
  meta: { requiresAuth: true }
}, {
  path: 'event',
  name: 'event-list',
  component: features_event_EventList,
  meta: { requiresAuth: true }
}, {
  path: 'event/:id',
  name: 'event-form',
  component: features_event_EventForm,
  meta: { requiresAuth: true }
}, {
  path: 'follow-called/:id',
  name: 'follow-called',
  component: features_follow_called_FollowCalled,
  meta: { requiresAuth: true }
}, {
  path: 'report',
  name: 'cycle-consolidated',
  component: features_report_CycleConsolidated,
  meta: { requiresAuth: true }
}, {
  path: 'user-project',
  name: 'user-project-list',
  component: features_user_project_UserProjectList,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente', 'analista'] }
}, {
  path: 'user-project/:id',
  name: 'user-project-form',
  component: features_user_project_UserProjectForm,
  meta: { requiresAuth: true, requireRoles: ['master', 'admin', 'admin_cliente', 'analista'] }
}]);
// CONCATENATED MODULE: ./src/router/index.js














vue_esm["default"].use(vue_router_esm["a" /* default */]);

// Agrupamento de todas as rotas
// Todas as rotas devem ser registradas com nome
// Estes nomes são utilizados no de/para com os itens de menu
var routes = [{
  path: '',
  name: 'login',
  component: features_auth_Login
}, {
  path: '/password/reset/:token',
  name: 'resetPassword',
  component: features_auth_ResetPassword
}, {
  path: '/app',
  component: components_layout_Main,
  children: [{
    path: 'not-authorized',
    name: 'not-authorized',
    component: features_auth_NotAuthorized
  }].concat(toConsumableArray_default()(AdminRoutes), toConsumableArray_default()(AuthenticatedRoutes))
}];

var router = new vue_router_esm["a" /* default */]({
  routes: routes
});

// em todas as rotas é verificado autenticação e autorização
router.beforeEach(function (to, from, next) {
  // move o scroll para o inicio da tela
  window.scrollTo(0, 0);
  AuthenticationGuard(to, from, next);
  AuthorizationGuard(to, from, next);
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/VueInstanceInject.js




// Propriedades que vão ser injetadas:
//  - na instancia Root do Vue
//  - na instancia dos Dialog
/* harmony default export */ var VueInstanceInject = ({
  i18n: src_i18n,
  store: Store,
  router: src_router
});
// EXTERNAL MODULE: ./src/stylus/main.styl
var main = __webpack_require__("tLfa");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./src/plugins/LogPlugin.js
/**
 * Plugin responsável por centralizar e exibir informações de log
 */
/* harmony default export */ var LogPlugin = ({
  install: function install(Vue) {
    var plugin = {
      debug: function debug(message) {
        for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        // eslint-disable-next-line
        console.info(message, params);
      },
      error: function error(message) {
        for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }

        // eslint-disable-next-line
        console.error(message, params);
      }
    };

    Vue.$log = plugin;
    Vue.prototype.$log = plugin;
  }
});
// CONCATENATED MODULE: ./src/plugins/ToastPlugin.js
/**
 * PLugin responsável pelo controle do component PrToast
 */
/* harmony default export */ var ToastPlugin = ({
  install: function install(Vue) {
    var plugin = new Vue({
      data: function data() {
        return {
          visible: false,
          message: '',
          color: 'default'
        };
      },

      methods: {
        /**
         * Metodo responsavel por exibir o toast.
         * @param {*} message
         */
        show: function show(message) {
          this.hide();
          this.visible = true;
          this.message = message;
        },

        /**
         * Metodo reponsavel por esconder o toast.
         */
        hide: function hide() {
          this.visible = false;
        },

        /**
         * Metodod responsavel por exibir toast de erro.
         * @param {*} message
         */
        error: function error(message) {
          this.color = 'error';
          this.show(message);
        },

        /**
         * Metodod responsavel por exibir toast de info.
         * @param {*} message
         */
        info: function info(message) {
          this.color = 'info';
          this.show(message);
        },

        /**
         * Metodod responsavel por exibir toast de warning.
         * @param {*} message
         */
        warning: function warning(message) {
          this.color = 'warning';
          this.show(message);
        },

        /**
         * Metodod responsavel por exibir toast de sucesso.
         * @param {*} message
         */
        success: function success(message) {
          this.color = 'success';
          this.show(message);
        }
      }
    });

    Vue.$toast = plugin;
    Vue.prototype.$toast = plugin;
  }
});
// CONCATENATED MODULE: ./src/plugins/SpinnerPlugin.js

/**
 * Plugin responsável por controlar a exibição do component PrSpinner
 */
/* harmony default export */ var SpinnerPlugin = ({
  install: function install(Vue) {
    var plugin = new Vue({
      data: function data() {
        return {
          visible: false
        };
      },

      methods: {
        show: function show() {
          this.visible = true;
        },
        hide: function hide() {
          this.visible = false;
        }
      }
    });

    Vue.$spinner = plugin;
    Vue.prototype.$spinner = plugin;
  }
});
// CONCATENATED MODULE: ./src/plugins/dialog/index.js


/**
 * Plugin responsável por injetar o Dialog service na instancia do Vue
 */
/* harmony default export */ var plugins_dialog = ({
  install: function install(Vue) {
    Vue.$dialog = dialog_DialogService;
    Vue.prototype.$dialog = dialog_DialogService;
  }
});
// CONCATENATED MODULE: ./src/plugins/LoadingPlugin.js
/**
  * Plugin responsável por controlar a exibição do component PrLoaderOverlay
 */
/* harmony default export */ var LoadingPlugin = ({
  install: function install(Vue) {
    var plugin = new Vue({
      data: function data() {
        return {
          loader: false
        };
      },

      methods: {
        show: function show() {
          if (this.loader) this.loader.hide();
          this.loader = this.$loading.show();
        },
        hide: function hide() {
          this.loader.hide();
        }
      }
    });

    Vue.$loaderOverlay = plugin;
    Vue.prototype.$loaderOverlay = plugin;
  }
});
// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/util/colors.js
var colors = __webpack_require__("IHMs");
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);

// CONCATENATED MODULE: ./src/Theme.js
// Todas as definições do tema
// Algumas especificas para a biblioteca Vuetify que é utilizada
// outras especificas para áreas internas do sistema, como o caso
// do menu



var baseColors = {
  primary: colors_default.a.blue.darken4,
  secondary: colors_default.a.indigo.base,
  tertiary: colors_default.a.blue.lighten3,
  error: colors_default.a.red.darken3,
  info: colors_default.a.teal.lighten2,
  success: colors_default.a.green.base,
  warning: colors_default.a.amber.accent3
};

baseColors.accent = baseColors.secondary;

/* harmony default export */ var Theme = ({
  baseColors: baseColors,
  menu: {
    bodyClass: 'secondary darken-1',
    headerClass: 'primary',
    activeItemClass: 'tertiary--text',
    darkMode: true
  }
});
// EXTERNAL MODULE: ./node_modules/vue-the-mask/dist/vue-the-mask.js
var vue_the_mask = __webpack_require__("hlPV");
var vue_the_mask_default = /*#__PURE__*/__webpack_require__.n(vue_the_mask);

// EXTERNAL MODULE: ./node_modules/vue-quill-editor/dist/vue-quill-editor.js
var vue_quill_editor = __webpack_require__("G0J2");
var vue_quill_editor_default = /*#__PURE__*/__webpack_require__.n(vue_quill_editor);

// EXTERNAL MODULE: ./node_modules/v-charts/lib/index.js
var v_charts_lib = __webpack_require__("vO7p");
var v_charts_lib_default = /*#__PURE__*/__webpack_require__.n(v_charts_lib);

// EXTERNAL MODULE: ./node_modules/vue-loading-overlay/dist/vue-loading.min.js
var vue_loading_min = __webpack_require__("ZZvs");
var vue_loading_min_default = /*#__PURE__*/__webpack_require__.n(vue_loading_min);

// EXTERNAL MODULE: ./node_modules/tb-skeleton/dist/tb-skeleton.js
var tb_skeleton = __webpack_require__("jA4w");
var tb_skeleton_default = /*#__PURE__*/__webpack_require__.n(tb_skeleton);

// EXTERNAL MODULE: ./node_modules/vue-clipboards/dist/vue-clipboards.es.js
var vue_clipboards_es = __webpack_require__("1f+G");

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.core.css
var quill_core = __webpack_require__("3f40");
var quill_core_default = /*#__PURE__*/__webpack_require__.n(quill_core);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.snow.css
var quill_snow = __webpack_require__("4qOc");
var quill_snow_default = /*#__PURE__*/__webpack_require__.n(quill_snow);

// EXTERNAL MODULE: ./node_modules/quill/dist/quill.bubble.css
var quill_bubble = __webpack_require__("+cgv");
var quill_bubble_default = /*#__PURE__*/__webpack_require__.n(quill_bubble);

// EXTERNAL MODULE: ./node_modules/vue-loading-overlay/dist/vue-loading.css
var vue_loading = __webpack_require__("SYh3");
var vue_loading_default = /*#__PURE__*/__webpack_require__.n(vue_loading);

// EXTERNAL MODULE: ./node_modules/tb-skeleton/dist/skeleton.css
var skeleton = __webpack_require__("SqcR");
var skeleton_default = /*#__PURE__*/__webpack_require__.n(skeleton);

// CONCATENATED MODULE: ./src/plugins/index.js
















// require styles VueQuillEditor








// Centraliza as definições de todos os plugins

vue_esm["default"].prototype.$theme = Theme;
vue_esm["default"].$theme = Theme;

vue_esm["default"].use(LogPlugin);
vue_esm["default"].use(vuetify_default.a, {
  theme: Theme.baseColors,
  options: {
    customProperties: true
  }
});
vue_esm["default"].use(ToastPlugin);
vue_esm["default"].use(SpinnerPlugin);
vue_esm["default"].use(plugins_dialog);
vue_esm["default"].use(LoadingPlugin);
vue_esm["default"].use(vue_the_mask_default.a);
vue_esm["default"].use(vue_quill_editor_default.a);
vue_esm["default"].use(v_charts_lib_default.a);
vue_esm["default"].use(vue_loading_min_default.a, {
  color: '#0D47A1'
});
vue_esm["default"].use(tb_skeleton_default.a);
vue_esm["default"].use(vue_clipboards_es["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/vue2-filters/dist/vue2-filters.js
var vue2_filters = __webpack_require__("OjAt");
var vue2_filters_default = /*#__PURE__*/__webpack_require__.n(vue2_filters);

// CONCATENATED MODULE: ./src/filters/PrDateFilter.js



// Filtro para converter um objeto Date em uma string
// no formato Brasileiro de Data
/* harmony default export */ var PrDateFilter = (function (date, displayDateParam) {
  var display = Config_Global.format.displayDate;

  if (displayDateParam) {
    display = displayDateParam;
  }

  if (date) {
    return moment_default()(String(date), Config_Global.format.parseDateTime).format(display);
  }

  return '--';
});
// CONCATENATED MODULE: ./src/filters/PrTimeFilter.js



/* harmony default export */ var PrTimeFilter = (function (data) {
  if (data) {
    return moment_default()(String(data), Config_Global.format.parseDateTime).format('HH:mm');
  }

  return null;
});
// CONCATENATED MODULE: ./src/filters/TAttrFilter.js


// Filtro para traduzir um atributo de um model
/* harmony default export */ var TAttrFilter = (function (name) {
  var key = 'attributes.' + name;
  var translate = src_i18n.t(key);

  return translate === key ? name : translate;
});
// CONCATENATED MODULE: ./src/filters/PrCnpjFilter.js
// Filtro para aplicar a mascara de cnpj
/* harmony default export */ var PrCnpjFilter = (function (cnpj) {
  var value = cnpj;
  if (value) {
    // Coloca ponto entre o segundo e o terceiro dígitos
    value = value.replace(/^(\d{2})(\d)/, '$1.$2');

    // Coloca ponto entre o quinto e o sexto dígitos
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');

    // Coloca uma barra entre o oitavo e o nono dígitos
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');

    // Coloca um hífen depois do bloco de quatro dígitos
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
  }
  return value;
});
// CONCATENATED MODULE: ./src/filters/ConvertToByte.js
/* harmony default export */ var ConvertToByte = (function (value) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (value === 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(value) / Math.log(1024)), 10);
  var round = Math.round(value / Math.pow(1024, i), 2);
  return round + ' ' + sizes[i];
});
// CONCATENATED MODULE: ./src/filters/index.js











/**
 * Encapsula todos os filtros globais utilizados no sistema
 * Filtros criados e plugins especificos de filtros
 */
vue_esm["default"].filter('prCnpj', PrCnpjFilter);
vue_esm["default"].filter('prDate', PrDateFilter);
vue_esm["default"].filter('prDateTime', PrDateTimeFilter);
vue_esm["default"].filter('prTime', PrTimeFilter);
vue_esm["default"].filter('tAttr', TAttrFilter);
vue_esm["default"].filter('prCurrency', CurrencyFilter);
vue_esm["default"].filter('convertToByte', ConvertToByte);

vue_esm["default"].use(vue2_filters_default.a);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  /**
   * Componente principal da aplicação.
   * Nele fica concentrado os componentes que tem uma única instancia como ex:
   * Toast, Progress Bar
   */
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4180384d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-linear',{staticClass:"spinner",attrs:{"color":"red","indeterminate":true,"active":_vm.$spinner.visible}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('v-snackbar',{staticClass:"toast",attrs:{"timeout":3000,"top":true,"right":true,"color":_vm.$toast.color},model:{value:(_vm.$toast.visible),callback:function ($$v) {_vm.$set(_vm.$toast, "visible", $$v)},expression:"$toast.visible"}},[_c('div',{staticClass:"toast-wrapper"},[_c('span',{staticClass:"toast-message",domProps:{"innerHTML":_vm._s(_vm.$toast.message)}}),_vm._v(" "),_c('v-btn',{staticClass:"toast-btn-close",attrs:{"icon":""},nativeOn:{"click":function($event){_vm.$toast.visible = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1)])],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("bH6m")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PrBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PrBox = ({
  props: {
    title: String,
    color: {
      default: 'primary',
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f01ee8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PrBox.vue
var PrBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[(_vm.title)?_c('v-toolbar',{attrs:{"card":"","dense":"","color":_vm.color,"prominent":"","dark":_vm.$theme.menu.darkMode}},[_c('v-toolbar-title',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("buttons-header")],2):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_vm._t("default")],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._t("buttons-footer")],2)],1)],1)],1)}
var PrBox_staticRenderFns = []
var PrBox_esExports = { render: PrBox_render, staticRenderFns: PrBox_staticRenderFns }
/* harmony default export */ var widgets_PrBox = (PrBox_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PrBox.vue
var PrBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrBox___vue_template_functional__ = false
/* styles */
var PrBox___vue_styles__ = null
/* scopeId */
var PrBox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrBox___vue_module_identifier__ = null
var PrBox_Component = PrBox_normalizeComponent(
  PrBox,
  widgets_PrBox,
  PrBox___vue_template_functional__,
  PrBox___vue_styles__,
  PrBox___vue_scopeId__,
  PrBox___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PrBox = (PrBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PrDate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PrDate = ({
  model: {
    prop: 'parentModel',
    event: 'parentModelChange'
  },
  props: {
    parentModel: {
      required: true
    },
    label: {
      type: String,
      default: 'Data'
    },
    innerFormat: {
      type: String,
      default: Config_Global.format.parseDate
    },
    displayFormat: {
      type: String,
      default: Config_Global.format.displayDate
    },
    displayMask: {
      type: String,
      default: '##/##/####'
    },
    showCurrent: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      date: null,
      menu: false,
      formatedDate: null
    };
  },
  created: function created() {
    if (this.parentModel) {
      this.date = moment_default()(this.parentModel, this.innerFormat).format(this.innerFormat);
    }
  },

  methods: {
    formatToInput: function formatToInput(value) {
      if (value) {
        return moment_default()(value).format(this.displayFormat);
      }

      return null;
    },
    parseToCalendar: function parseToCalendar(value) {
      if (value) {
        return moment_default()(value, this.displayFormat).format(this.innerFormat);
      }

      return null;
    }
  },
  watch: {
    formatedDate: {
      handler: function handler(newValue) {
        if (newValue.length === 10) {
          var date = this.parseToCalendar(newValue);
          if (date && date !== 'Invalid date') {
            this.date = date;
          } else {
            this.formatedDate = '';
            this.date = '';
          }
        }
      },

      deep: true
    },
    date: {
      handler: function handler(newValue, oldValue) {
        if (newValue && newValue.trim().length && newValue !== oldValue) {
          this.formatedDate = this.formatToInput(newValue);
          this.$emit('parentModelChange', newValue);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1c5e00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PrDate.vue
var PrDate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm1":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":true,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.date},on:{"update:returnValue":function($event){_vm.date=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-icon',{staticClass:"fix-icon-position",attrs:{"slot":"activator"},slot:"activator"},[_vm._v("event")]),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-BR","show-current":_vm.showCurrent,"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v(_vm._s(_vm.$t('global.cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu.save(_vm.date)}}},[_vm._v(_vm._s(_vm.$t('global.ok')))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"fix-field-position",attrs:{"xs10":"","sm11":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.displayMask),expression:"displayMask"}],attrs:{"error-messages":_vm.errorMessages,"label":_vm.label},model:{value:(_vm.formatedDate),callback:function ($$v) {_vm.formatedDate=$$v},expression:"formatedDate"}})],1)],1)}
var PrDate_staticRenderFns = []
var PrDate_esExports = { render: PrDate_render, staticRenderFns: PrDate_staticRenderFns }
/* harmony default export */ var widgets_PrDate = (PrDate_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PrDate.vue
function PrDate_injectStyle (ssrContext) {
  __webpack_require__("rV+Q")
}
var PrDate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrDate___vue_template_functional__ = false
/* styles */
var PrDate___vue_styles__ = PrDate_injectStyle
/* scopeId */
var PrDate___vue_scopeId__ = "data-v-1e1c5e00"
/* moduleIdentifier (server only) */
var PrDate___vue_module_identifier__ = null
var PrDate_Component = PrDate_normalizeComponent(
  PrDate,
  widgets_PrDate,
  PrDate___vue_template_functional__,
  PrDate___vue_styles__,
  PrDate___vue_scopeId__,
  PrDate___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PrDate = (PrDate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PrUploadFile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PrUploadFile = ({

  props: {
    imageClass: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'image/png,image/gif,image/jpeg'
    },
    maxSize: {
      type: Number,
      default: 10
    },
    disablePreview: {
      type: Boolean,
      default: false
    },
    avatar: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: String,
      default: '100px'
    },
    imageSize: {
      type: Number,
      default: 200
    },
    defaultPreview: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      file: null,
      preview: null,
      visiblePreview: false
    };
  },
  computed: {
    wrapperStyles: function wrapperStyles() {
      return {
        position: 'relative',
        width: '100%'
      };
    },
    fileInputStyles: function fileInputStyles() {
      return {};
    },
    textInputStyles: function textInputStyles() {
      return {};
    },
    previewImage: function previewImage() {
      return this.preview || this.defaultPreview;
    }
  },

  methods: {
    onChange: function onChange(e) {
      var _this = this;

      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      var file = files[0];
      var size = file.size && file.size / Math.pow(1000, 2);

      // check file max size
      if (size > this.maxSize) {
        this.$emit('size-exceeded', size);
        return;
      }

      // update file
      this.file = file;
      this.$emit('file', file);

      var reader = new FileReader();

      reader.onload = function (val) {
        var dataURI = val.target.result;

        if (dataURI) {
          _this.$emit('load', dataURI);
          _this.preview = dataURI;
        }
      };

      // read blob url from file data
      reader.readAsDataURL(file);
    },
    openBrowserAddFile: function openBrowserAddFile() {
      this.$refs.file.click();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-928c70f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PrUploadFile.vue
var PrUploadFile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-avatar',{directives:[{name:"show",rawName:"v-show",value:(_vm.previewImage && !_vm.disablePreview && _vm.avatar),expression:"previewImage && !disablePreview && avatar"}],staticClass:"grey lighten-4",attrs:{"size":_vm.avatarSize}},[_c('img',{attrs:{"src":_vm.previewImage,"alt":"avatar"}})]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.previewImage && !_vm.disablePreview && !_vm.avatar),expression:"previewImage && !disablePreview && !avatar"}],class:_vm.imageClass,attrs:{"width":_vm.imageSize,"src":_vm.previewImage}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{style:(_vm.wrapperStyles)},[_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},nativeOn:{"click":function($event){return _vm.openBrowserAddFile($event)}}},[_c('span',[_vm._v(" Alterar Imagem ")])]),_vm._v(" "),_c('input',{ref:"file",staticStyle:{"display":"none"},style:(_vm.fileInputStyles),attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onChange}})],1)])],1)}
var PrUploadFile_staticRenderFns = []
var PrUploadFile_esExports = { render: PrUploadFile_render, staticRenderFns: PrUploadFile_staticRenderFns }
/* harmony default export */ var widgets_PrUploadFile = (PrUploadFile_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PrUploadFile.vue
function PrUploadFile_injectStyle (ssrContext) {
  __webpack_require__("HAkv")
}
var PrUploadFile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrUploadFile___vue_template_functional__ = false
/* styles */
var PrUploadFile___vue_styles__ = PrUploadFile_injectStyle
/* scopeId */
var PrUploadFile___vue_scopeId__ = "data-v-928c70f0"
/* moduleIdentifier (server only) */
var PrUploadFile___vue_module_identifier__ = null
var PrUploadFile_Component = PrUploadFile_normalizeComponent(
  PrUploadFile,
  widgets_PrUploadFile,
  PrUploadFile___vue_template_functional__,
  PrUploadFile___vue_styles__,
  PrUploadFile___vue_scopeId__,
  PrUploadFile___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PrUploadFile = (PrUploadFile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PrPagination.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PrPagination = ({
  props: {
    paginator: {
      type: Object
    }
  },
  data: function data() {
    return {
      pageClass: {
        'btn-page': true,
        'hidden-xs-only': true
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd3cfe9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PrPagination.vue
var PrPagination_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"pr-pagination",attrs:{"row":"","justify-end":""}},[(_vm.paginator.numberOfPages > 1)?_c('div',{attrs:{"row":"","justify-end":""}},[_c('v-btn',{staticClass:"btn-page",attrs:{"small":"","flat":"","disabled":_vm.paginator.currentPage === 1},on:{"click":function($event){_vm.paginator.goToPage(1)}}},[_vm._v(_vm._s(_vm.paginator.options.labels.first))]),_vm._v(" "),_c('v-btn',{staticClass:"btn-page",attrs:{"small":"","flat":"","disabled":_vm.paginator.currentPage === 1},on:{"click":function($event){_vm.paginator.previousPage()}}},[_vm._v(_vm._s(_vm.paginator.options.labels.previous))]),_vm._v(" "),_vm._l((_vm.paginator.pages()),function(n){return _c('v-btn',{key:n,class:[{'secondary': n === _vm.paginator.currentPage}, _vm.pageClass],attrs:{"small":"","flat":""},on:{"click":function($event){_vm.paginator.goToPage(n)}}},[_vm._v(_vm._s(n))])}),_vm._v(" "),_c('v-btn',{staticClass:"btn-page",attrs:{"small":"","flat":"","disabled":_vm.paginator.currentPage === _vm.paginator.numberOfPages},on:{"click":function($event){_vm.paginator.nextPage()}}},[_vm._v(_vm._s(_vm.paginator.options.labels.next))]),_vm._v(" "),_c('v-btn',{staticClass:"btn-page",attrs:{"small":"","flat":"","disabled":_vm.paginator.currentPage === _vm.paginator.numberOfPages},on:{"click":function($event){_vm.paginator.goToPage(_vm.paginator.numberOfPages)}}},[_vm._v(_vm._s(_vm.paginator.options.labels.last))])],2):_vm._e(),_vm._v(" "),(_vm.paginator.total > 0)?_c('v-btn',{staticStyle:{"cursor":"default"},attrs:{"small":"","flat":"","disabled":""}},[_vm._v("\n      Total: "+_vm._s(_vm.paginator.total)+" registro(s)\n    ")]):_vm._e()],1)}
var PrPagination_staticRenderFns = []
var PrPagination_esExports = { render: PrPagination_render, staticRenderFns: PrPagination_staticRenderFns }
/* harmony default export */ var widgets_PrPagination = (PrPagination_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PrPagination.vue
function PrPagination_injectStyle (ssrContext) {
  __webpack_require__("c4RS")
}
var PrPagination_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrPagination___vue_template_functional__ = false
/* styles */
var PrPagination___vue_styles__ = PrPagination_injectStyle
/* scopeId */
var PrPagination___vue_scopeId__ = "data-v-2bd3cfe9"
/* moduleIdentifier (server only) */
var PrPagination___vue_module_identifier__ = null
var PrPagination_Component = PrPagination_normalizeComponent(
  PrPagination,
  widgets_PrPagination,
  PrPagination___vue_template_functional__,
  PrPagination___vue_styles__,
  PrPagination___vue_scopeId__,
  PrPagination___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PrPagination = (PrPagination_Component.exports);

// EXTERNAL MODULE: ./node_modules/cleave.js/dist/cleave.js
var cleave = __webpack_require__("sJdk");
var cleave_default = /*#__PURE__*/__webpack_require__.n(cleave);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PrInputMask.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PrInputMask = ({
  props: {
    value: {
      default: null,
      required: true,
      validator: function validator(value) {
        return value === null || typeof value === 'string' || value instanceof String || typeof value === 'number';
      }
    },
    // https://github.com/nosir/cleave.js/blob/master/doc/options.md
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // Set this prop to false to emit masked value
    raw: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: 'Data'
    },
    counter: {
      type: Number,
      default: null
    },
    errorMessages: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // cleave.js instance
      cleave: null,
      formatedValue: null
    };
  },
  mounted: function mounted() {
    /* istanbul ignore if */
    if (this.cleave) return;
    var input = this.$el.querySelector('input');
    this.cleave = new cleave_default.a(input, this.options);
    this.cleave.setRawValue(this.value);
  },

  methods: {
    /**
     * Watch for value changed by cleave and notify parent component
     * Note: we have to wait for DOM to get updated by cleave.js in order to get final value
     *
     * @param event
     */
    onInput: function onInput(event) {
      var _this = this;

      this.$nextTick(function () {
        var value = _this.raw ? _this.cleave.getRawValue() : event.target.value;
        _this.$emit('input', value);
      });
    }
  },
  watch: {
    /**
     * Watch for any changes in options and redraw
     *
     * @param newOptions Object
     */
    options: {
      deep: true,
      handler: function handler(newOptions) {
        this.cleave.destroy();
        var input = this.$el.querySelector('input');
        this.cleave = new cleave_default.a(input, newOptions);
        this.cleave.setRawValue(this.value);
      }
    },
    /**
     * Watch for changes from parent component and notify cleave instance
     *
     * @param newValue
     */
    value: function value(newValue) {
      if (this.cleave) {
        this.cleave.setRawValue(newValue);
        this.formatedValue = this.cleave.getFormattedValue();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Free up memory
    /* istanbul ignore else */
    if (this.cleave) {
      this.cleave.destroy();
      this.cleave = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0712811e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PrInputMask.vue
var PrInputMask_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"type":_vm.type,"error-messages":_vm.errorMessages,"label":_vm.label,"counter":_vm.counter},on:{"input":_vm.onInput},model:{value:(_vm.formatedValue),callback:function ($$v) {_vm.formatedValue=$$v},expression:"formatedValue"}})}
var PrInputMask_staticRenderFns = []
var PrInputMask_esExports = { render: PrInputMask_render, staticRenderFns: PrInputMask_staticRenderFns }
/* harmony default export */ var widgets_PrInputMask = (PrInputMask_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PrInputMask.vue
var PrInputMask_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrInputMask___vue_template_functional__ = false
/* styles */
var PrInputMask___vue_styles__ = null
/* scopeId */
var PrInputMask___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrInputMask___vue_module_identifier__ = null
var PrInputMask_Component = PrInputMask_normalizeComponent(
  PrInputMask,
  widgets_PrInputMask,
  PrInputMask___vue_template_functional__,
  PrInputMask___vue_styles__,
  PrInputMask___vue_scopeId__,
  PrInputMask___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PrInputMask = (PrInputMask_Component.exports);

// CONCATENATED MODULE: ./src/components/widgets/PrMoneyDirective.js



var PrMoneyDirective_defaults = {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2
};

function PrMoneyDirective_assign(defaultsParam, extrasParam) {
  var def = defaultsParam || {};
  var extras = extrasParam || {};
  return keys_default()(def).concat(keys_default()(extras)).reduce(function (acc, val) {
    acc[val] = extras[val] === undefined ? PrMoneyDirective_defaults[val] : extras[val];
    return acc;
  }, {});
}

/* harmony default export */ var PrMoneyDirective = (function (element, binding) {
  var el = element.querySelector('input');

  if (!binding.value) return;
  var opt = PrMoneyDirective_assign(PrMoneyDirective_defaults, binding.value);

  // v-money used on a component that's not a input
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      throw new Error('v-money requires 1 input, found ' + els.length);
    } else {
      el = els[0];
    }
  }

  el.oninput = function () {
    var positionFromEnd = el.value.length - el.selectionEnd;
    el.value = format(el.value, opt);
    positionFromEnd = Math.max(positionFromEnd, opt.suffix.length); // right
    positionFromEnd = el.value.length - positionFromEnd;
    positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1); // left
    setCursor(el, positionFromEnd);
    el.dispatchEvent(PrMoneyUtilFormat_event('change')); // v-model.lazy
  };

  el.onfocus = function () {
    setCursor(el, el.value.length - opt.suffix.length);
  };

  el.oninput();

  setTimeout(function () {
    el.dispatchEvent(PrMoneyUtilFormat_event('input'));
  }, 100);
});


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/widgets/PrInputMoney.vue
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var PrInputMoney = ({

  props: {
    value: {
      required: true,
      type: [Number, String],
      default: ''
    },
    masked: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: function _default() {
        return PrMoneyDirective_defaults.precision;
      }
    },
    decimal: {
      type: String,
      default: function _default() {
        return PrMoneyDirective_defaults.decimal;
      }
    },
    thousands: {
      type: String,
      default: function _default() {
        return PrMoneyDirective_defaults.thousands;
      }
    },
    prefix: {
      type: String,
      default: function _default() {
        return PrMoneyDirective_defaults.prefix;
      }
    },
    suffix: {
      type: String,
      default: function _default() {
        return PrMoneyDirective_defaults.suffix;
      }
    },
    label: {
      type: String,
      default: 'Data'
    },
    errorMessages: {
      default: function _default() {
        return [];
      }
    }
  },
  directives: { money: PrMoneyDirective },
  data: function data() {
    return {
      formattedValue: '',
      increment: 0
    };
  },
  mounted: function mounted() {
    this.formattedValue = this.value;
  },

  watch: {
    value: {
      handler: function handler(newValue) {
        var formatted = format(newValue, this.$props);
        if (formatted !== this.formattedValue) {
          this.formattedValue = formatted;
        }
      }
    }
  },
  methods: {
    onInput: function onInput(evt) {
      this.$emit('input', this.masked ? evt : unformat(evt, this.precision));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d94688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/PrInputMoney.vue
var PrInputMoney_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"money",rawName:"v-money",value:({precision: _vm.precision, decimal: _vm.decimal, thousands: _vm.thousands, prefix: _vm.prefix, suffix: _vm.suffix}),expression:"{precision, decimal, thousands, prefix, suffix}"}],attrs:{"error-messages":_vm.errorMessages,"label":_vm.label},on:{"input":_vm.onInput},model:{value:(_vm.formattedValue),callback:function ($$v) {_vm.formattedValue=$$v},expression:"formattedValue"}})}
var PrInputMoney_staticRenderFns = []
var PrInputMoney_esExports = { render: PrInputMoney_render, staticRenderFns: PrInputMoney_staticRenderFns }
/* harmony default export */ var widgets_PrInputMoney = (PrInputMoney_esExports);
// CONCATENATED MODULE: ./src/components/widgets/PrInputMoney.vue
var PrInputMoney_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PrInputMoney___vue_template_functional__ = false
/* styles */
var PrInputMoney___vue_styles__ = null
/* scopeId */
var PrInputMoney___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrInputMoney___vue_module_identifier__ = null
var PrInputMoney_Component = PrInputMoney_normalizeComponent(
  PrInputMoney,
  widgets_PrInputMoney,
  PrInputMoney___vue_template_functional__,
  PrInputMoney___vue_styles__,
  PrInputMoney___vue_scopeId__,
  PrInputMoney___vue_module_identifier__
)

/* harmony default export */ var components_widgets_PrInputMoney = (PrInputMoney_Component.exports);

// CONCATENATED MODULE: ./src/components/widgets/index.js










vue_esm["default"].component('pr-box', components_widgets_PrBox);
vue_esm["default"].component('pr-date', components_widgets_PrDate);
vue_esm["default"].component('pr-upload-file', components_widgets_PrUploadFile);
vue_esm["default"].component('pr-pagination', components_widgets_PrPagination);
vue_esm["default"].component('pr-input-mask', components_widgets_PrInputMask);
vue_esm["default"].component('pr-input-money', components_widgets_PrInputMoney);
vue_esm["default"].use(vue_the_mask_default.a);
// CONCATENATED MODULE: ./src/interceptors/LoadingInterceptor.js




// Interceptor responsável por Exibir e esconder
// o spinner em todas requisições AJAX
axios_default.a.interceptors.request.use(function (config) {
  vue_esm["default"].$spinner.show();
  vue_esm["default"].$loaderOverlay.show();
  return config;
});

axios_default.a.interceptors.response.use(function (response) {
  vue_esm["default"].$spinner.hide();
  vue_esm["default"].$loaderOverlay.hide();
  return response;
}, function (error) {
  vue_esm["default"].$spinner.hide();
  vue_esm["default"].$loaderOverlay.hide();
  return promise_default.a.reject(error);
});
// CONCATENATED MODULE: ./src/interceptors/TokenInterceptor.js








/**
 * Função responsável por atualizar o token no store com base
 * no que vem na resposta da requisição
 * @param {Resposta da requisição} response
 */
function refreshToken(response) {
  if (response.headers.authorization) {
    var token = response.headers.authorization;

    Store.commit(UPDATE_TOKEN, token.split(' ')[1]);
  }
}

/**
 * Função responsável por verificar e tratar erros na
 * requisição devirados de problema com o token
 * @param {Resposta da requisição} response
 */
function checkAndTraitTokenError(response) {
  var responseData = response.data;

  if (responseData.error && responseData.error.startsWith('token_')) {
    Store.dispatch('logout');
    dialog_DialogService.close();
    src_router.replace('/');

    return true;
  }

  // verifica se foi gerado um novo token, mesmo no caso de uma requisição com erro
  refreshToken(response);

  return false;
}

// Este interceptor é responsável por cuidar de todo o tratamento para envio e recebimento do token
axios_default.a.interceptors.request.use(function (config) {
  var token = Store.state.token;

  if (token) {
    config.headers = assign_default()({}, config.headers, { Authorization: 'Bearer ' + token });
  }

  return config;
});

axios_default.a.interceptors.response.use(function (response) {
  refreshToken(response);

  return response;
}, function (error) {
  // verifica se tem algum erro de token somente se tiver um response
  // algumas requisições não chegam a complemetar e com isso não geram um response
  if (error.response && checkAndTraitTokenError(error.response)) {
    var errorData = {
      error: 'messages.login.logoutInactive'
    };

    // Se der erro de token substitui a chave de erro específca de token para uma
    // gerénica de usário inativo
    return promise_default.a.reject(assign_default()({}, error, { response: { data: errorData } }));
  }

  return promise_default.a.reject(error);
});
// CONCATENATED MODULE: ./src/interceptors/ValidationInterceptor.js







// Interceptor responsável por tratar as requisições que tenham
// erro devido algum validação de negócio

axios_default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && typeof_default()(error.response.data) === 'object') {
    // Object with attribute error with key i18n { error: 'error.nameOfError' }
    if (error.response.data.error) {
      vue_esm["default"].$toast.error(src_i18n.t(error.response.data.error));
    } else {
      // Array
      var errorsValidation = Object(lodash["map"])(error.response.data, function (item) {
        return item;
      });

      vue_esm["default"].$toast.error(errorsValidation.join('<br/>'));
    }
  } else if (error.response && error.response.headers['content-type'] === 'text/html; charset=UTF-8' && error.response.headers['pr-development-detail-error']) {
    var newWindow = window.open(null, '_blank', 'resizable=yes');
    newWindow.document.write(error.response.data);
    newWindow.document.close();
  } else {
    vue_esm["default"].$toast.error('Serviço indisponível');
  }

  return promise_default.a.reject(error);
});
// CONCATENATED MODULE: ./src/interceptors/index.js




// Encapsula todos os interceptors de requisições AJAX
// CONCATENATED MODULE: ./src/Main.js

/* eslint-disable no-new */














vue_esm["default"].config.productionTip = false;

// Caso precise injetar algo na instancia root do Vue
// utilize o arquivo @/vue-instance-inject
new vue_esm["default"](extends_default()({
  el: '#app'
}, VueInstanceInject, {
  template: '<v-app><App/></v-app>',
  components: { App: src_App }
}));

// eslint-disable-next-line


/***/ }),

/***/ "moTl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMeG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rV+Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "txop":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vCkZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["lJKH"]);


// WEBPACK FOOTER //
// static/js/app.9c2e16ea3253c49cab0f.js